export const turtleTeachHtmlFooter = `<!DOCTYPE html><!--  Last Published: Fri Jul 14 2023 14:04:43 GMT+0000 (Coordinated Universal Time)  -->
<html data-wf-page="64302c0277cdc239073907d9" data-wf-site="63311ecceafed5876e7d5d49" lang="en">
<head><style>
.w-layout-grid {
  grid-row-gap: 16px;
  grid-column-gap: 16px;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  display: grid;
}

.w-pagination-wrapper {
  flex-wrap: wrap;
  justify-content: center;
  display: flex;
}

.w-pagination-previous, .w-pagination-next {
  color: #333;
  background-color: #fafafa;
  border: 1px solid #ccc;
  border-radius: 2px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 9px 20px;
  font-size: 14px;
  display: block;
}

.w-users-userformpagewrap {
  height: 100vh;
  max-width: 340px;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  margin-left: auto;
  margin-right: auto;
  display: flex;
}

.w-users-userformheader {
  text-align: center;
}

.w-commerce-commercecheckoutformcontainer {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
}

.w-commerce-commercelayoutcontainer {
  justify-content: center;
  align-items: flex-start;
  display: flex;
}

.w-commerce-commercelayoutmain {
  flex: 0 800px;
  margin-right: 20px;
}

.w-commerce-commercecheckoutorderitemswrapper {
  margin-bottom: 20px;
}

.w-commerce-commercecheckoutsummaryblockheader {
  background-color: #fff;
  border: 1px solid #e6e6e6;
  justify-content: space-between;
  align-items: baseline;
  padding: 4px 20px;
  display: flex;
}

.w-commerce-commercecheckoutblockcontent {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
  padding: 20px;
}

.w-commerce-commercecheckoutorderitemslist {
  margin-bottom: -20px;
}

.w-commerce-commercecheckoutorderitem {
  margin-bottom: 20px;
  display: flex;
}

.w-commerce-commercecartitemimage {
  width: 60px;
  height: 0%;
}

.w-commerce-commercecheckoutorderitemdescriptionwrapper {
  flex-grow: 1;
  margin-left: 16px;
  margin-right: 16px;
}

.w-commerce-commerceboldtextblock {
  font-weight: 700;
}

.w-commerce-commercecheckoutorderitemquantitywrapper {
  white-space: pre-wrap;
  display: flex;
}

.w-commerce-commercecheckoutorderitemoptionlist {
  margin-bottom: 0;
  padding-left: 0;
  text-decoration: none;
  list-style-type: none;
}

.w-commerce-commercecartapplepaybutton {
  color: #fff;
  cursor: pointer;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  height: 38px;
  min-height: 30px;
  background-color: #000;
  border-width: 0;
  border-radius: 2px;
  align-items: center;
  margin-bottom: 8px;
  padding: 0;
  text-decoration: none;
  display: flex;
}

.w-commerce-commercecartapplepayicon {
  width: 100%;
  height: 50%;
  min-height: 20px;
}

.w-commerce-commercecartquickcheckoutbutton {
  color: #fff;
  cursor: pointer;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  height: 38px;
  background-color: #000;
  border-width: 0;
  border-radius: 2px;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
  padding: 0 15px;
  text-decoration: none;
  display: flex;
}

.w-commerce-commercequickcheckoutgoogleicon, .w-commerce-commercequickcheckoutmicrosofticon {
  margin-right: 8px;
  display: block;
}

.w-commerce-commercecheckoutcustomerinfowrapper {
  margin-bottom: 20px;
}

.w-commerce-commercecheckoutblockheader {
  background-color: #fff;
  border: 1px solid #e6e6e6;
  justify-content: space-between;
  align-items: baseline;
  padding: 4px 20px;
  display: flex;
}

.w-commerce-commercecheckoutlabel {
  margin-bottom: 8px;
}

.w-commerce-commercecheckoutemailinput {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 0;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutemailinput::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutemailinput::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutemailinput:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutadditionalinputscontainer {
  margin-bottom: 20px;
}

.w-commerce-commercecheckoutadditionaltextinput {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutadditionaltextinput::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutadditionaltextinput::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutadditionaltextinput:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutadditionaltextarea {
  height: 76px;
  width: 100%;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
}

.w-commerce-commercecheckoutadditionaltextarea::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutadditionaltextarea::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutadditionaltextarea:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutadditionalcheckboxwrapper {
  flex-direction: row;
  align-items: center;
  display: flex;
}

.w-commerce-commercecheckoutadditionalcheckbox {
  margin-right: 8px;
}

.w-commerce-commercecheckoutshippingaddresswrapper {
  margin-bottom: 20px;
}

.w-commerce-commercecheckoutshippingfullname {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutshippingfullname::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutshippingfullname::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutshippingfullname:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutshippingstreetaddress {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutshippingstreetaddress::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutshippingstreetaddress::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutshippingstreetaddress:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutshippingstreetaddressoptional {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutshippingstreetaddressoptional::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutshippingstreetaddressoptional::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutshippingstreetaddressoptional:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutrow {
  margin-left: -8px;
  margin-right: -8px;
  display: flex;
}

.w-commerce-commercecheckoutcolumn {
  flex: 1;
  padding-left: 8px;
  padding-right: 8px;
}

.w-commerce-commercecheckoutshippingcity {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutshippingcity::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutshippingcity::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutshippingcity:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutshippingstateprovince {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutshippingstateprovince::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutshippingstateprovince::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutshippingstateprovince:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutshippingzippostalcode {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutshippingzippostalcode::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutshippingzippostalcode::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutshippingzippostalcode:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutshippingcountryselector {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 0;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutshippingcountryselector::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutshippingcountryselector::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutshippingcountryselector:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutshippingmethodswrapper {
  margin-bottom: 20px;
}

.w-commerce-commercecheckoutshippingmethodslist {
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
}

.w-commerce-commercecheckoutshippingmethoditem {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  flex-direction: row;
  align-items: baseline;
  margin-bottom: 0;
  padding: 16px;
  font-weight: 400;
  display: flex;
}

.w-commerce-commercecheckoutshippingmethoddescriptionblock {
  flex-direction: column;
  flex-grow: 1;
  margin-left: 12px;
  margin-right: 12px;
  display: flex;
}

.w-commerce-commercecheckoutshippingmethodsemptystate {
  text-align: center;
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
  padding: 64px 16px;
}

.w-commerce-commercecheckoutpaymentinfowrapper {
  margin-bottom: 20px;
}

.w-commerce-commercecheckoutcardnumber {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  cursor: text;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutcardnumber::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutcardnumber::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutcardnumber:focus, .w-commerce-commercecheckoutcardnumber.-wfp-focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutcardsecuritycode {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  cursor: text;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutcardsecuritycode::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutcardsecuritycode::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutcardsecuritycode:focus, .w-commerce-commercecheckoutcardsecuritycode.-wfp-focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutcardexpirationdate {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  cursor: text;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutcardexpirationdate::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutcardexpirationdate::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutcardexpirationdate:focus, .w-commerce-commercecheckoutcardexpirationdate.-wfp-focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutbillingaddresstogglewrapper {
  flex-direction: row;
  display: flex;
}

.w-commerce-commercecheckoutbillingaddresstogglecheckbox {
  margin-top: 4px;
}

.w-commerce-commercecheckoutbillingaddresstogglelabel {
  margin-left: 8px;
  font-weight: 400;
}

.w-commerce-commercecheckoutbillingaddresswrapper {
  margin-top: 16px;
  margin-bottom: 20px;
}

.w-commerce-commercecheckoutbillingfullname {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutbillingfullname::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutbillingfullname::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutbillingfullname:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutbillingstreetaddress {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutbillingstreetaddress::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutbillingstreetaddress::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutbillingstreetaddress:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutbillingstreetaddressoptional {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutbillingstreetaddressoptional::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutbillingstreetaddressoptional::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutbillingstreetaddressoptional:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutbillingcity {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutbillingcity::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutbillingcity::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutbillingcity:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutbillingstateprovince {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutbillingstateprovince::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutbillingstateprovince::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutbillingstateprovince:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutbillingzippostalcode {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 16px;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutbillingzippostalcode::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutbillingzippostalcode::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutbillingzippostalcode:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutbillingcountryselector {
  height: 38px;
  width: 100%;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 0;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutbillingcountryselector::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutbillingcountryselector::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutbillingcountryselector:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercelayoutsidebar {
  flex: 0 0 320px;
  position: -webkit-sticky;
  position: sticky;
  top: 20px;
}

.w-commerce-commercecheckoutordersummarywrapper {
  margin-bottom: 20px;
}

.w-commerce-commercecheckoutsummarylineitem, .w-commerce-commercecheckoutordersummaryextraitemslistitem {
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 8px;
  display: flex;
}

.w-commerce-commercecheckoutsummarytotal {
  font-weight: 700;
}

.w-commerce-commercecheckoutdiscounts {
  background-color: #fff;
  border: 1px solid #e6e6e6;
  flex-wrap: wrap;
  padding: 20px;
  display: flex;
}

.w-commerce-commercecheckoutdiscountslabel {
  flex-basis: 100%;
  margin-bottom: 8px;
}

.w-commerce-commercecheckoutdiscountsinput {
  height: 38px;
  width: auto;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  min-width: 0;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  flex: 1;
  margin-bottom: 0;
  padding: 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commercecheckoutdiscountsinput::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commercecheckoutdiscountsinput::placeholder {
  color: #999;
}

.w-commerce-commercecheckoutdiscountsinput:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commercecheckoutdiscountsbutton {
  color: #fff;
  cursor: pointer;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  height: 38px;
  background-color: #3898ec;
  border-width: 0;
  border-radius: 3px;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: center;
  margin-left: 8px;
  padding: 9px 15px;
  text-decoration: none;
  display: flex;
}

.w-commerce-commercecheckoutplaceorderbutton {
  color: #fff;
  cursor: pointer;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  text-align: center;
  background-color: #3898ec;
  border-width: 0;
  border-radius: 3px;
  align-items: center;
  margin-bottom: 20px;
  padding: 9px 15px;
  text-decoration: none;
  display: block;
}

.w-commerce-commercecheckouterrorstate {
  background-color: #ffdede;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 10px 16px;
}

.w-form-formrecaptcha {
  margin-bottom: 8px;
}

.w-commerce-commerceaddtocartform {
  margin: 0 0 15px;
}

.w-commerce-commerceaddtocartquantityinput {
  height: 38px;
  width: 60px;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 3px;
  margin-bottom: 10px;
  padding: 8px 6px 8px 12px;
  line-height: 20px;
  display: block;
}

.w-commerce-commerceaddtocartquantityinput::-ms-input-placeholder {
  color: #999;
}

.w-commerce-commerceaddtocartquantityinput::placeholder {
  color: #999;
}

.w-commerce-commerceaddtocartquantityinput:focus {
  border-color: #3898ec;
  outline-style: none;
}

.w-commerce-commerceaddtocartbutton {
  color: #fff;
  cursor: pointer;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #3898ec;
  border-width: 0;
  border-radius: 0;
  align-items: center;
  padding: 9px 15px;
  text-decoration: none;
  display: flex;
}

.w-commerce-commerceaddtocartbutton.w--ecommerce-add-to-cart-disabled {
  color: #666;
  cursor: not-allowed;
  background-color: #e6e6e6;
  border-color: #e6e6e6;
  outline-style: none;
}

.w-commerce-commercebuynowbutton {
  color: #fff;
  cursor: pointer;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: #3898ec;
  border-width: 0;
  border-radius: 0;
  align-items: center;
  margin-top: 10px;
  padding: 9px 15px;
  text-decoration: none;
  display: inline-block;
}

.w-commerce-commercebuynowbutton.w--ecommerce-buy-now-disabled {
  color: #666;
  cursor: not-allowed;
  background-color: #e6e6e6;
  border-color: #e6e6e6;
  outline-style: none;
}

.w-commerce-commerceaddtocartoutofstock {
  background-color: #ddd;
  margin-top: 10px;
  padding: 10px;
}

.w-commerce-commerceaddtocarterror {
  background-color: #ffdede;
  margin-top: 10px;
  padding: 10px;
}

.w-users-userloginformwrapper {
  margin-bottom: 0;
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
}

.w-users-userformbutton {
  width: 100%;
  text-align: center;
}

.w-users-userformfooter {
  justify-content: space-between;
  margin-top: 12px;
  display: flex;
}

.w-users-userformerrorstate {
  margin-left: 20px;
  margin-right: 20px;
  position: absolute;
  top: 100%;
  left: 0%;
  right: 0%;
}

.w-commerce-commerceorderconfirmationcontainer {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
}

.w-commerce-commercecheckoutcustomerinfosummarywrapper {
  margin-bottom: 20px;
}

.w-commerce-commercecheckoutsummaryitem, .w-commerce-commercecheckoutsummarylabel {
  margin-bottom: 8px;
}

.w-commerce-commercecheckoutsummaryflexboxdiv {
  flex-direction: row;
  justify-content: flex-start;
  display: flex;
}

.w-commerce-commercecheckoutsummarytextspacingondiv {
  margin-right: .33em;
}

.w-commerce-commercecheckoutshippingsummarywrapper, .w-commerce-commercecheckoutpaymentsummarywrapper {
  margin-bottom: 20px;
}

.w-commerce-commercelabel {
  margin-top: 20px;
  margin-bottom: 8px;
}

.w-commerce-commercepaypalcheckoutformcontainer {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
}

.w-commerce-commercepaypalcheckouterrorstate {
  background-color: #ffdede;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 10px 16px;
}

.w-users-userresetpasswordformwrapper {
  margin-bottom: 0;
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
}

.w-users-userformsuccessstate {
  display: none;
}

.w-users-usersignupformwrapper {
  margin-bottom: 0;
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
}

.w-checkbox {
  margin-bottom: 5px;
  padding-left: 20px;
  display: block;
}

.w-checkbox:before {
  content: " ";
  grid-area: 1 / 1 / 2 / 2;
  display: table;
}

.w-checkbox:after {
  content: " ";
  clear: both;
  grid-area: 1 / 1 / 2 / 2;
  display: table;
}

.w-checkbox-input {
  float: left;
  margin: 4px 0 0 -20px;
  line-height: normal;
}

.w-checkbox-input--inputType-custom {
  width: 12px;
  height: 12px;
  border: 1px solid #ccc;
  border-radius: 2px;
}

.w-checkbox-input--inputType-custom.w--redirected-checked {
  background-color: #3898ec;
  background-image: url('https://d3e54v103j8qbb.cloudfront.net/static/custom-checkbox-checkmark.589d534424.svg');
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  border-color: #3898ec;
}

.w-checkbox-input--inputType-custom.w--redirected-focus {
  box-shadow: 0 0 3px 1px #3898ec;
}

.w-users-usersignupverificationmessage {
  display: none;
}

.w-users-userupdatepasswordformwrapper {
  margin-bottom: 0;
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
}

.w-users-useraccountwrapper {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
}

.w-users-blockheader {
  background-color: #fff;
  border: 1px solid #e6e6e6;
  justify-content: space-between;
  align-items: baseline;
  padding: 4px 20px;
  display: flex;
}

.w-users-blockcontent {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
  border-right: 1px solid #e6e6e6;
  margin-bottom: 20px;
  padding: 20px;
}

.w-users-useraccountformsavebutton {
  text-align: center;
  margin-right: 8px;
}

.w-users-useraccountformcancelbutton {
  text-align: center;
  color: #333;
  background-color: #d3d3d3;
}

.w-users-useraccountsubscriptionlist {
  -webkit-overflow-scrolling: touch;
  flex: 1;
  overflow: auto;
}

.w-users-useraccountsubscriptionlistitem {
  align-items: flex-start;
  display: flex;
}

.w-commerce-commercecartiteminfo {
  flex-direction: column;
  flex: 1;
  margin-left: 16px;
  margin-right: 16px;
  display: flex;
}

.w-commerce-commercecartproductname {
  font-weight: 700;
}

.w-users-gridrow {
  grid-column-gap: 8px;
  grid-template-columns: auto auto;
  justify-content: flex-start;
  display: grid;
}

.w-users-flexcolumn {
  flex-direction: column;
  display: flex;
}

.w-users-useraccountsubscriptioncancelbutton {
  color: #3898ec;
  cursor: pointer;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background-color: rgba(0, 0, 0, 0);
  padding: 0;
}

@media screen and (max-width: 767px) {
  .w-commerce-commercelayoutcontainer {
    flex-direction: column;
    align-items: stretch;
  }

  .w-commerce-commercelayoutmain {
    flex-basis: auto;
    margin-right: 0;
  }

  .w-commerce-commercelayoutsidebar {
    flex-basis: auto;
  }
}

@media screen and (max-width: 479px) {
  .w-commerce-commercecheckoutemailinput, .w-commerce-commercecheckoutadditionaltextinput, .w-commerce-commercecheckoutadditionaltextarea, .w-commerce-commercecheckoutshippingfullname, .w-commerce-commercecheckoutshippingstreetaddress, .w-commerce-commercecheckoutshippingstreetaddressoptional {
    font-size: 16px;
  }

  .w-commerce-commercecheckoutrow {
    flex-direction: column;
  }

  .w-commerce-commercecheckoutshippingcity, .w-commerce-commercecheckoutshippingstateprovince, .w-commerce-commercecheckoutshippingzippostalcode, .w-commerce-commercecheckoutshippingcountryselector, .w-commerce-commercecheckoutcardnumber, .w-commerce-commercecheckoutcardsecuritycode, .w-commerce-commercecheckoutcardexpirationdate, .w-commerce-commercecheckoutbillingfullname, .w-commerce-commercecheckoutbillingstreetaddress, .w-commerce-commercecheckoutbillingstreetaddressoptional, .w-commerce-commercecheckoutbillingcity, .w-commerce-commercecheckoutbillingstateprovince, .w-commerce-commercecheckoutbillingzippostalcode, .w-commerce-commercecheckoutbillingcountryselector, .w-commerce-commercecheckoutdiscountsinput, .w-commerce-commerceaddtocartquantityinput {
    font-size: 16px;
  }
}

body {
  color: #212127;
  background-color: #fffbf6;
  font-family: sofia-pro-soft, sans-serif;
  font-size: 14px;
  line-height: 20px;
}

h1 {
  color: #5a4522;
  margin-top: 64px;
  margin-bottom: 32px;
  font-size: 38px;
  font-weight: 500;
  line-height: 44px;
}

h2 {
  color: #5a4522;
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 32px;
  font-weight: 400;
  line-height: 36px;
}

h3 {
  color: #5a4522;
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
}

h4 {
  color: #5a4522;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
}

h5 {
  color: #5a4522;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

h6 {
  color: #5a4522;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
}

p {
  color: #5a4522;
  margin-bottom: 10px;
  font-weight: 500;
}

a {
  color: #5a4522;
  text-decoration: underline;
}

li {
  color: #5a4522;
  list-style-type: disc;
}

img {
  max-width: 100%;
  display: inline-block;
}

figure {
  margin-top: 30px;
  margin-bottom: 10px;
}

.page-content {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: block;
  overflow: hidden;
}

.banner {
  height: 850px;
  padding: 0 30px;
  position: relative;
}

.banner.sub {
  z-index: 1;
  height: auto;
  background-color: rgba(0, 0, 0, 0);
  flex-direction: column;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  position: relative;
}

.banner.sub.school-order {
  height: auto;
  background-color: #30a1f2;
  flex-direction: column;
  padding-top: 40px;
}

.banner.sub.distributor {
  height: 150px;
  background-color: #fcbe4b;
  padding-top: 40px;
  position: static;
}

.banner.sub.career {
  flex-direction: column;
}

.section {
  background-color: #fffbf6;
  padding: 32px 16px;
}

.section.less-space {
  border-top: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
  padding-top: 60px;
  padding-bottom: 60px;
  display: none;
}

.section.school-order {
  background-color: #30a1f2;
}

.section.distributor {
  background-color: #fcbe4b;
}

.container {
  max-width: 1200px;
}

.container.center {
  z-index: 1;
  text-align: left;
  padding-left: 64px;
  padding-right: 64px;
  position: relative;
  top: 50%;
  transform: translate(0, -50%);
}

.navbar {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 15px;
}

.nav-menu {
  float: none;
  text-align: center;
  flex-wrap: nowrap;
  align-content: flex-start;
  justify-content: flex-end;
  align-items: center;
  display: flex;
}

.brand {
  float: left;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
}

.top-banner {
  text-align: center;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
}

.nav-link {
  color: #5a4522;
  align-self: flex-end;
  padding-right: 20px;
  font-family: Inter, sans-serif;
  font-weight: 400;
  display: inline-block;
}

.nav-link:hover {
  color: #29c0e7;
}

.nav-link.w--current {
  color: #ffa800;
}

.nav-link.dropdown {
  z-index: 1;
  float: left;
}

.nav-link.in-footer {
  color: #fff;
  padding-right: 32px;
  font-size: 24px;
  line-height: 150%;
  text-decoration: none;
}

.nav-link.in-footer:hover {
  text-decoration: underline;
}

.nav-link.in-footer.disabled {
  color: #777;
}

.nav-link.disabled {
  color: #dbdbdb;
}

.logo-title {
  color: #919197;
  margin-bottom: 0;
  margin-left: 10px;
}

.cart-button {
  width: 45px;
  height: 45px;
  color: #212127;
  background-color: #29c0e7;
  border-radius: 999px;
  justify-content: center;
  align-items: center;
  padding: 0;
  display: none;
}

.cat-text {
  color: #919197;
  font-weight: 500;
}

.cart {
  width: 24px;
  height: 24px;
  align-self: center;
}

.top-icon-flex {
  justify-content: center;
  align-items: center;
  margin-left: 20px;
  display: flex;
}

.top-icon-flex.no-space {
  width: 150px;
  max-width: 150px;
  grid-column-gap: 4px;
  grid-row-gap: 16px;
  order: 0;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  align-content: stretch;
  justify-content: center;
  align-self: center;
  justify-items: center;
  margin-left: 0;
  display: grid;
}

.top-icon-flex._5px-space {
  margin-left: 5px;
}

.top-text {
  margin-bottom: 0;
  margin-left: 10px;
}

.top-text.white-text {
  color: #fff;
  margin-left: 0;
  margin-right: 10px;
  font-size: 15px;
  font-style: italic;
}

.div-block {
  justify-content: space-between;
  align-items: center;
  display: flex;
}

.banner-second {
  height: 100%;
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
}

.banner-second.normal {
  z-index: 0;
  background-image: none;
  justify-content: center;
  align-items: center;
  padding-top: 0;
  display: flex;
  position: relative;
}

.banner-second.normal.school-order {
  height: auto;
  max-width: 1200px;
  align-self: center;
  display: flex;
}

.banner-second.normal.career {
  max-width: 1200px;
  flex-flow: column;
  align-content: stretch;
  justify-content: center;
  align-self: center;
  align-items: center;
  display: flex;
  position: relative;
}

.banner-second.normal.distributor {
  max-width: 1200px;
  align-self: center;
  padding-top: 20px;
  display: block;
  position: relative;
}

.icon {
  margin-top: 24px;
  margin-right: 5px;
  font-size: 12px;
}

.dropdown-list {
  margin-top: 0;
}

.dropdown-list.w--open {
  background-color: #fff;
  margin-top: 60px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.collection-list {
  background-color: #fff;
}

.dropdown-link {
  width: 100%;
  color: #919197;
  background-color: #fff;
  padding: 10px 20px;
  font-size: 13px;
  line-height: 18px;
  text-decoration: none;
  display: inline-block;
}

.dropdown-link:hover {
  color: #212127;
}

.dropdown-link.no-left-padding {
  color: #947849;
  background-color: #fffbf6;
  padding-left: 0;
}

.dropdown-link.no-left-padding.biger {
  padding-top: 0;
  padding-bottom: 0;
  font-size: 15px;
}

.top-title {
  text-align: center;
  margin-bottom: 32px;
}

.top-title-text {
  color: #f05023;
  text-align: center;
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  font-family: Inter, sans-serif;
  font-size: 30px;
  font-weight: 700;
  display: block;
}

.top-title-text.school-order {
  color: #fff;
  border-radius: 8px;
}

.top-title-text.school-order.form-section {
  text-align: left;
  margin-top: 20px;
  margin-bottom: 20px;
}

.top-title-text.school-order.form-result {
  margin-top: 40px;
  margin-bottom: 10px;
}

.top-title-text.distributor {
  color: #533d18;
}

.top-title-text.distributor.form-section {
  text-align: left;
  margin-top: 20px;
  margin-bottom: 20px;
}

.top-title-text.distributor.subtitle {
  max-width: 1200px;
  font-size: 20px;
  font-weight: 400;
}

.top-title-text.job-posting {
  color: #533d18;
}

.top-title-text.job-posting.form-section {
  text-align: left;
  margin-top: 20px;
  margin-bottom: 20px;
}

.top-title-text.job-posting.subtitle {
  font-size: 20px;
}

.top-title-text.job-posting.subtitle.left-aligned {
  text-align: left;
}

.top-title-text.form-section {
  text-align: left;
  margin-top: 30px;
  margin-bottom: 20px;
  font-weight: 400;
}

.divider {
  width: 50px;
  height: 1px;
  background-color: #000;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.margin-page {
  margin-top: 120px;
}

.logo-wrapper {
  justify-content: space-between;
  display: flex;
}

.client-logo {
  cursor: default;
  padding: 0 45px;
}

.align-center {
  z-index: 3;
  width: 100%;
  text-align: left;
  padding-top: 140px;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: auto;
  right: 0%;
}

.heading-banner {
  width: 90%;
  color: #fff;
  text-align: right;
  justify-content: flex-start;
  margin: 0 40px 30px auto;
  font-family: Inter, sans-serif;
  font-size: 40px;
  font-weight: 700;
  line-height: 70px;
  display: block;
}

.heading-banner.smaller {
  width: auto;
  color: #5a4522;
  text-align: center;
  margin-bottom: 0;
  margin-right: auto;
  padding-left: 0;
  padding-right: 0;
  font-size: 50px;
  line-height: 125%;
}

.heading-banner.smaller.faq {
  margin-bottom: 0;
  margin-right: auto;
  padding-left: 0;
  padding-right: 0;
}

.heading-banner.smaller.career {
  color: #f05023;
  padding-top: 20px;
  padding-bottom: 20px;
}

.heading-banner.smaller {
  color: #5a4522;
  text-align: center;
  padding-left: 32px;
  padding-right: 32px;
  font-size: 50px;
  line-height: 125%;
}

.heading-banner.smaller.shop {
  color: #f05023;
  position: static;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.heading-banner.smaller.school-order {
  height: auto;
  color: #fff;
  padding-top: 20px;
  padding-bottom: 20px;
}

.heading-banner.smaller.product {
  color: #f05023;
}

.heading-banner.smaller.distributor {
  color: #533d18;
  padding-top: 20px;
  padding-bottom: 20px;
}

.top-margin {
  margin-top: 40px;
  display: block;
}

.top-margin.main-page {
  z-index: 10;
  width: 90%;
  text-align: right;
  object-fit: fill;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  margin-top: 0;
  margin-left: auto;
  margin-right: 40px;
  display: block;
  position: relative;
  overflow: visible;
}

.button {
  color: #212127;
  background-color: #212127;
  padding: 15px 20px;
}

.button:hover {
  background-color: #3e3e49;
}

.button.white {
  width: 250px;
  max-width: 100%;
  color: #fff;
  text-align: center;
  background-color: #ffa800;
  border-radius: 999px;
  justify-content: center;
  margin-top: 0;
  font-size: 20px;
  line-height: 150%;
}

.button.white:hover {
  background-color: #db9000;
}

.button.white.dark {
  color: #212127;
  background-color: #fff;
}

.button.white.full {
  width: 100%;
  text-align: center;
  display: block;
}

.button.white.main-page {
  z-index: 5;
  width: 180px;
  color: #fff;
  -webkit-text-fill-color: inherit;
  background-color: #f05023;
  background-clip: border-box;
  margin-right: 0;
  font-family: Inter, sans-serif;
  position: relative;
}

.button.white.main-page.hero {
  -webkit-backface-visibility: visible;
  backface-visibility: visible;
  perspective: none;
  transform-origin: 50%;
  color: #f05023;
  mix-blend-mode: normal;
  background-color: #fff;
  font-family: Inter, sans-serif;
  position: relative;
  transform: none;
}

.button.white.main-page.hero._3d {
  transition: transform .2s cubic-bezier(.55, .085, .68, .53), margin .1s cubic-bezier(.55, .085, .68, .53), box-shadow .1s cubic-bezier(.55, .085, .68, .53);
  position: relative;
  box-shadow: 0 6px #cacaca;
}

.button.white.main-page.hero._3d:hover {
  transform: scale(1.1);
}

.button.white.main-page.hero._3d:active {
  margin-top: 6px;
  margin-bottom: -6px;
  top: auto;
  left: auto;
  transform: translate(0)scale(1.1);
  box-shadow: 0 0 #cacaca;
}

.button.white.main-page.hero._3d.pressed {
  box-shadow: none;
  display: none;
}

.button.white.main-page.best-seller {
  width: 120px;
  object-fit: fill;
  flex: 0 auto;
  align-self: auto;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  font-family: Inter, sans-serif;
  position: static;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
  overflow: visible;
}

.button.white.main-page.best-seller._3d {
  transition: box-shadow .1s cubic-bezier(.55, .085, .68, .53), transform .2s cubic-bezier(.55, .085, .68, .53), margin .1s cubic-bezier(.55, .085, .68, .53);
  box-shadow: 0 6px #cf431c;
}

.button.white.main-page.best-seller._3d:hover {
  transform: scale(1.1);
}

.button.white.main-page.best-seller._3d:active {
  margin-top: 6px;
  margin-bottom: -6px;
  box-shadow: 0 0 #cf431c;
}

.button.white.main-page.buy-now {
  width: 120px;
  margin-top: 40px;
}

.button.white.main-page.feature {
  margin-top: 73px;
  font-family: Inter, sans-serif;
  position: static;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.button.white.main-page.feature._3d {
  margin-top: 107px;
  transition: box-shadow .1s cubic-bezier(.55, .085, .68, .53), margin .1s cubic-bezier(.55, .085, .68, .53), transform .2s cubic-bezier(.55, .085, .68, .53);
  position: static;
  box-shadow: 0 6px #cf431c;
}

.button.white.main-page.feature._3d:hover {
  transform: scale(1.1);
}

.button.white.main-page.feature._3d:active {
  margin-top: 113px;
  margin-bottom: -6px;
  box-shadow: 0 0 #cf431c;
}

.button.white.main-page.school {
  display: block;
  position: relative;
  top: 93px;
}

.button.white.main-page.cookie-kiddle-feature {
  margin-top: 0;
  font-family: Inter, sans-serif;
  position: relative;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.button.white.main-page.cookie-kiddle-feature._3d {
  z-index: 9;
  margin-bottom: 0;
  transition: bottom .1s cubic-bezier(.55, .085, .68, .53), box-shadow .1s cubic-bezier(.55, .085, .68, .53), margin .1s cubic-bezier(.55, .085, .68, .53), transform .2s cubic-bezier(.55, .085, .68, .53);
  position: relative;
  box-shadow: 0 6px #cf431c;
}

.button.white.main-page.cookie-kiddle-feature._3d:hover {
  margin-top: 0;
  margin-bottom: 0;
  transform: scale(1.1);
}

.button.white.main-page.cookie-kiddle-feature._3d:active {
  margin-top: 6px;
  margin-bottom: -6px;
  bottom: -6px;
  box-shadow: 0 0 #cf431c;
}

.button.white.main-page.cookie-kiddle-feature._3d.product-page {
  top: 42px;
}

.button.white.main-page.pearson-feature {
  margin-top: 0;
  font-family: Inter, sans-serif;
  position: relative;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.button.white.main-page.pearson-feature._3d {
  margin-bottom: 0;
  transition: bottom .1s cubic-bezier(.55, .085, .68, .53), box-shadow .1s cubic-bezier(.55, .085, .68, .53), margin .1s cubic-bezier(.55, .085, .68, .53), transform .2s cubic-bezier(.55, .085, .68, .53);
  position: relative;
  box-shadow: 0 6px #cf431c;
}

.button.white.main-page.pearson-feature._3d:hover {
  margin-top: 0;
  margin-bottom: 0;
  transform: scale(1.1);
}

.button.white.main-page.pearson-feature._3d:active {
  margin-top: 6px;
  margin-bottom: -6px;
  bottom: 0%;
  box-shadow: 0 0 #cf431c;
}

.button.white.main-page.school {
  margin-top: 73px;
  font-family: Inter, sans-serif;
  position: static;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.button.white.main-page.school._3d {
  flex: 0 auto;
  margin-top: 107px;
  margin-bottom: 0;
  transition: box-shadow .1s cubic-bezier(.55, .085, .68, .53), margin .1s cubic-bezier(.55, .085, .68, .53), transform .2s cubic-bezier(.55, .085, .68, .53);
  position: static;
  box-shadow: 0 6px #cf431c;
}

.button.white.main-page.school._3d:hover {
  transform: scale(1.1);
}

.button.white.main-page.school._3d:active {
  margin-top: 113px;
  margin-bottom: -6px;
  box-shadow: 0 0 #cf431c;
}

.button.white.main-page.turtle-teach {
  margin-top: 73px;
  font-family: Inter, sans-serif;
  position: static;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.button.white.main-page.turtle-teach._3d {
  width: 250px;
  margin-top: 0;
  transition: box-shadow .1s cubic-bezier(.55, .085, .68, .53), margin .1s cubic-bezier(.55, .085, .68, .53), transform .2s cubic-bezier(.55, .085, .68, .53);
  position: relative;
  bottom: 32%;
  left: 5%;
  box-shadow: 0 6px #cf431c;
}

.button.white.main-page.turtle-teach._3d:hover {
  transform: scale(1.1);
}

.button.white.main-page.turtle-teach._3d:active {
  margin-top: 6px;
  margin-bottom: -6px;
  box-shadow: 0 0 #cf431c;
}

.button.white.main-page.turtle-teach._3d.form-submit {
  left: 0%;
}

.button.white._3d {
  transition: box-shadow .1s cubic-bezier(.55, .085, .68, .53), transform .2s cubic-bezier(.55, .085, .68, .53), margin .1s cubic-bezier(.55, .085, .68, .53);
  box-shadow: 0 6px #cf8900;
}

.button.white._3d:hover {
  transform: scale(1.1);
}

.button.white._3d:active {
  margin-top: 6px;
  margin-bottom: -6px;
  box-shadow: 0 0 #cf8900;
}

.button.white._3d.school-order:hover {
  background-color: #ffa800;
}

.button.white.distributor {
  z-index: 5;
  width: 180px;
  color: #fff;
  -webkit-text-fill-color: inherit;
  background-color: #f05023;
  background-clip: border-box;
  margin-right: 0;
  font-family: Inter, sans-serif;
  position: relative;
}

.button.white.distributor.hero {
  -webkit-backface-visibility: visible;
  backface-visibility: visible;
  perspective: none;
  transform-origin: 50%;
  color: #f05023;
  mix-blend-mode: normal;
  background-color: #fff;
  font-family: Inter, sans-serif;
  position: relative;
  transform: none;
}

.button.white.distributor.hero._3d {
  transition: transform .2s cubic-bezier(.55, .085, .68, .53), margin .1s cubic-bezier(.55, .085, .68, .53), box-shadow .1s cubic-bezier(.55, .085, .68, .53);
  position: relative;
  box-shadow: 0 6px #cacaca;
}

.button.white.distributor.hero._3d:hover {
  transform: scale(1.1);
}

.button.white.distributor.hero._3d:active {
  margin-top: 6px;
  margin-bottom: -6px;
  top: auto;
  left: auto;
  transform: translate(0)scale(1.1);
  box-shadow: 0 0 #cacaca;
}

.button.white.distributor.hero._3d.pressed {
  box-shadow: none;
  display: none;
}

.button.white.distributor.best-seller {
  width: 120px;
  object-fit: fill;
  flex: 0 auto;
  align-self: auto;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  font-family: Inter, sans-serif;
  position: static;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
  overflow: visible;
}

.button.white.distributor.best-seller._3d {
  transition: box-shadow .1s cubic-bezier(.55, .085, .68, .53), transform .2s cubic-bezier(.55, .085, .68, .53), margin .1s cubic-bezier(.55, .085, .68, .53);
  box-shadow: 0 6px #cf431c;
}

.button.white.distributor.best-seller._3d:hover {
  transform: scale(1.1);
}

.button.white.distributor.best-seller._3d:active {
  margin-top: 6px;
  margin-bottom: -6px;
  box-shadow: 0 0 #cf431c;
}

.button.white.distributor.buy-now {
  width: 120px;
  margin-top: 40px;
}

.button.white.distributor.feature {
  margin-top: 73px;
  font-family: Inter, sans-serif;
  position: static;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.button.white.distributor.feature._3d {
  transition: box-shadow .1s cubic-bezier(.55, .085, .68, .53), margin .1s cubic-bezier(.55, .085, .68, .53), transform .2s cubic-bezier(.55, .085, .68, .53);
  position: static;
  box-shadow: 0 6px #cf431c;
}

.button.white.distributor.feature._3d:hover {
  transform: scale(1.1);
}

.button.white.distributor.feature._3d:active {
  margin-top: 79px;
  margin-bottom: -6px;
  box-shadow: 0 0 #cf431c;
}

.button.white.distributor.school {
  display: none;
}

.button.white.distributor.cookie-kiddle-feature {
  margin-top: 0;
  font-family: Inter, sans-serif;
  position: relative;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.button.white.distributor.cookie-kiddle-feature._3d {
  margin-bottom: 0;
  transition: bottom .1s cubic-bezier(.55, .085, .68, .53), box-shadow .1s cubic-bezier(.55, .085, .68, .53), margin .1s cubic-bezier(.55, .085, .68, .53), transform .2s cubic-bezier(.55, .085, .68, .53);
  position: relative;
  box-shadow: 0 6px #cf431c;
}

.button.white.distributor.cookie-kiddle-feature._3d:hover {
  margin-top: 0;
  margin-bottom: 0;
  transform: scale(1.1);
}

.button.white.distributor.cookie-kiddle-feature._3d:active {
  margin-top: 6px;
  margin-bottom: -6px;
  bottom: -6px;
  box-shadow: 0 0 #cf431c;
}

.button.white.distributor.pearson-feature {
  margin-top: 0;
  font-family: Inter, sans-serif;
  position: relative;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.button.white.distributor.pearson-feature._3d {
  margin-bottom: 0;
  transition: bottom .1s cubic-bezier(.55, .085, .68, .53), box-shadow .1s cubic-bezier(.55, .085, .68, .53), margin .1s cubic-bezier(.55, .085, .68, .53), transform .2s cubic-bezier(.55, .085, .68, .53);
  position: relative;
  box-shadow: 0 6px #cf431c;
}

.button.white.distributor.pearson-feature._3d:hover {
  margin-top: 0;
  margin-bottom: 0;
  transform: scale(1.1);
}

.button.white.distributor.pearson-feature._3d:active {
  margin-top: 6px;
  margin-bottom: -6px;
  bottom: 0%;
  box-shadow: 0 0 #cf431c;
}

.button.white.distributor._3d {
  box-shadow: 0 6px #cf431c;
}

.button.white.distributor._3d:active {
  box-shadow: 0 0 #cf431c;
}

.footer {
  height: 418px;
  background-color: #fff;
  padding: 0;
}

.subscribe-flex {
  justify-content: center;
  align-items: center;
  display: flex;
}

.subscribe-text {
  margin-bottom: 0;
  margin-right: 20px;
  font-size: 17px;
  font-style: italic;
}

.form-block {
  width: 400px;
  margin-bottom: 0;
}

.text-field {
  width: 65%;
  height: 50px;
  float: left;
  border-style: solid none solid solid;
  border-top-width: 1px;
  border-top-color: #ededed;
  border-bottom-width: 1px;
  border-bottom-color: #ededed;
  border-left-width: 1px;
  border-left-color: #ededed;
  margin-bottom: 0;
}

.text-field.full {
  width: 100%;
  height: 40px;
  float: none;
  color: #5a4522;
  background-color: #fffbf6;
  border: 1px #000;
  border-bottom: 1px solid rgba(185, 156, 0, .3);
  border-radius: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.text-field.full::-ms-input-placeholder {
  color: #667085;
}

.text-field.full::placeholder {
  color: #667085;
}

.text-field.full.area {
  height: auto;
  padding-bottom: 90px;
}

.text-field.full.area.bottom {
  border-bottom-style: none;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
}

.text-field.full.add-space {
  margin-top: 15px;
  margin-bottom: 5px;
}

.text-field.full.top {
  height: 40px;
  border-style: solid;
  border-color: #000;
  border-radius: 5px;
  margin-bottom: 0;
  padding-left: 12px;
}

.text-field.full.top::-ms-input-placeholder {
  color: #667085;
}

.text-field.full.top::placeholder {
  color: #667085;
}

.text-field.full.top.left {
  border-top-right-radius: 0;
}

.text-field.full.top.right {
  border-top-left-radius: 0;
}

.text-field.full.middle {
  color: #5a4522;
  border-bottom-style: none;
  padding-left: 12px;
}

.text-field.full.bottom {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

.text-field.full.bottom.left {
  border-bottom-right-radius: 0;
}

.text-field.full.bottom.right {
  border-bottom-left-radius: 0;
}

.text-field.full.standalone {
  border-radius: 8px;
}

.submit-button {
  width: 35%;
  height: 50px;
  float: left;
  background-color: #212127;
  padding-left: 20px;
  padding-right: 20px;
  font-family: Poppins;
  font-weight: 500;
}

.submit-button:hover {
  background-color: #414147;
}

.submit-button.normal {
  width: 128px;
  height: 48px;
  max-width: 100%;
  float: none;
  text-align: center;
  background-color: #307fe2;
  border-radius: 16px;
  padding-top: 0;
  padding-bottom: 0;
  font-family: Sofia pro soft;
}

.submit-button.normal.center {
  text-align: center;
  justify-content: center;
}

.product-wrapper {
  height: 100%;
  min-height: 450px;
  color: #212127;
  text-align: center;
  align-self: auto;
  text-decoration: none;
  position: relative;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: 0%;
}

.product-wrapper.with-padding {
  padding-left: 20px;
  padding-right: 20px;
}

.product-wrapper.with-padding.shop {
  min-height: 400px;
  grid-column-gap: 16px;
  grid-row-gap: 0px;
  grid-template-rows: auto auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  align-items: stretch;
  justify-items: stretch;
  display: grid;
  position: relative;
}

.product-image {
  margin-bottom: 0;
  position: static;
}

.price {
  color: #5a4522;
  font-family: Inter, sans-serif;
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
}

.price.slashedprice {
  color: #f9423b;
  font-family: Inter, sans-serif;
  font-size: 16px;
  text-decoration: line-through;
}

.price.buy-now {
  margin-top: -25px;
  font-size: 25px;
}

.flex-row {
  justify-content: center;
  align-items: center;
  display: flex;
}

.flex-row.make-vertical {
  display: none;
}

.footer-left-part {
  justify-content: flex-end;
  display: flex;
}

.footer-left-part.right-now {
  justify-content: flex-start;
}

.social-icon {
  max-width: 50px;
  min-width: 50px;
  margin-right: 10px;
}

.social-icon.hidden {
  display: none;
}

.social-icon.rounded {
  border-radius: 13px;
}

.copyright {
  color: rgba(255, 255, 255, .5);
  margin-bottom: 0;
}

.link-2 {
  color: #fff;
  text-decoration: none;
}

.align-right {
  text-align: right;
}

.stripe-image {
  width: 80px;
  height: 35px;
  opacity: 1;
  background-color: #7a7a7a;
  /* background-image: url('../../../public/asset/images/webflow/white.png'); */
  background-image: url('../../../public/asset/images/webflow/white.png');
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 40px;
  border-radius: 30px;
  display: inline-block;
}

.preloader {
  z-index: 9999;
  width: 100%;
  height: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  background-color: #fff;
  grid-template-rows: minmax(200px, 1fr) auto;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  align-items: center;
  justify-items: stretch;
  display: none;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.top-title-text-2 {
  background-color: #fff;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 20px;
  position: relative;
}

.top-title-text-2.in-left {
  background-color: #fffbf6;
  padding-left: 0;
}

.footer-top-title {
  height: 60px;
  align-items: center;
}

.footer-column {
  width: 90%;
}

.footer-column.add-top-margin {
  margin-top: 40px;
}

.line-title {
  width: 100%;
  height: 1px;
  background-color: #e1e1e1;
  position: absolute;
}

.top-title-2 {
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
  display: flex;
  position: relative;
}

.top-title-2.zero-margin {
  margin-bottom: 0;
}

.top-title-2.zero-margin.left {
  justify-content: flex-start;
}

.collection-list-wrapper {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr 1fr;
}

.success-message {
  color: #fff;
  background-color: rgba(0, 218, 131, .73);
  border-radius: 16px;
  justify-content: center;
  align-items: center;
  display: flex;
}

.error-message {
  color: #9e0000;
  text-align: center;
  border-radius: 16px;
}

.form-block-2 {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.utility-page-wrap {
  width: 100vw;
  height: 100vh;
  max-height: 100%;
  max-width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
}

.utility-page-content {
  width: 500px;
  text-align: center;
  flex-direction: column;
  align-items: center;
  display: flex;
}

.utility-page-form {
  width: 100%;
  flex-direction: column;
  align-items: center;
  display: flex;
}

.cart-order-value {
  font-size: 17px;
  font-weight: 400;
}

.remove-button {
  margin-top: 4px;
}

.text-block {
  color: #818187;
  font-size: 16px;
}

.cart-product-name {
  margin-bottom: 3px;
  font-size: 16px;
  font-weight: 400;
}

.field-label {
  color: #919197;
  font-weight: 400;
}

.right-padding {
  padding-left: 50px;
}

.product-item {
  min-height: 500px;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  flex-direction: column;
  flex: 1;
  order: 0;
  grid-template-rows: minmax(200px, 250px) minmax(150px, 1fr) minmax(57px, 60px) auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  justify-content: flex-end;
  align-self: auto;
  align-items: center;
  justify-items: center;
  margin-bottom: 0;
  display: grid;
}

.product-item.shop {
  grid-template-rows: minmax(450px, 60px) auto;
  align-items: start;
  margin-bottom: 60px;
  position: relative;
}

.menu-button {
  display: none;
}

.cart-container {
  min-width: 420px;
}

.best-seller-collection-wrapper-desktop {
  width: 100%;
  height: 550px;
  text-align: center;
  object-fit: fill;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  display: block;
  position: relative;
}

.rich-text-wrapper {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.link-3 {
  color: #515157;
}

.algin-center {
  text-align: center;
  position: relative;
}

.paragraph-wrapper {
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.button-wrapper {
  text-align: center;
  padding: 40px;
}

.button-wrapper.with-color {
  background-color: #212127;
}

.empty-state {
  text-align: center;
  background-color: #f5f5f7;
}

.checkout-form {
  min-height: auto;
  background-color: rgba(0, 0, 0, 0);
}

.text-block-2 {
  font-size: 20px;
  font-weight: 400;
}

.order-confirmation-container {
  min-height: auto;
  background-color: rgba(0, 0, 0, 0);
}

.cart-quantity {
  height: 18px;
  min-width: 18px;
  color: #fff;
  background-color: #f9423a;
  border-radius: 20px;
  position: absolute;
  top: -4px;
  bottom: auto;
  left: auto;
  right: -4px;
}

.paypal {
  margin-bottom: 5px;
}

.center {
  text-align: center;
}

.discounts {
  margin-top: 20px;
  margin-bottom: 20px;
}

.container-description {
  background-image: linear-gradient(gold, gold);
  border-radius: 32px;
  justify-content: space-around;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 24px;
  display: flex;
}

.container-description.description-2 {
  background-image: linear-gradient(#44d62c, #44d62c);
}

.container-description.description-3 {
  background-image: linear-gradient(#f93822, #f93822);
}

.description-text-container {
  flex-direction: column;
  flex: 1;
  align-self: center;
  margin-top: 16px;
  margin-bottom: 16px;
  padding-right: 32px;
  display: flex;
}

.description-video {
  z-index: 9999;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  flex: 1;
  align-self: center;
  align-items: center;
  display: block;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
  overflow: hidden;
}

.heading-description-heading {
  color: #5a4522;
  margin-top: 0;
  font-weight: 700;
  line-height: 150%;
}

.heading-description-heading.description-2 {
  color: #fffbf6;
  font-size: 32px;
  font-weight: 700;
}

.heading-description-body {
  color: #5a4522;
  font-size: 20px;
  line-height: 150%;
}

.heading-description-body.white-text {
  color: #fffbf6;
}

.body-2 {
  background-color: #fff;
  font-family: sofia-pro-soft, sans-serif;
  font-weight: 400;
  overflow: visible;
}

.section-description {
  padding-left: 16px;
  padding-right: 16px;
}

.nav-bar {
  height: 120px;
  background-color: #fffbf6;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-right: 0;
  padding-right: 0;
  font-size: 20px;
  display: flex;
}

.cart-2 {
  float: right;
  align-self: center;
}

.container-2 {
  width: 900px;
  max-width: 100%;
  flex-direction: row;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  justify-content: flex-start;
  align-self: center;
  align-items: center;
  margin-left: 0;
  margin-right: 0;
  display: flex;
}

.background-video {
  z-index: 12;
  width: 100%;
  height: 100%;
  display: block;
  position: relative;
  top: auto;
  bottom: auto;
  left: auto;
  right: 0%;
}

.product-actual-image {
  height: 250px;
  border-radius: 8px;
}

.heading {
  color: #5a4522;
  font-family: Inter, sans-serif;
  font-weight: 400;
}

.image-2 {
  max-height: 100%;
  object-fit: scale-down;
  position: static;
}

.div-block-2 {
  height: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  justify-content: flex-end;
  align-self: auto;
  align-items: center;
  padding-right: 16px;
  display: flex;
  position: relative;
  top: 50%;
  transform: translate(0, -50%);
}

.top-menu-nav-div {
  align-self: auto;
  display: flex;
}

.top-menu-nav-div.mobile {
  display: none;
}

.form {
  background-color: gold;
  border-radius: 16px;
  padding: 8px;
}

.form.school-order {
  background-color: rgba(0, 0, 0, 0);
}

.div-block-3 {
  text-align: center;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  display: flex;
}

.div-block-4 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.img-social-media {
  width: 32px;
  height: 32px;
  max-width: none;
}

.heading-2 {
  color: #29c0e7;
}

.paragraph {
  color: #5a4522;
}

.rich-text-block {
  text-align: left;
}

.rich-text-block h4 {
  margin-top: 24px;
  margin-bottom: 8px;
  font-weight: 700;
}

.rich-text-about-us figure {
  width: 512px;
  max-width: 100%;
  margin-top: 32px;
  margin-bottom: 32px;
}

.description-video-container {
  border-radius: 8px;
  flex: 1;
  align-self: center;
  position: relative;
}

.slider {
  height: 100%;
  border-radius: 16px;
  margin-bottom: 32px;
  overflow: hidden;
}

.description-image {
  opacity: 0;
  border-radius: 8px;
  flex: 1;
  align-self: center;
  align-items: center;
  display: flex;
  position: relative;
}

.rich-text-block-2 {
  color: #009444;
  text-align: left;
}

.background-video-2 {
  z-index: 9999;
  width: 100%;
  height: 100%;
  position: absolute;
}

.description-image-container {
  border-radius: 8px;
  flex: 1;
  align-self: center;
  align-items: center;
  display: flex;
  position: relative;
}

.div-block-5 {
  width: 90%;
  height: 120px;
  max-width: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  text-align: left;
  flex: 0 auto;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  justify-content: space-around;
  align-self: auto;
  display: flex;
}

.column {
  flex-direction: column;
  align-items: center;
  display: flex;
}

.collection-list-wrapper-4 {
  width: 100%;
  height: auto;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  flex-direction: column;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  justify-content: center;
  align-items: center;
  display: block;
}

.collection-list-2 {
  height: auto;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template: "Area"
  / 1fr 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  grid-auto-flow: row;
  align-content: stretch;
  justify-content: center;
  align-items: center;
  justify-items: center;
  display: grid;
}

.lightbox-link {
  width: 100px;
  height: 100%;
  flex-direction: row;
  margin-left: 8px;
  margin-right: 8px;
  display: block;
}

.image-3 {
  width: 100%;
  height: 100%;
  max-width: none;
  object-fit: cover;
  border-radius: 8px;
  display: inline-block;
  position: relative;
}

.image-4 {
  border-radius: 16px;
}

.main-product-image {
  border-radius: 16px;
  margin-bottom: 32px;
  position: static;
}

.nav-link-language-1 {
  color: #5a4522;
  padding-left: 5px;
  font-size: 14px;
  display: inline-block;
}

.nav-link-language-1:hover {
  color: #29c0e7;
}

.nav-link-language-1.w--current {
  color: #212127;
}

.nav-link-language-1.dropdown {
  z-index: 1;
  float: left;
}

.nav-link-language-1.in-footer {
  color: #fff;
  padding-right: 32px;
  font-size: 18px;
  text-decoration: none;
}

.nav-link-language-1.in-footer:hover {
  text-decoration: underline;
}

.nav-link-language-2 {
  color: #5a4522;
  padding-right: 5px;
  font-size: 14px;
  display: inline-block;
}

.nav-link-language-2:hover {
  color: #29c0e7;
}

.nav-link-language-2.w--current {
  color: #212127;
}

.nav-link-language-2.dropdown {
  z-index: 1;
  float: left;
}

.nav-link-language-2.in-footer {
  color: #fff;
  padding-right: 32px;
  font-size: 18px;
  text-decoration: none;
}

.nav-link-language-2.in-footer:hover {
  text-decoration: underline;
}

.top-menu-nav-lang-div {
  text-align: left;
  display: none;
}

.paragraph-2 {
  width: 60%;
  max-width: 100%;
  color: #fffbf6;
  text-align: right;
  margin-bottom: 30px;
  margin-left: auto;
  margin-right: 40px;
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 150%;
  position: relative;
}

.video-slider {
  z-index: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
}

.video-overlay {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
}

.left-arrow {
  justify-content: center;
  align-items: center;
  display: flex;
}

.image-5 {
  width: 48px;
  display: block;
  position: absolute;
}

.right-arrow {
  align-items: center;
  display: flex;
}

.heroaccolades {
  z-index: 5;
  width: 450px;
  height: 120px;
  max-height: 150px;
  object-fit: fill;
  border: 3px #000;
  border-radius: 0;
  align-items: stretch;
  margin-top: 0;
  display: inline-block;
  position: absolute;
  top: auto;
  bottom: 94px;
  left: auto;
  right: 24px;
  overflow: visible;
}

.heroaccolades.hksda-silver {
  width: 10%;
  bottom: 140px;
}

.image-5-copy {
  width: 48px;
  display: block;
  position: absolute;
}

.brand-2 {
  order: -1;
}

.brand-2.w--current {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  order: -1;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  display: block;
}

.image-7 {
  margin-right: 32px;
}

.main-product-image-2 {
  border-radius: 16px;
  margin-bottom: 32px;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
}

.div-block-7 {
  position: relative;
}

.product-actual-image-variant {
  height: 250px;
  border-radius: 8px;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 50%;
  right: auto;
  transform: translate(-50%);
}

.promo-banner {
  z-index: 999;
  height: 125px;
  background-image: url('https://d3e54v103j8qbb.cloudfront.net/img/background-image.svg');
  background-size: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-left: 32px;
  padding-right: 32px;
  text-decoration: none;
  display: flex;
  position: relative;
}

.text-block-3 {
  color: #fffbf6;
  align-self: center;
  padding-bottom: 8px;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
  text-decoration: none;
}

.text-block-3-copy {
  color: #fffbf6;
  letter-spacing: 2px;
  text-transform: uppercase;
  padding-bottom: 8px;
  font-size: 14px;
  font-weight: 700;
}

.div-block-8 {
  z-index: -1;
  width: 100%;
  height: 100%;
  opacity: 1;
  color: #fff;
  justify-content: center;
  align-items: center;
  display: flex;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: auto;
}

.background-image {
  z-index: -1;
  width: 100%;
  height: 100%;
  opacity: 1;
  background-color: #009444;
  background-image: url('../../../public/asset/images/webflow/banner-v1.0.1.jpg');
  background-position: 50% 100%;
  background-size: contain;
  display: block;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: auto;
}

.div-block-9 {
  flex-direction: column;
  align-items: center;
  margin-right: 32px;
  display: flex;
}

.avilable-for-ipad {
  height: 64px;
  margin-top: 8px;
  margin-bottom: 8px;
}

.text-block-4 {
  color: #fffbf6;
}

.top-menu-div {
  height: 100%;
  flex-direction: row;
  order: 0;
  justify-content: flex-start;
  align-self: auto;
  align-items: center;
  display: flex;
  position: relative;
}

.text-block-5 {
  color: #5a4522;
  text-align: center;
}

.div-block-11 {
  color: #5a4522;
  position: relative;
}

.text-block-6 {
  color: #fff;
  text-align: center;
  align-self: center;
  margin: 16px 32px;
  font-size: 24px;
  line-height: 125%;
}

.div-block-12 {
  z-index: 999;
  width: 100%;
  height: 180px;
  position: relative;
}

.container-3 {
  flex-direction: column;
  justify-content: center;
  margin-bottom: 64px;
  display: flex;
}

.section-title {
  z-index: 1;
  color: #5a4522;
  text-align: center;
  margin-top: 32px;
  margin-bottom: 10px;
  font-family: Inter, sans-serif;
  font-size: 30px;
  font-weight: 700;
  line-height: 32px;
  position: absolute;
  top: -10%;
  bottom: auto;
  left: 0%;
  right: 0%;
}

.section-title.orange {
  z-index: auto;
  color: #f05023;
  margin-top: 50px;
  margin-bottom: 50px;
  font-family: Inter, sans-serif;
  font-size: 30px;
  font-weight: 700;
  position: relative;
  top: 0%;
}

.image-holder {
  justify-content: center;
  align-items: center;
  display: flex;
}

.image-10 {
  max-width: 100%;
  border-radius: 16px;
  margin-left: 24px;
  margin-right: 24px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, .15);
}

.image-11 {
  margin-left: 24px;
  margin-right: 24px;
}

.html-embed {
  text-align: center;
  position: static;
}

.background-image-red {
  z-index: -1;
  width: 100%;
  height: 100%;
  opacity: 1;
  background-color: #d91a1a;
  background-image: url('../../../public/asset/images/webflow/banner-v2.0.0.jpg');
  background-size: contain;
  display: block;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: auto;
}

.image-10-copy, .image-12 {
  border-radius: 16px;
  margin-left: 24px;
  margin-right: 24px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, .15);
}

.grid {
  grid-column-gap: 16px;
  grid-template: "Area"
                 "Area-2"
                 / 1fr;
  margin-bottom: 20px;
}

.div-block-13 {
  display: none;
}

.payment-icon {
  width: 70px;
  height: auto;
  object-fit: contain;
  border-radius: 7px;
}

.payment-methods {
  text-align: right;
  justify-content: flex-end;
  display: flex;
}

.grid-2 {
  max-width: 75%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  align-content: stretch;
  justify-content: stretch;
  display: grid;
}

.section-2 {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  display: grid;
}

.price-copy {
  color: #5a4522;
  font-size: 22px;
  line-height: 30px;
}

.price-copy.slashedprice {
  color: #f9423b;
  font-size: 16px;
  text-decoration: line-through;
}

.grid-3 {
  width: 80%;
  height: 100%;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  align-content: stretch;
  justify-content: stretch;
  align-items: center;
  justify-items: center;
  margin-top: -57px;
}

.school-logos {
  max-height: 150px;
  max-width: 150px;
}

.column-2 {
  justify-content: flex-end;
  display: flex;
}

.school-logos-2 {
  max-height: 150px;
  max-width: 220px;
}

.div-block-14 {
  height: 20px;
}

.supple-materials-text {
  text-align: center;
  flex-flow: row;
  order: 0;
  justify-content: center;
  align-self: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 16px;
  display: block;
}

.supple-icon {
  max-width: 50%;
}

.column-3 {
  display: block;
}

.image-14, .image-15 {
  max-width: 50%;
}

.column-4 {
  flex-flow: column;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  justify-content: center;
  align-items: center;
  display: block;
  position: relative;
}

.grid-4 {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-rows: auto;
  grid-template-columns: .25fr 1fr .25fr;
  grid-auto-columns: 1fr;
  grid-auto-flow: row;
  display: grid;
}

.image-16 {
  line-height: 20px;
}

.grid-5 {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  justify-items: stretch;
  display: grid;
}

.demo-image {
  border-radius: 20px;
}

.heading-3 {
  color: #ffa800;
  text-align: center;
  display: inline;
  position: static;
}

.heading-4 {
  text-align: center;
  object-fit: fill;
  display: block;
  position: static;
}

.heading-5 {
  color: #ffa800;
}

.grid-6 {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0);
  border-radius: 10px 10px 10px 101px;
  box-shadow: 0 0 0 -20px #000;
}

.cards-section {
  padding-top: 100px;
  padding-bottom: 100px;
}

.centered-container {
  text-align: center;
  flex: 1;
}

.cards-grid-container {
  grid-column-gap: 40px;
  grid-row-gap: 40px;
  text-align: left;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  display: grid;
}

.cards-image-mask {
  border-radius: 0%;
  padding-top: 100%;
  position: relative;
  overflow: hidden;
}

.cards-image {
  width: 100%;
  height: 100%;
  max-width: none;
  object-fit: cover;
  object-position: 50% 50%;
  border-radius: 20px;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.cards-image-2 {
  width: 100%;
  height: 100%;
  max-width: none;
  object-fit: cover;
  object-position: 50% 50%;
  display: inline-block;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: 0%;
  overflow: visible;
}

.heading-6 {
  color: #009444;
  text-align: center;
}

.button-2 {
  background-color: #29c0e7;
}

.demo-buy-button {
  width: 40%;
  height: 100px;
  text-align: center;
  background-color: #ffa800;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-style: normal;
  text-decoration: none;
  display: flex;
  box-shadow: 4px 4px 8px -2px #000;
}

.grid-7 {
  grid-template-rows: auto;
}

.button-3 {
  width: 40%;
  height: 100px;
  text-align: center;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  display: flex;
  position: static;
  box-shadow: 4px 4px 8px -2px #000;
}

.image-17 {
  width: 200px;
  text-align: center;
}

.link-block-3 {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  text-align: center;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  display: block;
}

.image-18 {
  float: none;
  clear: both;
  text-align: left;
  display: block;
  position: static;
}

.herohksda {
  z-index: 5;
  width: 100%;
  height: 100%;
  max-height: 100%;
  max-width: none;
  object-fit: scale-down;
  text-decoration: none;
  display: inline-block;
  position: relative;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: auto;
}

.grid-8 {
  width: 100%;
  grid-column-gap: 0px;
  text-align: left;
  grid-template-rows: auto;
  grid-template-columns: 1.25fr .75fr;
}

.image-20 {
  width: 75%;
  display: inline-block;
}

.image-21 {
  width: 75%;
}

.link-block-4 {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  display: block;
}

.heading-7 {
  text-align: center;
  font-family: Inter, sans-serif;
  font-size: 14px;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 3%;
}

.text-block-8 {
  color: #909191;
  font-size: 10px;
}

.image-22 {
  width: 100px;
}

.retail-logo {
  width: auto;
  max-height: 60%;
  max-width: 80%;
  object-fit: scale-down;
  border-radius: 0;
}

.image-24 {
  max-height: 100px;
  border-radius: 16px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, .15);
}

.div-block-15 {
  height: 20px;
}

.location-text {
  color: #ffa800;
  text-align: center;
  margin-top: 64px;
  margin-bottom: 32px;
  font-size: 32px;
  font-weight: 700;
  line-height: 32px;
}

.language-dropdown {
  align-items: center;
  display: flex;
}

.language-toggle {
  height: 50px;
  text-align: left;
  border: 2px solid #f05023;
  border-radius: 39px;
  flex-direction: row;
  flex: 0 auto;
  justify-content: center;
  align-items: center;
  padding: 10px;
  display: flex;
}

.language-list.w--open {
  min-width: 200px;
  background-color: #fffbf6;
  border: 2px solid #f05023;
  border-radius: 17px;
  flex: 0 auto;
  margin-bottom: 0;
  padding: 8px 16px;
  display: block;
}

.language-link {
  width: 100%;
  min-height: 45px;
  align-items: center;
  text-decoration: none;
  display: flex;
}

.flag-1 {
  width: 25px;
  height: 25px;
  background-image: url('../../../public/asset/images/webflow/hk.svg');
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  margin-right: 14px;
  display: block;
}

.language-link-base {
  position: absolute;
}

.language-link-break {
  height: 1px;
  background-color: #5b3acc;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.flag-1-copy {
  width: 25px;
  height: 25px;
  background-image: url('../../../public/asset/images/webflow/gb.svg');
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  margin-right: 14px;
}

.div-block-16 {
  position: absolute;
}

.text-block-9 {
  text-decoration: none;
}

.text-block-10 {
  font-style: normal;
  text-decoration: none;
}

.text-block-11 {
  color: #f05023;
  justify-content: center;
  align-items: stretch;
  font-family: Inter, sans-serif;
  font-weight: 400;
  display: block;
}

.icon-5 {
  -webkit-text-fill-color: inherit;
  background-color: rgba(0, 0, 0, 0);
  background-clip: border-box;
}

.language-icon {
  width: 25px;
  height: 25px;
  background-image: url('../../../public/asset/images/webflow/language.svg');
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  margin-right: 14px;
  display: block;
}

.language-drop-icon {
  width: 17.25px;
  height: 15px;
  text-align: left;
  background-image: url('../../../public/asset/images/webflow/language_dropdown.svg');
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  flex-flow: row;
  flex: 0 auto;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  margin-right: 0;
  display: flex;
}

.image-26 {
  width: 100%;
}

.herocontainer {
  max-height: 832px;
  max-width: 100%;
  min-height: 832px;
  object-fit: fill;
  object-position: 50% 50%;
  background-color: #f05023;
  border: 1px #fff;
  padding-bottom: 0;
  display: block;
  position: relative;
  overflow: hidden;
}

.herocontainer.cookiekiddle {
  background-color: #29c0e7;
}

.heropattern {
  z-index: 1;
  width: 70%;
  max-height: none;
  max-width: none;
  object-fit: cover;
  object-position: 50% 50%;
  border: 1px #000;
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;
  display: inline-block;
  position: absolute;
  top: 5%;
  bottom: 0%;
  left: auto;
  right: 0%;
  overflow: visible;
}

.herowhitebanner {
  z-index: 0;
  min-width: 100%;
  float: none;
  clear: none;
  outline-offset: 0px;
  object-fit: cover;
  object-position: 50% 100%;
  border: 1px #000;
  border-bottom: 6px #fff;
  outline: 3px #212127;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
  overflow: visible;
}

.herowhitebanner._2 {
  z-index: 2;
  bottom: -1px;
}

.heroorange {
  z-index: 1;
  width: auto;
  height: auto;
  object-fit: fill;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: auto;
  right: 0%;
  overflow: hidden;
}

.herocharacters {
  position: absolute;
  top: auto;
  bottom: 10%;
  left: 0%;
  right: 0%;
}

.youtube {
  width: 9%;
  border-radius: 40px;
  display: block;
}

.column-5 {
  margin-top: 140px;
  padding-top: 1px;
}

.video {
  width: 90%;
  border-radius: 40px;
}

.background-video-3 {
  z-index: 20;
  width: 95%;
  height: 400px;
  max-width: 95%;
  float: none;
  clear: none;
  object-fit: fill;
  border-radius: 80px;
  margin-right: 0;
  padding-right: 0;
  position: relative;
  overflow: auto;
}

.characterdiv2 {
  z-index: 5;
  width: 150px;
  height: 50px;
  grid-column-gap: 0px;
  grid-row-gap: 16px;
  -webkit-text-fill-color: inherit;
  background-color: #38d430;
  background-clip: padding-box;
  border-radius: 10px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  display: grid;
  position: absolute;
  top: auto;
  bottom: 7%;
  left: 59%;
  right: auto;
}

.text-block-12 {
  clear: none;
  color: #fff;
  text-align: center;
  flex-flow: row-reverse;
  flex: 0 auto;
  align-content: flex-end;
  justify-content: center;
  align-items: center;
  margin: auto;
  line-height: 20px;
  display: flex;
  position: relative;
}

.text-block-13 {
  color: #fff;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin: auto;
  font-size: 20px;
  display: flex;
}

.column-6 {
  text-align: center;
  padding-left: 10px;
  padding-right: 20px;
  position: relative;
}

.column-7 {
  text-align: center;
  align-items: stretch;
  padding-left: 20px;
  display: flex;
  position: relative;
}

.columns {
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.characterdiv1 {
  z-index: 5;
  width: 150px;
  height: 50px;
  grid-column-gap: 0px;
  grid-row-gap: 16px;
  background-color: #00b9e3;
  border-radius: 10px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  display: grid;
  position: absolute;
  top: auto;
  bottom: 19%;
  left: 41%;
  right: auto;
}

.characterdiv3 {
  z-index: 5;
  width: 150px;
  height: 50px;
  grid-column-gap: 0px;
  grid-row-gap: 16px;
  -webkit-text-fill-color: inherit;
  background-color: #7e57c5;
  background-clip: padding-box;
  border-radius: 10px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  display: grid;
  position: absolute;
  top: auto;
  bottom: 10%;
  left: 49%;
  right: auto;
}

.column-8 {
  height: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  position: static;
}

.image-27 {
  height: 100%;
  object-fit: scale-down;
  border-radius: 0;
  display: none;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: auto;
  right: 0%;
}

.retail-grid {
  width: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  flex: 1;
  grid-template-rows: minmax(100px, auto);
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-auto-rows: minmax(100px, auto);
  grid-auto-columns: 1fr;
  align-content: stretch;
  justify-content: stretch;
  align-self: center;
  align-items: center;
  justify-items: center;
  margin-bottom: 50px;
  display: grid;
}

.feature-section {
  width: 100%;
  min-height: 700px;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  text-align: left;
  background-color: #fff;
  flex-direction: column;
  grid-template-rows: auto auto auto;
  grid-template-columns: 50%;
  grid-auto-columns: 1fr;
  justify-content: center;
  align-items: center;
  justify-items: start;
  margin-bottom: auto;
  margin-left: auto;
  margin-right: auto;
  padding-top: 100px;
  padding-bottom: 133px;
  padding-left: 40px;
  display: flex;
  position: relative;
}

.feature-video {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
  position: absolute;
}

.feature-container {
  width: 20%;
  object-fit: scale-down;
  position: absolute;
}

.feature-grid {
  width: 70%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  text-align: left;
  flex: 0 auto;
  order: 0;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  align-content: stretch;
  justify-content: stretch;
  align-self: center;
  align-items: center;
  justify-items: center;
  display: grid;
  position: static;
}

.feature-grid.cookiekiddle {
  grid-template-columns: 1fr 1fr 1fr;
}

.background-video-4 {
  z-index: 9999;
  width: 80%;
  height: 100%;
  object-fit: fill;
  border-radius: 25px;
  position: absolute;
  top: 0;
}

.feature-image-filler {
  z-index: -999;
  width: 100%;
  height: 100%;
  object-fit: fill;
  border-radius: 40px;
  display: block;
  position: relative;
}

.image-29, .image-30 {
  border-radius: 25px;
}

.feature-div {
  background-color: #fedf89;
  border-radius: 40px;
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
}

.feature-div.disabled {
  display: none;
}

.feature-video-1 {
  z-index: 999;
  width: 100%;
  height: 100%;
  object-fit: fill;
  border-radius: 25px;
  display: block;
  position: absolute;
  top: 0;
}

.feature-text {
  z-index: 998;
  width: 80%;
  direction: ltr;
  color: #533d18;
  text-align: center;
  text-transform: none;
  white-space: normal;
  justify-content: flex-start;
  font-size: 20px;
  line-height: 30px;
  display: block;
  position: absolute;
  overflow: visible;
}

.retail-location-section {
  z-index: 1;
  width: 100%;
  min-height: 500px;
  text-align: left;
  background-color: #fff;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 0;
  display: block;
  position: static;
}

.operation-section {
  max-height: 100%;
  max-width: 100%;
  min-height: 500px;
  object-fit: fill;
  object-position: 50% 50%;
  background-color: #fcbe4b;
  margin-top: 0;
  padding-top: 140px;
  display: block;
  position: relative;
  top: auto;
}

.image-31 {
  z-index: 0;
  min-width: 100%;
  object-fit: cover;
  border: 5px #000;
  position: absolute;
  top: -22%;
  bottom: auto;
  left: 0%;
  right: 0%;
  overflow: visible;
}

.text-block-14 {
  z-index: auto;
  height: auto;
  color: #5a4522;
  flex-flow: row;
  align-items: flex-end;
  margin-top: 0;
  margin-bottom: 0;
  margin-right: 0;
  font-family: Inter, sans-serif;
  font-size: 20px;
  line-height: 40px;
  display: flex;
  position: relative;
}

.operation-video {
  z-index: 2;
  width: 500px;
  height: 400px;
  max-height: 100%;
  max-width: 100%;
  clear: both;
  object-fit: scale-down;
  border-radius: 40px;
  justify-content: center;
  align-items: center;
  margin-top: -51px;
  padding-top: 0;
  padding-bottom: 0;
  display: block;
  position: relative;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: 0%;
  overflow: hidden;
}

.column-9 {
  height: 100%;
  text-align: left;
  justify-content: center;
  align-items: center;
  padding-left: 0;
  padding-right: 0;
  transition: transform .2s;
  display: flex;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: auto;
}

.column-10 {
  z-index: 5;
  height: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  text-align: left;
  object-fit: fill;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  align-content: space-around;
  justify-content: space-around;
  align-items: center;
  justify-items: start;
  margin-top: 0;
  padding-top: 10%;
  padding-left: 20px;
  padding-right: 10px;
  line-height: 100px;
  display: block;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: auto;
  right: 0%;
  overflow: visible;
}

.school-section {
  max-height: 832px;
  max-width: 100%;
  min-height: 500px;
  object-fit: fill;
  object-position: 50% 50%;
  background-color: #f05023;
  margin-top: 0;
  padding-top: 0;
  display: block;
  position: relative;
  top: auto;
}

.school-section-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0;
  position: static;
}

.school-section-logos {
  flex-direction: column;
  align-items: center;
  margin-top: 0;
  padding-top: 60px;
  padding-bottom: 20px;
  display: flex;
  position: static;
}

.best-sellers-section {
  z-index: auto;
  height: 100%;
  min-height: 500px;
  -webkit-text-fill-color: inherit;
  background-color: #fff;
  background-clip: border-box;
  flex-direction: column;
  align-items: center;
  margin-top: 0;
  padding: 60px 16px;
  display: block;
  position: relative;
}

.best-sellers-section.less-space {
  border-top: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
  padding-top: 60px;
  padding-bottom: 60px;
  display: none;
}

.cookie-kiddle-section {
  z-index: auto;
  max-height: 832px;
  max-width: 100%;
  min-height: 500px;
  object-fit: fill;
  object-position: 50% 50%;
  background-color: #54c0e8;
  background-image: none;
  background-size: auto;
  margin-top: 0;
  padding-top: 0;
  display: block;
  position: relative;
  top: auto;
}

.pearson-section {
  max-height: 832px;
  max-width: 100%;
  min-height: 500px;
  object-fit: fill;
  object-position: 50% 50%;
  background-color: #f8f0e0;
  justify-content: center;
  align-items: flex-start;
  margin-top: 0;
  padding-top: 0;
  display: flex;
  position: relative;
  top: auto;
}

.buy-now-section {
  max-height: 832px;
  max-width: 100%;
  min-height: 500px;
  object-fit: fill;
  object-position: 50% 50%;
  background-color: #fff;
  margin-top: 0;
  margin-left: auto;
  margin-right: auto;
  padding-top: 0;
  display: block;
  position: relative;
  top: auto;
  overflow: visible;
}

.buy-now-section-title {
  color: #f05023;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 60px;
  margin-bottom: 30px;
  font-family: Inter, sans-serif;
  font-size: 30px;
  font-weight: 700;
  display: flex;
  position: relative;
}

.div-block-17 {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  margin-left: 40px;
  margin-right: 40px;
  display: block;
  position: relative;
  top: 30%;
}

.footer-text-block {
  color: #fff;
  text-align: center;
  font-family: Inter, sans-serif;
}

.footer-div-block-2 {
  width: 100%;
  height: 60%;
  color: #fff;
  -webkit-text-fill-color: inherit;
  object-fit: fill;
  background-color: #545454;
  background-clip: border-box;
  position: relative;
  top: auto;
  bottom: 0;
  left: 0%;
  right: 0%;
}

.text-block-15 {
  text-align: center;
  font-family: Inter, sans-serif;
}

.image-33 {
  float: none;
  clear: none;
  text-align: center;
  object-fit: fill;
  object-position: 50% 50%;
  margin-left: auto;
  margin-right: auto;
  display: block;
  position: relative;
  left: auto;
}

.div-block-19 {
  position: absolute;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.footer-div-block-1 {
  width: 100%;
  height: 40%;
  color: #fff;
  -webkit-text-fill-color: inherit;
  object-fit: fill;
  background-color: #414141;
  background-clip: border-box;
  position: relative;
  top: auto;
  bottom: 0;
  left: 0%;
  right: 0%;
}

.grid-10 {
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  position: relative;
  top: 30%;
}

.school-logo-div {
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  margin-bottom: 86px;
  display: flex;
}

.school-logo-slider {
  width: 100%;
  background-color: rgba(0, 0, 0, 0);
  margin-top: 20px;
}

.school-section-text {
  color: #fff;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  margin-top: 60px;
  margin-bottom: 100px;
  font-size: 25px;
  line-height: 40px;
  display: inline;
  position: relative;
}

.rich-text-block-3 {
  color: #fff;
}

.grid-11 {
  height: 100%;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  direction: ltr;
  text-align: left;
  text-transform: none;
  column-count: auto;
  object-fit: fill;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-flow: row;
  align-content: center;
  justify-content: stretch;
  align-items: center;
  justify-items: start;
  margin-left: 50px;
  margin-right: 50px;
  overflow: visible;
}

.columns-2 {
  height: 100%;
  justify-content: flex-start;
  align-items: center;
  display: none;
  position: static;
}

.text-block-16 {
  color: #fff;
  margin-bottom: 30px;
  padding-left: 20px;
  padding-right: 62px;
  font-size: 25px;
  line-height: 40px;
  position: relative;
}

.text-block-17 {
  color: #fff;
  margin-top: 60px;
  margin-bottom: 20px;
  font-family: Inter, sans-serif;
  font-size: 30px;
  font-weight: 700;
  line-height: 40px;
  position: relative;
}

.previous {
  float: left;
  background-color: rgba(0, 0, 0, 0);
  border-style: none;
  display: block;
}

.collection-list-3 {
  height: auto;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  text-align: left;
  object-fit: fill;
  flex-direction: row;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  justify-content: center;
  align-items: center;
  display: flex;
}

.empty-state-2 {
  background-color: #f8f0e0;
}

.pagination {
  min-width: 100%;
  flex-wrap: nowrap;
  flex: 0 auto;
  order: 0;
  align-content: center;
  justify-content: space-between;
  align-self: auto;
  align-items: center;
  position: static;
  top: auto;
}

.pagination.overlapping {
  z-index: 9;
  clear: none;
  object-fit: fill;
  background-color: #f8f0e0;
  flex-flow: row;
  flex: 0 auto;
  order: 0;
  justify-content: space-between;
  align-self: auto;
  align-items: center;
  position: relative;
  top: 50%;
  bottom: auto;
}

.pagination.products {
  width: 100%;
  min-width: 0%;
  text-align: left;
  border: 1px #000;
  margin-top: -228px;
  display: block;
  position: static;
  top: 109%;
  left: 0;
  right: 0;
  transform: translate(0, -50%);
}

.pagination.customer-reviews {
  width: 100%;
  min-width: 0%;
  text-align: left;
  border: 1px #000;
  margin-top: 0;
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translate(0, -50%);
}

.next {
  float: right;
  background-color: rgba(0, 0, 0, 0);
  border-style: none;
}

.icon-6, .icon-7 {
  width: 300%;
  height: 100%;
}

.previous-2 {
  background-color: rgba(0, 0, 0, 0);
  border-style: none;
}

.next-2, .next-2-copy {
  width: 14px;
  background-color: rgba(0, 0, 0, 0);
  border-style: none;
}

.image-34 {
  z-index: 2147483647;
  object-fit: none;
  border: 1px #000;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.cookie-kiddle-eclipse {
  z-index: 1;
  width: 90%;
  height: 100%;
  max-width: 1500px;
  min-width: auto;
  object-fit: cover;
  object-position: 50% 100%;
  border: 1px #000;
  margin-top: 0;
  margin-left: 0;
  padding-top: 0;
  display: inline-block;
  position: absolute;
  top: auto;
  bottom: auto;
  left: 0%;
  right: 0;
  overflow: hidden;
}

.cookie-kiddle-image {
  z-index: 0;
  width: auto;
  height: 100%;
  max-width: 50%;
  min-height: 100%;
  min-width: auto;
  object-fit: cover;
  object-position: 50% 50%;
  flex: 0 auto;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  display: block;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
  overflow: hidden;
}

.cookie-kiddle-image.video {
  z-index: 0;
  width: auto;
  height: 100%;
  max-width: 50%;
  min-height: 100%;
  min-width: auto;
  object-fit: cover;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  display: block;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
  overflow: hidden;
}

.columns-3 {
  z-index: 5;
  height: 100%;
  justify-content: center;
  align-items: center;
  display: block;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: 0%;
}

.cookie-kiddle-turtle {
  z-index: 6;
  margin-right: 10px;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: auto;
  right: 0%;
  transform: rotate(0);
}

.cookie-kiddle-pattern {
  z-index: 2;
  height: 80%;
  font-family: Inter, sans-serif;
  position: absolute;
  top: -2%;
  bottom: 0%;
  left: 1px;
  right: 0%;
}

.cookie-kiddle-award {
  z-index: 2;
  position: absolute;
  top: 63%;
  bottom: 0%;
  left: 3%;
  right: auto;
}

.cookie-kiddle-logo {
  z-index: 1;
  transition: transform .5s cubic-bezier(.175, .885, .332, 1.275);
  position: absolute;
  top: 3%;
  bottom: auto;
  left: 3%;
  right: auto;
}

.cookie-kiddle-logo:hover {
  transform: scale(1.2);
}

.cookie-kiddle-unicorn {
  z-index: 2;
  position: absolute;
  top: auto;
  bottom: 6%;
  left: 59%;
  right: auto;
}

.cookie-kiddle-dino {
  z-index: 2;
  position: absolute;
  top: auto;
  bottom: 1%;
  left: 29%;
  right: auto;
}

.cookie-kiddle-submarine {
  z-index: 2;
  position: absolute;
  top: auto;
  bottom: 32%;
  left: 75%;
  right: auto;
}

.cookie-kiddle-collection-list-wrapper {
  z-index: 5;
  padding: 0;
  position: relative;
  top: auto;
  left: auto;
}

.collection-list-4, .collection-item {
  z-index: 5;
  position: relative;
}

.empty-state-3 {
  background-color: rgba(0, 0, 0, 0);
}

.retail-subgrid {
  width: 100%;
  height: 100%;
  grid-row-gap: 0px;
  grid-template-rows: minmax(100px, 100px) minmax(33px, 50px);
  grid-template-columns: 1fr;
  align-content: stretch;
  justify-content: stretch;
  align-items: center;
  justify-items: center;
}

.retail-geo-text {
  color: #5a4522;
  font-family: Inter, sans-serif;
  font-size: 16px;
}

.pearson-section-column-2 {
  z-index: 5;
  height: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  text-align: left;
  object-fit: fill;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  align-content: space-around;
  justify-content: space-around;
  align-items: center;
  justify-items: start;
  margin-top: 0;
  margin-left: auto;
  margin-right: auto;
  padding-top: 1%;
  padding-left: 10px;
  padding-right: 10px;
  line-height: 150px;
  display: block;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: auto;
  overflow: visible;
}

.collection-list-wrapper-6 {
  width: auto;
  height: auto;
  float: none;
  clear: none;
  object-fit: fill;
  position: relative;
}

.collection-item-2 {
  width: auto;
  height: 100%;
  position: relative;
}

.collection-list-5 {
  width: auto;
  height: auto;
}

.columns-4 {
  display: flex;
}

.column-11 {
  position: static;
}

.image-35 {
  width: 100%;
  height: 100%;
  opacity: 1;
  -webkit-text-fill-color: inherit;
  mix-blend-mode: normal;
  object-fit: cover;
  background-clip: border-box;
  margin-left: 0;
  position: static;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
}

.buy-now-text {
  z-index: auto;
  height: auto;
  color: #5a4522;
  flex-flow: row;
  align-items: flex-end;
  margin-top: 0;
  margin-bottom: 0;
  font-family: Inter, sans-serif;
  font-size: 20px;
  line-height: 40px;
  display: flex;
  position: relative;
}

.column-12 {
  position: relative;
}

.school-section-column-1 {
  height: 100%;
  text-align: left;
  justify-content: center;
  align-items: center;
  padding-left: 0;
  padding-right: 0;
  display: flex;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: auto;
}

.school-section-column-2 {
  z-index: 5;
  height: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  text-align: left;
  object-fit: fill;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  align-content: space-around;
  justify-content: space-around;
  align-items: center;
  justify-items: start;
  margin-top: 0;
  padding-top: 0%;
  padding-left: 20px;
  padding-right: 10px;
  line-height: 100px;
  display: block;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: auto;
  right: 0%;
  overflow: visible;
}

.operation-section-column-1 {
  height: 100%;
  text-align: left;
  justify-content: center;
  align-items: center;
  padding-left: 0;
  padding-right: 0;
  display: flex;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: 0%;
}

.operation-section-column-2 {
  z-index: 2;
  height: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  text-align: left;
  object-fit: fill;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  align-content: space-around;
  justify-content: space-around;
  align-items: center;
  justify-items: start;
  margin-top: 0;
  padding-top: 10%;
  padding-left: 20px;
  padding-right: 10px;
  line-height: 100px;
  display: block;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: auto;
  right: 0%;
  overflow: visible;
}

.operation-section-text {
  z-index: auto;
  height: auto;
  color: #5a4522;
  flex-flow: row;
  align-items: flex-end;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 25px;
  line-height: 40px;
  display: flex;
  position: relative;
}

.list-item {
  font-size: 25px;
}

.operation-section-list {
  font-size: 20px;
  line-height: 60px;
}

.image-36 {
  object-fit: cover;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: 0;
  right: 0%;
}

.columns-5 {
  justify-content: flex-start;
  align-items: stretch;
  margin-right: 0;
  display: none;
}

.pearson-section-image {
  z-index: 1;
  max-height: 35%;
  min-height: 0%;
  border-radius: 20px;
  margin-top: 20px;
  margin-left: 20px;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
  box-shadow: 6px 6px 3px rgba(0, 0, 0, .3);
}

.image-37 {
  position: absolute;
}

.pearson-product-1 {
  z-index: 0;
  width: auto;
  max-height: 80%;
  min-height: 70%;
  box-shadow: none;
  object-fit: cover;
  border-radius: 20px;
  margin-left: 0;
  position: absolute;
  top: 12%;
  left: 19%;
  transform: translate(0)rotate(-20deg);
}

.pearson-product-2 {
  z-index: 0;
  width: auto;
  max-height: 80%;
  min-height: 70%;
  box-shadow: none;
  object-fit: cover;
  border-radius: 20px;
  position: absolute;
  top: 10%;
  left: 37%;
  transform: rotate(17deg);
}

.div-block-20 {
  padding-left: 40px;
  padding-right: 40px;
}

.grid-12 {
  grid-column-gap: 1px;
  grid-row-gap: 1px;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr;
  grid-auto-flow: row;
  align-content: space-between;
}

.select-field.top {
  background-color: #fffbf6;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.empty-state-4 {
  background-color: #fffbf6;
}

.select-item {
  display: none;
  overflow: visible;
}

.collection-list-6 {
  overflow: visible;
}

.select-field-2 {
  background-color: #fffbf6;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin-bottom: 0;
}

.select-field-2.distributor {
  border-radius: 8px;
}

.success-message-2 {
  background-color: rgba(0, 218, 131, .73);
  border-radius: 16px;
}

.heading-8 {
  text-align: right;
}

.expandable-div {
  height: 20px;
}

.expandable-div-header {
  justify-content: flex-start;
  align-items: flex-start;
  display: block;
}

.expandable-div-header-1 {
  justify-content: center;
  align-items: flex-start;
  display: block;
}

.expandable-div-header-title-2 {
  text-align: center;
  position: static;
}

.product-description {
  display: none;
}

.faq-stripe-1 {
  width: 2px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
}

.c-faq {
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
}

.faq-stripe-2 {
  width: 100%;
  height: 2px;
  background-color: rgba(0, 0, 0, 0);
  position: absolute;
}

.c-faq-item {
  -webkit-text-fill-color: inherit;
  cursor: pointer;
  background-color: #fffbf6;
  background-clip: border-box;
  border-left: 3px solid #f05023;
  margin-bottom: 10px;
  font-size: 1.2em;
  line-height: 1.6em;
}

.c-faq-a {
  perspective-origin: 50% 0;
  transform-origin: 50% 0;
  overflow: hidden;
}

.c-faq-q {
  align-items: center;
  display: flex;
}

._w-faq-icon {
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
}

.faq-a-text {
  font-size: 1em;
  line-height: 1.6em;
}

.c-faq-a-text {
  padding: 20px;
}

.c-faq-q-text {
  flex: 1;
  padding: 20px;
}

.c-faq-divider {
  padding-left: 20px;
  padding-right: 20px;
}

.faq-divider {
  height: 0;
  border-top: 1px dashed rgba(255, 255, 255, .25);
}

.c-faq-icon {
  cursor: pointer;
  justify-content: center;
  align-items: center;
  padding: 20px;
  position: relative;
}

.list {
  margin-top: 80px;
  margin-bottom: auto;
  font-family: Inter, sans-serif;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: 0%;
}

.html-embed-2 {
  z-index: 2;
  display: none;
  position: absolute;
}

.grid-13 {
  grid-template-rows: auto;
  grid-template-columns: 1.25fr 1fr;
}

.div-block-21 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.hero-turtle {
  z-index: 2;
  width: 100%;
  position: relative;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
}

.hero-dino {
  z-index: 2;
  width: 100%;
  height: auto;
  position: relative;
  top: auto;
  bottom: 13%;
  left: 13%;
  right: auto;
}

.hero-unicorn {
  z-index: 2;
  width: 100%;
  height: auto;
  position: relative;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: auto;
  transform: rotate(0);
}

.characterdiv-columns {
  z-index: auto;
  height: 100%;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  font-family: Inter, sans-serif;
  font-weight: 400;
  display: flex;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.slide-nav-2 {
  margin-bottom: -70px;
}

.pearson-section-column-1 {
  z-index: 5;
  height: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  text-align: left;
  object-fit: fill;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  align-content: center;
  justify-content: space-around;
  align-items: center;
  justify-items: start;
  margin-top: 0;
  margin-left: auto;
  margin-right: auto;
  padding-top: 1%;
  padding-left: 10px;
  padding-right: 20px;
  line-height: 150px;
  display: grid;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: auto;
  right: 0%;
  overflow: visible;
}

.pearson-logo-desktop {
  position: relative;
}

.columns-6 {
  display: block;
}

.grid-15 {
  grid-row-gap: 7px;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  margin-left: 50px;
  margin-right: 50px;
}

.operation-bubble.lower-right {
  position: absolute;
  top: auto;
  bottom: 0%;
  left: auto;
  right: 0%;
}

.operation-bubble.upper-left {
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
}

.operation-bubble.lower-left {
  position: absolute;
  top: auto;
  bottom: 9%;
  left: 0%;
  right: auto;
}

.operation-bubble.upper-right {
  position: absolute;
  top: 0%;
  bottom: auto;
  left: auto;
  right: 0%;
}

.text-block-16-copy {
  color: #fff;
  margin-bottom: 20px;
  font-family: Inter, sans-serif;
  font-size: 20px;
  line-height: 40px;
  position: relative;
}

.column-16, .hero-column {
  height: 100%;
}

.hero-column-video {
  margin-top: 140px;
  padding-top: 1px;
}

.hero-columns {
  height: 100%;
}

.pearson-logo-mobile {
  display: none;
}

.best-seller-collection-wrapper-mobile {
  width: 100%;
  height: 550px;
  text-align: center;
  object-fit: fill;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  display: none;
  position: relative;
}

.collection-list-7 {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  display: grid;
}

.heading-10 {
  display: none;
}

.collection-item-3 {
  width: 100px;
  height: 100px;
  object-fit: fill;
  display: block;
  position: static;
}

.collection-list-wrapper-4-mobile {
  width: 100%;
  height: auto;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  flex-direction: column;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  justify-content: center;
  align-items: center;
  display: none;
}

.hero-turtle-div {
  z-index: auto;
  width: 16%;
  max-width: 18%;
  margin-bottom: -33px;
  margin-left: 11px;
  position: absolute;
  top: auto;
  bottom: 17%;
  left: 0%;
  right: auto;
}

.hero-dino-div {
  z-index: auto;
  width: 15%;
  max-width: 15%;
  margin-bottom: 10px;
  margin-left: -10px;
  padding-left: 14px;
  position: absolute;
  top: auto;
  bottom: 13%;
  left: 13%;
  right: auto;
}

.hero-unicorn-div {
  z-index: auto;
  width: 10%;
  max-width: 10%;
  margin-bottom: -3px;
  position: absolute;
  top: auto;
  bottom: 11%;
  left: 32%;
  right: auto;
}

.heroeduhk {
  z-index: 21;
  width: 100%;
  max-height: 100%;
  max-width: 60%;
  object-fit: scale-down;
  padding-left: 0;
  position: static;
  top: auto;
  bottom: 0%;
  left: auto;
  right: 0%;
}

.characterdiv1-mobile {
  z-index: 5;
  width: 124px;
  height: 40px;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  background-color: #00b9e3;
  border-radius: 10px;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  display: none;
  position: absolute;
  top: auto;
  bottom: 19%;
  left: 51%;
  right: auto;
}

.characterdiv2-mobile {
  z-index: 5;
  width: 124px;
  height: 40px;
  -webkit-text-fill-color: inherit;
  background-color: #38d430;
  background-clip: padding-box;
  border-radius: 10px;
  display: none;
  position: absolute;
  top: auto;
  bottom: 12%;
  left: 59%;
  right: auto;
}

.characterdiv3-mobile {
  z-index: 5;
  width: 124px;
  height: 40px;
  -webkit-text-fill-color: inherit;
  background-color: #7e57c5;
  background-clip: padding-box;
  border-radius: 10px;
  display: none;
  position: absolute;
  top: auto;
  bottom: 10%;
  left: 49%;
  right: auto;
}

._w-accordion-item-a {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 30%;
  grid-auto-columns: 1fr;
  padding: 5px 15px 5px 10px;
  font-family: Inter, sans-serif;
  display: block;
}

._w-accordion-item-a.job-posting-subtitle {
  grid-template-rows: 100%;
  grid-template-columns: 1fr;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}

._w-accordion-item-a.job-posting-text {
  grid-column-gap: 1px;
  grid-row-gap: 1px;
  color: #5a4522;
  grid-template-columns: 1fr;
  grid-auto-flow: row;
  padding-left: 20px;
}

._w-accordion-item-a.main {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 30%;
  grid-auto-columns: 1fr;
  display: grid;
}

.c-header {
  text-align: center;
}

.c-accordion-item-q-icon {
  justify-content: center;
  align-items: center;
  padding: 20px;
  display: flex;
}

._w-accordion-content-divider {
  padding-left: 20px;
  padding-right: 20px;
}

.c-accordion-list {
  margin-bottom: 20px;
}

.accordion-item-q-icon-stripe-2 {
  width: .3em;
  height: 100%;
  background-color: #f05023;
  position: absolute;
}

.accordion-item-q-text {
  font-size: 1.2em;
  font-weight: 600;
  line-height: 1.4em;
}

.accordion-item-q-text.job-posting-title {
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
}

.c-accordion-item-q-text {
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  display: flex;
  position: relative;
}

.accordion-content-divider {
  width: 100%;
  height: 0;
  border-bottom: 1px dashed rgba(51, 51, 51, .2);
}

._w-accordion-item-q-text {
  display: flex;
}

.c-accordion-item-a {
  overflow: hidden;
}

.c-accordion-item-a.job-posting {
  background-color: #f8f0e0;
  border-radius: 0;
  padding-top: 0;
  padding-bottom: 10px;
}

.c-details {
  margin-bottom: 60px;
  display: none;
}

._w-accordion-item {
  cursor: pointer;
  border: 1px solid #fff;
  border-radius: 10px;
  transition: all .25s;
  box-shadow: 1px 1px 15px rgba(19, 19, 19, .15);
}

._w-accordion-item:hover {
  border-color: rgba(93, 195, 163, .25);
  box-shadow: 1px 1px 15px rgba(33, 159, 163, .75);
}

._w-accordion-item.job-posting {
  border-style: none;
}

._w-accordion-item-q-icon {
  width: 1.5em;
  height: 1.5em;
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
}

.subheader {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 1.2em;
  line-height: 1.4em;
}

.accordion-item-q-icon-stripe-1 {
  width: 100%;
  height: .3em;
  background-color: #f05023;
  position: relative;
}

.c-accordion-item {
  background-color: rgba(0, 0, 0, 0);
  margin-bottom: 10px;
}

.accordion-item-a-text {
  color: #666;
  margin-bottom: 0;
}

._w-accordion-item-q {
  display: flex;
}

.c-accordion-item-q.job-posting {
  background-color: #fcbe4b;
  border-radius: 0;
}

.details {
  width: 100%;
  max-width: 750px;
  color: #888;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  font-size: 1em;
  line-height: 1.4em;
}

.header {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 4em;
  line-height: 1em;
}

.best-seller-collection-wrapper-desktop-copy {
  width: 100%;
  height: 550px;
  text-align: center;
  object-fit: fill;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  display: block;
  position: relative;
}

.pagination-button {
  opacity: .4;
}

.pagination-button:hover, .pagination-button:focus {
  opacity: .8;
}

.nav-link-language-3 {
  color: #5a4522;
  padding-right: 5px;
  font-size: 14px;
  display: inline-block;
}

.nav-link-language-3:hover {
  color: #29c0e7;
}

.nav-link-language-3.w--current {
  color: #212127;
}

.nav-link-language-4 {
  color: #5a4522;
  padding-left: 5px;
  font-size: 14px;
  display: inline-block;
}

.nav-link-language-4:hover {
  color: #29c0e7;
}

.nav-link-language-4.w--current {
  color: #212127;
}

.top-menu-div-mobile {
  height: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  display: none;
}

.accordion-item-q-icon-stripe-2-2 {
  width: .3em;
  height: 100%;
  background-color: #f05023;
  position: absolute;
}

.c-details-2 {
  margin-bottom: 60px;
  display: none;
}

.accordion-item-q-icon-stripe-1-2 {
  width: 100%;
  height: .3em;
  background-color: #f05023;
  position: relative;
}

.c-accordion-item-2 {
  background-color: rgba(0, 0, 0, 0);
  margin-bottom: 10px;
}

.text-block-18, .text-block-19 {
  margin-top: 20px;
}

.bold-text, .bold-text-2, .bold-text-3 {
  font-weight: 400;
}

.cookie-kiddle-award-mobile {
  z-index: 2;
  display: none;
  position: absolute;
  top: 63%;
  bottom: 0%;
  left: 3%;
  right: auto;
}

.feature-text-landscape {
  z-index: 998;
  width: 80%;
  direction: ltr;
  color: #533d18;
  text-align: center;
  text-transform: none;
  white-space: normal;
  justify-content: flex-start;
  font-size: 20px;
  line-height: 30px;
  display: none;
  position: absolute;
  overflow: visible;
}

.herowhitebanner-copy {
  z-index: 2;
  min-width: 100%;
  object-fit: fill;
  object-position: 50% 100%;
  border: 1px #000;
  position: absolute;
  top: auto;
  bottom: 202px;
  left: 0%;
  right: 0%;
  overflow: visible;
}

.heroorange-copy {
  z-index: 1;
  width: auto;
  height: auto;
  object-fit: fill;
  position: static;
  top: auto;
  bottom: 21%;
  left: auto;
  right: -6%;
  overflow: hidden;
}

.grid-16 {
  z-index: 5;
  display: none;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: 0%;
}

.div-block-24 {
  width: 50%;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: auto;
}

.div-block-25 {
  width: 50%;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: auto;
  right: 0%;
}

.pearson-eclipse {
  z-index: 0;
  width: 90%;
  height: 100%;
  max-width: 1500px;
  min-width: 100%;
  object-fit: cover;
  object-position: 50% 100%;
  border: 1px #000;
  margin-top: 0;
  margin-left: 0;
  padding-top: 0;
  display: block;
  position: absolute;
  top: auto;
  bottom: auto;
  left: 0%;
  right: 0;
  overflow: hidden;
}

.grid-17 {
  width: 100%;
  height: 100%;
  max-height: 832px;
  min-height: 500px;
  grid-template-rows: auto;
  grid-template-columns: 1.5fr 1fr;
  align-content: stretch;
  justify-content: stretch;
}

.div-block-27, .pearson-div {
  padding: 20px;
}

.pearson-div._1 {
  height: 100%;
  padding: 40px;
}

.pearson-div._2 {
  height: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  flex-flow: wrap;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  grid-auto-flow: row;
  align-content: stretch;
  justify-content: flex-start;
  align-items: center;
  padding: 40px;
  display: flex;
}

.grid-18 {
  height: 100%;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  grid-template: "."
                 "."
                 "."
                 / 1fr;
  align-content: center;
  justify-content: stretch;
  padding-left: 40px;
  position: static;
}

.school-grid {
  width: 100%;
  height: 100%;
  max-height: 832px;
  min-height: 500px;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr;
  align-content: stretch;
  justify-content: stretch;
}

.school-div {
  padding: 20px;
}

.school-div._1 {
  width: 100%;
  height: 100%;
  padding: 0;
}

.school-div._2 {
  height: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  flex-flow: wrap;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  grid-auto-flow: row;
  align-content: stretch;
  justify-content: flex-start;
  align-items: center;
  padding: 40px;
  display: flex;
}

.pearson-div-copy {
  padding: 20px;
}

.pearson-div-copy._1 {
  height: 100%;
  padding: 40px;
}

.pearson-div-copy._2 {
  width: 100%;
  height: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  flex-flow: wrap;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  grid-auto-flow: row;
  align-content: stretch;
  justify-content: flex-start;
  align-items: center;
  padding: 40px;
  display: flex;
}

.operation-column {
  height: 100%;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  position: static;
}

.buy-now-grid {
  width: 100%;
  height: 100%;
  max-height: 832px;
  min-height: 500px;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr;
  align-content: stretch;
  justify-content: stretch;
}

.buy-now-div {
  padding: 20px;
}

.buy-now-div._1 {
  width: 100%;
  height: 100%;
  padding: 0;
}

.buy-now-div._2 {
  height: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  flex-flow: wrap;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  grid-auto-flow: row;
  align-content: stretch;
  justify-content: flex-start;
  align-items: center;
  padding: 40px;
  display: flex;
}

.buy-now-div2 {
  padding: 20px;
}

.buy-now-div2._1 {
  height: 100%;
  padding: 40px;
}

.buy-now-div2._2 {
  width: 100%;
  height: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  flex-flow: wrap;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  grid-auto-flow: row;
  align-content: stretch;
  justify-content: flex-start;
  align-items: center;
  padding: 40px;
  display: flex;
}

.remove {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: static;
}

.heading-11 {
  display: none;
}

.retail-logo-2 {
  max-width: 200px;
  border-radius: 16px;
  margin-left: 24px;
  margin-right: 24px;
}

.character-bio {
  z-index: 6;
  width: 130px;
  height: 110px;
  float: none;
  clear: none;
  text-align: center;
  object-fit: none;
  background-color: #fcbe4b;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  padding: 10px;
  display: flex;
  position: absolute;
  top: auto;
  bottom: auto;
  left: auto;
  right: auto;
  box-shadow: 0 4px 4px rgba(0, 0, 0, .25);
}

.character-bio.dino {
  width: 130px;
  height: 120px;
  background-color: #fcbe4b;
  display: none;
  box-shadow: 0 4px 4px rgba(0, 0, 0, .25);
}

.character-bio.turtle {
  z-index: 6;
  height: 120px;
  display: none;
  position: absolute;
}

.character-bio.unicorn {
  z-index: 6;
  width: 130px;
  height: 120px;
  display: none;
  position: absolute;
  bottom: auto;
  left: auto;
}

.language-indicator {
  color: #f05023;
  justify-content: center;
  align-items: stretch;
  font-family: Inter, sans-serif;
  font-weight: 400;
  display: block;
}

.bold-text-4, .bold-text-5 {
  font-weight: 400;
}

.cookie-kiddle-bg-video {
  z-index: 0;
  width: 100%;
  height: 100%;
  max-width: 50%;
  border: 0 #000;
  border-radius: 0;
  display: block;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
}

.background-video-5 {
  z-index: 0;
  width: 100%;
  height: 100%;
  max-width: 50%;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
}

.cookie-kiddle-video {
  z-index: 0;
  width: auto;
  height: 100%;
  max-width: 50%;
  min-height: 100%;
  min-width: auto;
  object-fit: cover;
  object-position: 50% 50%;
  flex: 0 auto;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  display: none;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
  overflow: hidden;
}

.cookie-kiddle-video.video {
  z-index: 0;
  width: auto;
  height: 100%;
  max-width: 50%;
  min-height: 100%;
  min-width: auto;
  object-fit: cover;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  display: block;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
  overflow: hidden;
}

.customer-reviews-section {
  z-index: auto;
  height: 100%;
  min-height: 500px;
  -webkit-text-fill-color: inherit;
  background-color: #f8f0e0;
  background-clip: border-box;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  padding: 60px 16px;
  display: block;
  position: relative;
}

.customer-reviews-section.less-space {
  border-top: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
  padding-top: 60px;
  padding-bottom: 60px;
  display: none;
}

.customer-reviews-collection-wrapper-desktop {
  width: 100%;
  height: auto;
  text-align: center;
  object-fit: fill;
  flex-direction: column;
  justify-content: flex-start;
  align-self: auto;
  align-items: center;
  padding-left: 80px;
  padding-right: 80px;
  display: none;
  position: relative;
}

.customer-reviews-collection-list {
  height: auto;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  text-align: left;
  object-fit: fill;
  flex-direction: row;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  justify-content: center;
  align-items: center;
  display: flex;
}

.customer-reviewer-collection-item {
  justify-content: center;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
}

.customer-review-item-div {
  width: 100%;
  height: 500px;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  grid-template-rows: minmax(50%, 50%) auto;
  grid-template-columns: minmax(100%, 100%);
  grid-auto-columns: 1fr;
  display: grid;
}

.customer-review-text-div {
  grid-column-gap: 16px;
  grid-row-gap: 0px;
  text-align: left;
  background-color: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 25px;
  border-bottom-left-radius: 25px;
  grid-template-rows: minmax(auto, auto) minmax(auto, 50px);
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  display: grid;
}

.customer-review-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 25px 25px 0 0;
  position: static;
}

.customer-review-title {
  color: #f05023;
  font-weight: 700;
  display: block;
}

.customer-review-pagination {
  min-width: 100%;
  flex-wrap: nowrap;
  flex: 0 auto;
  order: 0;
  align-content: center;
  justify-content: space-between;
  align-self: auto;
  align-items: center;
  position: static;
  top: auto;
}

.customer-review-pagination.overlapping {
  z-index: 9;
  clear: none;
  object-fit: fill;
  background-color: #f8f0e0;
  flex-flow: row;
  flex: 0 auto;
  order: 0;
  justify-content: space-between;
  align-self: auto;
  align-items: center;
  position: relative;
  top: 50%;
  bottom: auto;
}

.customer-review-pagination.products {
  width: 100%;
  min-width: 0%;
  text-align: left;
  border: 1px #000;
  margin-top: -228px;
  display: block;
  position: absolute;
  top: 109%;
  left: 0;
  right: 0;
  transform: translate(0, -50%);
}

.icon-8 {
  z-index: 99;
  width: 100%;
  height: 100%;
  position: absolute;
}

.customer-reviews-collection-wrapper-mobile {
  width: 100%;
  height: auto;
  text-align: center;
  object-fit: fill;
  flex-direction: column;
  justify-content: flex-start;
  align-self: auto;
  align-items: center;
  padding-left: 80px;
  padding-right: 80px;
  display: none;
  position: relative;
}

.slider-2 {
  height: 500px;
}

.job-posting-background {
  z-index: 0;
  width: 100%;
  max-width: none;
  object-fit: fill;
  position: absolute;
  top: 22%;
  bottom: auto;
  left: 0%;
  right: 0%;
}

.div-block-29 {
  width: 100%;
  height: auto;
  max-height: 300px;
  grid-column-gap: 0px;
  grid-row-gap: 16px;
  text-align: left;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  align-content: center;
  justify-content: start;
  align-items: center;
  justify-items: center;
  padding-left: 100px;
  padding-right: 100px;
  display: grid;
}

.collection-list-wrapper-7 {
  z-index: 1;
  position: relative;
}

.grid-19 {
  grid-template-rows: auto auto;
  grid-template-areas: ". Area"
                       ". Area";
}

.image-42 {
  width: auto;
  height: auto;
  max-height: 200px;
  display: none;
  position: absolute;
  top: auto;
  bottom: 16%;
  left: auto;
  right: 6%;
}

.job-posting-mascot {
  width: auto;
  height: 50%;
  max-width: none;
}

.red-dot {
  width: 15px;
  height: 15px;
  float: right;
  clear: none;
  object-fit: fill;
  position: relative;
  top: 13%;
  bottom: 0%;
  left: -16%;
  right: 0%;
}

.red-dot.career {
  object-fit: fill;
  position: absolute;
  top: 20%;
  bottom: auto;
  left: 1%;
  right: auto;
  overflow: visible;
}

.grid-20 {
  width: 80%;
  grid-template-columns: 1fr 1fr 1fr;
  position: static;
  left: 10px;
}

.slide {
  text-align: center;
}

.testimonial-div {
  width: auto;
  height: 90%;
  max-height: none;
  max-width: none;
  grid-column-gap: 37px;
  grid-row-gap: 0px;
  grid-template-rows: auto;
  grid-template-columns: 30% 30% 30%;
  grid-auto-columns: 1fr;
  align-content: stretch;
  justify-content: space-between;
  align-items: center;
  justify-items: center;
  margin-left: 100px;
  margin-right: 100px;
  display: grid;
}

.slider-3 {
  height: 700px;
  background-color: rgba(0, 0, 0, 0);
}

.testimonial-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  position: static;
}

.testimonial-image._2 {
  z-index: auto;
  object-fit: cover;
  display: block;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: 0%;
}

.testimonial-image._2:hover {
  display: block;
}

.testimonial-image._1 {
  z-index: 1;
  display: block;
  position: relative;
}

.testimonial-image._1:hover, .testimonial-image._1:focus {
  z-index: 1;
  display: block;
}

.testimonial-grid {
  width: auto;
  height: 600px;
  max-height: none;
  max-width: 350px;
  grid-row-gap: 0px;
  object-fit: fill;
  grid-template-rows: 50% 50%;
  grid-template-columns: 1fr;
  position: static;
  overflow: visible;
}

.testimonial-text {
  height: 100%;
  text-align: justify;
  background-color: rgba(0, 0, 0, 0);
  border-radius: 0;
  padding-top: 30px;
  padding-left: 30px;
  padding-right: 30px;
  font-size: 16px;
  line-height: 25px;
  display: block;
}

.testimonial-text.full {
  display: none;
}

.icon-9, .icon-10 {
  color: #f05023;
}

.testimonial-text-div {
  grid-column-gap: 16px;
  grid-row-gap: 0px;
  background-color: #fff;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  grid-template-rows: 80% 50px;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  display: grid;
}

.testimonial-name-div {
  padding-left: 30px;
  font-family: Inter, sans-serif;
}

.heading-12 {
  font-family: Inter, sans-serif;
}

.testimonial-image-div {
  position: relative;
}

.heading-13 {
  font-family: Inter, sans-serif;
}

.testimonial-slider {
  height: 700px;
  background-color: rgba(0, 0, 0, 0);
}

.image-43 {
  position: absolute;
}

.last-updated-date {
  width: auto;
  max-width: 25%;
  text-align: left;
  font-size: 12px;
  line-height: 16px;
  display: flex;
}

.animation-detection-div {
  z-index: 7;
  width: 100%;
  height: 100%;
  cursor: none;
  display: block;
  position: absolute;
}

.bold-text-6, .bold-text-7 {
  font-weight: 400;
}

.feature-dino-div {
  z-index: 3;
  width: 10%;
  max-width: 15%;
  margin-bottom: 0;
  margin-left: 0;
  padding-left: 0;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: auto;
}

.feature-unicorn-div {
  z-index: 3;
  width: 10%;
  max-width: 10%;
  margin-bottom: 0;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: auto;
  right: 0%;
}

.unicorn {
  z-index: 2;
  width: 100%;
  height: auto;
  position: relative;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: auto;
  transform: rotate(0);
}

.unicorn.feature {
  width: 80%;
  transform-style: preserve-3d;
  transform: rotateX(0)rotateY(180deg)rotateZ(0);
}

.div-block-30 {
  z-index: 4;
  width: auto;
  height: 100%;
  max-width: 50%;
  min-height: 100%;
  min-width: auto;
  object-fit: cover;
  background-color: #d32424;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
  overflow: hidden;
}

.grid-21 {
  width: 40%;
  grid-column-gap: 3px;
  grid-template: "Area . . . ." 160px
                 "Area-2 Area-2 Area-2 Area-2 Area-2" minmax(120px, 1fr)
                 / minmax(20%, 50px) minmax(20%, 50px) minmax(20%, 50px) minmax(20%, 50px) minmax(20%, 50px);
  margin-right: 20px;
  position: absolute;
  top: auto;
  bottom: -2%;
  left: auto;
  right: 0%;
}

.grid-21.cookiekiddle {
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: row;
}

.subheading-banner {
  color: #f05023;
  text-align: center;
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-weight: 400;
  display: block;
}

.subheading-banner.school-order {
  color: #fff;
  border-radius: 8px;
}

.subheading-banner.school-order.form-section {
  text-align: left;
  margin-top: 20px;
  margin-bottom: 20px;
}

.subheading-banner.school-order.form-result {
  margin-top: 40px;
  margin-bottom: 10px;
}

.subheading-banner.distributor {
  color: #533d18;
}

.subheading-banner.distributor.form-section {
  text-align: left;
  margin-top: 20px;
  margin-bottom: 20px;
}

.subheading-banner.distributor.subtitle {
  font-size: 20px;
}

.subheading-banner.job-posting {
  color: #533d18;
}

.subheading-banner.job-posting.form-section {
  text-align: left;
  margin-top: 20px;
  margin-bottom: 20px;
}

.subheading-banner.job-posting.subtitle {
  font-size: 20px;
}

.subheading-banner.school {
  color: #fff;
}

.subheading-banner.demo {
  color: #5a4522;
}

.text-block-20 {
  color: #fff;
  display: none;
}

.div-block-31 {
  width: 100%;
  padding-left: 40px;
  padding-right: 40px;
  display: none;
}

.social-share-icon {
  width: 75px;
  height: auto;
  background-image: url('../../../public/asset/images/webflow/facebook-share-button-icon.svg');
  background-position: 0 0;
  background-size: auto;
}

.social-share-icon.facebook {
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: scroll;
  overflow: visible;
}

.div-block-32 {
  z-index: 999;
  position: relative;
}

.image-44 {
  overflow: hidden;
}

.html-embed-3 {
  overflow: visible;
}

.div-block-33 {
  width: auto;
  min-width: 33%;
  padding-left: 20px;
  overflow: visible;
}

.image-45 {
  display: none;
  overflow: visible;
}

.image-46 {
  margin: 20px 0;
}

.html-embed-4 {
  margin-left: 27px;
}

.share-text {
  color: #5a4522;
}

.rich-text-block-6 {
  text-align: left;
  align-items: center;
  display: flex;
}

.rich-text-block-7 {
  z-index: 9;
  position: absolute;
}

.rich-text-block-8 {
  z-index: 9;
  object-fit: scale-down;
  position: absolute;
  top: auto;
  bottom: 53%;
  left: auto;
  right: 0%;
}

.grid-21-cookie-kiddle {
  z-index: 4;
  width: 40%;
  max-height: 200px;
  grid-column-gap: 3px;
  grid-row-gap: 0px;
  grid-template: "." 1fr
  / minmax(25%, 50px) 1fr 1fr;
  align-content: center;
  align-items: center;
  justify-items: center;
  margin-right: 20px;
  position: absolute;
  top: auto;
  bottom: 10%;
  left: auto;
  right: 0%;
}

.grid-21-cookie-kiddle.cookiekiddle {
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-flow: row;
}

.image-47 {
  z-index: 21;
  width: auto;
  max-width: 30%;
  margin-right: 0;
  position: absolute;
  top: -10%;
  bottom: auto;
  left: auto;
  right: 3%;
  transform: rotate(15deg);
}

.image-48 {
  z-index: 21;
  max-width: 40%;
  float: left;
  position: absolute;
  top: -10%;
  bottom: auto;
  left: auto;
  right: 3%;
  transform: rotate(15deg);
}

.image-49 {
  max-height: 75px;
  max-width: none;
  min-width: 0;
  display: inline-block;
  position: static;
}

.div-block-35 {
  display: block;
  position: relative;
}

.link-block-9 {
  display: inline-block;
  position: static;
}

.nav-link-turtle-teach {
  color: #5a4522;
  padding-right: 20px;
  font-family: Inter, sans-serif;
  font-weight: 400;
  display: inline-block;
}

.nav-link-turtle-teach:hover {
  color: #29c0e7;
}

.nav-link-turtle-teach.w--current {
  color: #ffa800;
}

.nav-link-turtle-teach.dropdown {
  z-index: 1;
  float: left;
}

.nav-link-turtle-teach.in-footer {
  color: #fff;
  padding-right: 32px;
  font-size: 24px;
  line-height: 150%;
  text-decoration: none;
}

.nav-link-turtle-teach.in-footer:hover {
  text-decoration: underline;
}

.nav-link-turtle-teach.in-footer.disabled {
  color: #777;
}

.nav-link-turtle-teach.disabled {
  color: #dbdbdb;
}

.image-50 {
  border-radius: 13px;
}

.image-51 {
  position: absolute;
  top: 0%;
  bottom: auto;
  left: auto;
  right: 0%;
  transform: rotate(15deg);
}

.app-store {
  z-index: 21;
  width: 100%;
  max-height: 100%;
  max-width: 60%;
  object-fit: scale-down;
  padding-left: 0;
  display: inline-block;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: auto;
  right: 0%;
}

.app-store-label {
  z-index: 21;
  max-width: 40%;
  float: left;
  position: absolute;
  top: auto;
  bottom: 5%;
  left: auto;
  right: 10%;
}

.turtle-teach-section {
  max-height: none;
  max-width: 100%;
  min-height: 500px;
  object-fit: fill;
  object-position: 50% 50%;
  background-color: #fffbf6;
  margin-top: 0;
  padding: 60px;
  display: block;
  position: relative;
  top: auto;
}

.turtle-teach-section.hidden {
  display: none;
}

.turtle-teach-grid {
  width: 100%;
  height: 100%;
  max-height: 832px;
  min-height: 500px;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr;
  align-content: stretch;
  justify-content: stretch;
  align-items: center;
  justify-items: stretch;
}

.turtle-teach-text-div {
  padding: 20px;
}

.turtle-teach-text-div._1 {
  height: 100%;
  padding: 40px;
}

.turtle-teach-text-div._2 {
  width: 100%;
  height: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  flex-flow: wrap;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  grid-auto-flow: row;
  align-content: stretch;
  justify-content: flex-start;
  align-items: center;
  padding: 40px;
  display: flex;
}

.turtle-teach-illustration-div {
  border-radius: 20px;
  padding: 20px;
}

.turtle-teach-illustration-div._1 {
  width: 100%;
  height: 100%;
  padding: 0;
}

.turtle-teach-illustration-div._2 {
  height: 100%;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  flex-flow: wrap;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  grid-auto-flow: row;
  align-content: stretch;
  justify-content: flex-start;
  align-items: center;
  padding: 40px;
  display: flex;
}

.turtle-teach-hero-title {
  color: #5a4522;
  margin-bottom: 10px;
  font-family: sofia-pro-soft, sans-serif;
  font-size: 48px;
  font-weight: 700;
  line-height: 150%;
  position: static;
  top: 10%;
  bottom: auto;
  left: 5%;
  right: auto;
}

.turtle-teach-signup-form {
  background-color: #f8f0e0;
  padding: 80px 16px 32px;
  position: relative;
}

.turtle-teach-signup-form.less-space {
  border-top: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
  padding-top: 60px;
  padding-bottom: 60px;
  display: none;
}

.turtle-teach-signup-form.school-order {
  background-color: #30a1f2;
}

.turtle-teach-signup-form.distributor {
  background-color: #fcbe4b;
}

.turtle-teach-form {
  background-color: #fffbf6;
  border: 1px solid #8b6424;
  border-radius: 8px;
  padding: 60px;
  box-shadow: 0 0 6px #8b6424;
}

.turtle-teach-form.school-order {
  background-color: rgba(0, 0, 0, 0);
}

.select-field-3 {
  color: #5a4522;
  background-color: #fffbf6;
  margin-bottom: 0;
}

.select-field-4 {
  color: #5a4522;
  background-color: #fffbf6;
}

.image-52 {
  max-height: 100px;
}

.grid-22 {
  z-index: 2;
  max-width: 100%;
  grid-row-gap: 39px;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  align-content: stretch;
  justify-content: stretch;
  align-items: stretch;
  justify-items: stretch;
  margin-bottom: 0;
  padding-left: 20px;
  position: relative;
}

.image-53 {
  max-width: 30%;
}

.heading-14 {
  text-align: center;
  font-size: 64px;
  line-height: 150%;
}

.turtle-teach-feature-section {
  width: 100%;
  min-height: 700px;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  text-align: left;
  background-color: #fffbf6;
  flex-direction: column;
  grid-template-rows: auto auto auto;
  grid-template-columns: 50%;
  grid-auto-columns: 1fr;
  justify-content: center;
  align-items: center;
  justify-items: start;
  margin-bottom: auto;
  margin-left: auto;
  margin-right: auto;
  padding-top: 100px;
  padding-bottom: 133px;
  padding-left: 40px;
  display: block;
  position: relative;
}

.turtle-teach-text-block {
  color: #5a4522;
  text-align: left;
  margin-bottom: 20px;
  font-family: Inter, sans-serif;
  font-size: 20px;
  line-height: 40px;
  position: relative;
}

.turtle-teach-text-block-title {
  color: #5a4522;
  text-align: center;
  flex: 0 auto;
  align-self: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  font-family: Inter, sans-serif;
  font-size: 30px;
  font-weight: 700;
  line-height: 40px;
  display: block;
  position: relative;
}

.turtle-teach-hero-container {
  max-height: none;
  max-width: 100%;
  min-height: 700px;
  object-fit: fill;
  object-position: 50% 50%;
  background-color: #ffa800;
  border: 1px #fff;
  padding-top: 100px;
  padding-bottom: 0;
  padding-left: 40px;
  display: block;
  position: relative;
  overflow: hidden;
}

.turtle-teach-hero-container.cookiekiddle {
  background-color: #29c0e7;
}

.turtle-teach-feature-dino-div {
  z-index: 3;
  width: 10%;
  max-width: 15%;
  margin-bottom: 0;
  margin-left: 0;
  padding-left: 0;
  display: none;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: auto;
}

.turtle-teach-feature-unicorn-div-copy {
  z-index: 3;
  width: 10%;
  max-width: 10%;
  margin-bottom: 0;
  display: none;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: auto;
  right: 0%;
}

.turtle-teach-hero-turtle-div {
  z-index: 9;
  width: 16%;
  max-width: 18%;
  transform-style: preserve-3d;
  margin-bottom: -19px;
  position: absolute;
  top: auto;
  bottom: 14%;
  left: auto;
  right: 15px;
  transform: rotateX(0)rotateY(180deg)rotateZ(0);
}

.image-55 {
  max-width: 50%;
  object-fit: contain;
}

.turtle-teach-feature-main-points {
  height: 100%;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  grid-template-rows: auto auto;
  grid-template-columns: minmax(200px, 20%) minmax(200px, 20%) minmax(200px, 20%);
  align-content: start;
  justify-content: center;
  align-items: stretch;
  justify-items: stretch;
  padding-left: 0;
  position: absolute;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.turtle-teach-key-points-text {
  color: #5a4522;
  margin-bottom: 20px;
  font-family: Inter, sans-serif;
  font-size: 16px;
  line-height: 150%;
  display: block;
  position: relative;
}

.turtle-teach-form-text-field {
  width: 65%;
  height: 50px;
  float: left;
  border-style: solid none solid solid;
  border-top-width: 1px;
  border-top-color: #ededed;
  border-bottom-width: 1px;
  border-bottom-color: #ededed;
  border-left-width: 1px;
  border-left-color: #ededed;
  margin-bottom: 0;
}

.turtle-teach-form-text-field.full {
  width: 100%;
  height: 40px;
  float: none;
  color: #5a4522;
  background-color: #fffbf6;
  border: 1px solid #8b6424;
  border-radius: 5px;
  margin-top: 0;
  margin-bottom: 20px;
}

.turtle-teach-form-text-field.full::-ms-input-placeholder {
  color: #667085;
}

.turtle-teach-form-text-field.full::placeholder {
  color: #667085;
}

.turtle-teach-form-text-field.full.area {
  height: auto;
  padding-bottom: 90px;
}

.turtle-teach-form-text-field.full.area.bottom {
  border-bottom-style: none;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
}

.turtle-teach-form-text-field.full.add-space {
  margin-top: 15px;
  margin-bottom: 5px;
}

.turtle-teach-form-text-field.full.top {
  height: 40px;
  border-style: solid;
  border-color: #000;
  border-radius: 5px;
  margin-bottom: 0;
  padding-left: 12px;
}

.turtle-teach-form-text-field.full.top::-ms-input-placeholder {
  color: #667085;
}

.turtle-teach-form-text-field.full.top::placeholder {
  color: #667085;
}

.turtle-teach-form-text-field.full.top.left {
  border-top-right-radius: 0;
}

.turtle-teach-form-text-field.full.top.right {
  border-top-left-radius: 0;
}

.turtle-teach-form-text-field.full.middle {
  color: #5a4522;
  border-bottom-style: none;
  padding-left: 12px;
}

.turtle-teach-form-text-field.full.bottom {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}

.turtle-teach-form-text-field.full.bottom.left {
  border-bottom-right-radius: 0;
}

.turtle-teach-form-text-field.full.bottom.right {
  border-bottom-left-radius: 0;
}

.turtle-teach-form-text-field.full.standalone {
  border-radius: 8px;
}

.image-56 {
  z-index: 4;
  max-height: 80%;
  max-width: 635px;
  min-height: 80%;
  object-fit: contain;
  position: relative;
  top: auto;
  bottom: auto;
  left: auto;
  right: auto;
}

.grid-23 {
  height: auto;
  grid-template-rows: auto;
  position: relative;
}

.form-bg-pattern {
  z-index: 0;
  object-fit: fill;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.image-57 {
  order: 0;
  align-self: center;
  position: static;
  top: 0%;
  bottom: 0%;
  left: auto;
  right: 0%;
}

.div-block-36 {
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  flex-direction: row;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  position: relative;
}

.turtle-teach-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 60px;
  position: static;
}

.tt-grid-with-head {
  height: 100%;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  grid-template: "Area ."
                 "Area-2 Area-2"
                 / 6fr 1fr;
  align-content: center;
  justify-content: stretch;
  padding-left: 40px;
  position: static;
}

.turtle-teach-feature-subgrid {
  grid-template-rows: minmax(auto, 70px) auto auto;
  grid-template-columns: minmax(200px, 80%);
  align-content: start;
  justify-items: center;
  position: relative;
}

.turtle-teach-feature-thumbnail {
  max-width: none;
  object-fit: fill;
  border-radius: 20px;
  position: relative;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, .6);
}

.div-block-37 {
  min-height: 800px;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  flex-direction: row;
  grid-template-rows: auto;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  align-content: stretch;
  justify-content: center;
  align-items: center;
  justify-items: center;
  display: grid;
  position: relative;
}

.turtle-teach-video {
  z-index: 2;
  min-width: 300px;
  min-height: 240px;
  max-height: 100%;
  max-width: 100%;
  clear: both;
  object-fit: scale-down;
  border-radius: 40px;
  justify-content: center;
  align-items: center;
  margin-top: -51px;
  padding-top: 0;
  padding-bottom: 0;
  display: block;
  position: relative;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: 0%;
  overflow: hidden;
}

.turtle-teach-video video {
  width: 100%; /* make sure the video is always full width */
  height: auto; /* height is set automatically based on aspect ratio */
  object-fit: cover; /* maintain aspect ratio while filling container */
}

.heading-15 {
  text-align: center;
}

.user-log-in-log-out {
  background-color: #fffbf6;
}

.user-log-in-log-out.disabled {
  color: #5a4522;
}

.form-wrapper {
  z-index: 50;
  width: 100%;
  max-width: 400px;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  position: relative;
  overflow: visible;
}

.forgot-password-link {
  float: right;
  margin-left: auto;
}

.tooltip-title {
  margin-bottom: 6px;
  font-size: 110%;
  font-weight: 800;
}

.tooltip-wrapper {
  width: 300px;
  color: #333;
  text-align: left;
  background-color: #fafbfe;
  border: 1px solid #d8e3f0;
  border-radius: 10px;
  font-size: 11.5px;
  font-weight: 400;
  line-height: 1.5em;
  display: block;
  position: absolute;
  box-shadow: 1px 1px 8px 1px rgba(45, 62, 80, .12);
}

.tooltip-diamond {
  z-index: 2;
  width: 16px;
  height: 16px;
  background-color: #fafbfe;
  border: 1px solid #d8e3f0;
  border-radius: 2px;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  top: -7px;
  bottom: auto;
  left: 0%;
  right: 0%;
  transform: rotate(45deg);
  box-shadow: 0 -3px 8px rgba(45, 62, 80, .06);
}

.tooltip-diamond.left {
  margin-top: auto;
  margin-bottom: auto;
  top: 0;
  bottom: 10px;
  left: -7px;
  right: auto;
}

.tooltip-svg {
  width: 16px;
  height: 16px;
  justify-content: center;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
  display: flex;
}

.tour-step {
  display: none;
}

.tooltip-author-wrap {
  align-items: center;
  display: flex;
}

.tooltip-anchor {
  z-index: 100;
  width: 100%;
  height: 10px;
  justify-content: center;
  margin-top: 0;
  margin-left: auto;
  margin-right: auto;
  padding-top: 12px;
  display: flex;
  position: absolute;
  top: 100%;
  bottom: 0;
  left: 0%;
  right: 0%;
}

.tooltip-anchor.right {
  width: auto;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
  margin-right: -12px;
  padding-left: 12px;
  top: 0%;
  bottom: 0%;
  left: auto;
  right: 0%;
}

.tooltip-author {
  width: 32px;
  border-radius: 50%;
  margin-right: 10px;
}

.tooltip-close {
  z-index: 5;
  width: 24px;
  height: 24px;
  color: #3f3e46;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  display: flex;
}

.tooltip-close:hover {
  background-color: rgba(0, 42, 255, .1);
}

.tooltip-container {
  z-index: 3;
  background-color: #fafbfe;
  border-radius: 9px 9px 0 0;
  padding: 20px;
  font-size: 12.5px;
  position: relative;
}

.tooltip-navigation {
  z-index: 3;
  min-height: 50px;
  color: #64636e;
  background-color: #fafbfe;
  border-top: 1px solid #d8e3f0;
  border-radius: 0 0 9px 9px;
  justify-content: space-between;
  align-items: center;
  padding: 8px 20px;
  display: flex;
  position: relative;
  bottom: 0;
}

.tooltip-navigation.top {
  border-top-style: none;
  border-bottom: 1px solid #d8e3f0;
  border-radius: 9px 9px 0 0;
}

.relative {
  position: relative;
}

.email-form {
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 10px -20px 20px;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  overflow: hidden;
}

.form-div-line {
  width: 40%;
  height: .8px;
  background-color: #e4e4e4;
}

.text-field-wrapper {
  width: 100%;
  flex-direction: column;
  margin-bottom: 12px;
  display: flex;
}

.text-field-2 {
  height: 42px;
  color: #000;
  border: 1px solid #dcdce5;
  border-radius: 6px;
  margin-bottom: 0;
  font-size: 15px;
  font-weight: 300;
  transition: border-color .2s, box-shadow .2s;
  box-shadow: 0 1px 2px rgba(220, 220, 229, .5);
}

.text-field-2:hover {
  border-color: rgba(0, 0, 0, .8);
  box-shadow: 0 1px 4px rgba(220, 220, 229, .9);
}

.text-field-2:focus {
  border: 1px solid #434de7;
}

.text-field-2::-ms-input-placeholder {
  color: #6e6e6e;
}

.text-field-2::placeholder {
  color: #6e6e6e;
}

.footer-2 {
  text-align: center;
  align-items: flex-start;
  padding-top: 10vh;
  padding-bottom: 5vh;
  font-size: 13px;
}

.social-image {
  width: 24px;
}

.form-wrapper-2 {
  z-index: 50;
  width: 100%;
  max-width: 360px;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  display: flex;
  position: relative;
  overflow: visible;
}

.navbar-2 {
  padding-top: 4vh;
  padding-bottom: 4vh;
}

.flex-row-center {
  justify-content: center;
  align-items: center;
  display: flex;
}

.fake-logo {
  height: 20px;
  color: #333;
  font-size: 20px;
  font-weight: 600;
}

.footer-flex-container {
  text-align: left;
  justify-content: space-between;
  display: flex;
}

.disconnect-link {
  text-align: right;
  padding: 13px;
  text-decoration: underline;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: auto;
  right: 0%;
}

.disconnect-link:hover {
  color: #000;
}

.link-block-10 {
  text-decoration: none;
}

.social-btn {
  width: 100%;
  color: #000;
  border: 1px solid #dcdce5;
  border-radius: 6px;
  margin-bottom: 10px;
  padding: 12px 40px 12px 15px;
  font-size: 15px;
  font-weight: 300;
  text-decoration: none;
  transition: border-color .2s, box-shadow .2s;
  position: relative;
  box-shadow: 0 1px 2px rgba(220, 220, 229, .5);
}

.social-btn:hover {
  box-shadow: none;
  border-color: #374252;
}

.social-btn:focus {
  border: 1px solid #000;
}

.social-btn::-ms-input-placeholder {
  color: #6e6e6e;
}

.social-btn::placeholder {
  color: #6e6e6e;
}

.social-btn.google {
  width: 50%;
}

.social-btn.google:hover {
  border-color: #4285f4;
}

.container-4 {
  padding-left: 5%;
  padding-right: 5%;
}

.button-4 {
  width: 100%;
  height: 45px;
  background-color: #434de7;
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  font-size: 16px;
  font-weight: 400;
  transition: background-color .2s, box-shadow .2s;
  display: flex;
  box-shadow: 0 1px 20px rgba(34, 34, 34, .16);
}

.button-4:hover {
  background-color: #272d88;
  box-shadow: 0 5px 30px rgba(34, 34, 34, .16);
}

.disconnect-image {
  width: 16px;
}

.social-content {
  grid-column-gap: 20px;
  justify-content: center;
  align-items: center;
  display: flex;
}

.field-description {
  color: rgba(0, 0, 0, .6);
  margin-top: 3px;
  font-size: 12px;
  font-weight: 300;
}

.short-page-wrapper {
  width: 100%;
  min-height: 100vh;
  min-width: 50%;
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  position: relative;
  overflow: hidden;
}

.form-div-text {
  min-width: 33%;
  text-align: center;
  flex: none;
}

.link {
  border-bottom: 1px dashed #7b83ff;
  font-weight: 600;
}

.link:hover {
  color: #272d88;
}

.field-label-2 {
  color: #374252;
  margin-bottom: 3px;
  font-size: 13.5px;
  font-weight: 600;
}

.flex-stack-center {
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-left: 5%;
  padding-right: 5%;
  display: flex;
  position: relative;
}

.form-divider {
  width: 100%;
  color: rgba(0, 0, 0, .8);
  letter-spacing: 2px;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: 12px;
  display: flex;
}

.double-click {
  text-align: center;
  font-size: 12px;
  position: absolute;
  top: -27.3203px;
  left: -28.3203px;
  transform: rotate(-30deg);
}

.widget-wrapper {
  z-index: 9999;
  width: 20vw;
  height: 50vh;
  padding: 1vw;
  position: fixed;
  top: auto;
  bottom: 0;
  left: auto;
  right: 0;
}

.ms-iframe {
  z-index: 2147483647;
  height: 70px;
  justify-content: flex-end;
  align-items: flex-end;
  display: flex;
  position: fixed;
  top: auto;
  bottom: 0%;
  left: 0%;
  right: auto;
}

.widget-container {
  z-index: 3;
  height: 100%;
  background-color: #2962ff;
  border: 2px solid #2962ff;
  border-radius: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
  overflow: hidden;
  box-shadow: -7px 7px 30px 1px rgba(0, 0, 0, .2);
}

.widget-mobile {
  display: none;
}

.widget-svg {
  width: 44px;
  height: 44px;
  justify-content: center;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
  display: flex;
}

.widget-close {
  z-index: 5;
  width: 32px;
  height: 32px;
  color: #3f3e46;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  margin-bottom: -.5vw;
  display: flex;
  position: absolute;
  top: auto;
  bottom: 100%;
  left: auto;
  right: 1vw;
}

.widget-close:hover {
  background-color: rgba(0, 42, 255, .1);
}

.ms-iframe-footer-embed {
  width: 100%;
  height: 350px;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 0;
  display: block;
  overflow: hidden;
}

.widget-embed {
  height: 100%;
  min-width: 86vh;
  flex: 1;
}

.ms-iframe-embed {
  width: 180px;
  height: 70px;
  justify-content: flex-end;
  align-items: flex-end;
  display: flex;
  position: relative;
  overflow: visible;
}

.widget-move {
  width: 40px;
  height: 40px;
  opacity: 0;
  color: #fff;
  background-color: #161e27;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  transition: opacity .2s;
  display: flex;
  position: absolute;
  top: auto;
  bottom: 100%;
  left: 0;
  right: 0;
}

.widget-move:hover {
  opacity: 1;
}

.widget-move.left {
  margin: auto 0;
  top: 0;
  bottom: 0;
  left: auto;
  right: 100%;
  transform: rotate(-90deg);
}

.widget-move.down {
  top: 100%;
  bottom: auto;
  transform: rotate(180deg);
}

.widget-move.right {
  margin: auto 0;
  top: 0;
  bottom: 0;
  left: 100%;
  right: auto;
  transform: rotate(90deg);
}

.widget-svg-small {
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
  display: flex;
}

.div-block-38 {
  width: 50px;
}

.div-block-39 {
  height: 50px;
}

.div-block-40 {
  display: flex;
}

.div-block-41 {
  align-self: center;
  display: none;
}

.user-log-in-log-out-2 {
  flex: 0 auto;
  align-self: auto;
}

.link-block-11 {
  display: none;
}

.button-5 {
  width: 20%;
  align-self: center;
}

.school-logos-3 {
  height: 50%;
  max-height: 150px;
  max-width: 220px;
}

@media screen and (max-width: 991px) {
  .page-content {
    width: 100%;
    background-color: #fff;
  }

  .banner {
    height: 500px;
    padding-left: 0;
    padding-right: 0;
  }

  .banner.sub {
    height: auto;
    padding-left: 30px;
    padding-right: 30px;
  }

  .section {
    padding-top: 64px;
    padding-bottom: 64px;
  }

  .section.less-space {
    overflow: hidden;
  }

  .section.school-order {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .nav-menu {
    background-color: #f5f5f7;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .nav-link {
    display: block;
  }

  .nav-link.w--current {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .nav-link.in-footer {
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 0;
  }

  .top-icon-flex.no-left {
    margin-left: 0;
  }

  .banner-second {
    background-image: none;
  }

  .banner-second.normal {
    justify-content: center;
    align-items: center;
    padding-top: 0;
    display: flex;
  }

  .top-title {
    margin-bottom: 32px;
  }

  .logo-wrapper {
    display: block;
  }

  .client-logo {
    width: 33.333%;
    margin-bottom: 10px;
  }

  .align-center {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: 1fr minmax(auto, 1fr);
    grid-template-columns: minmax(363px, .25fr);
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    align-content: stretch;
    justify-content: end;
    justify-items: stretch;
    margin-left: auto;
    padding-top: 157px;
    padding-left: 57px;
    display: grid;
    position: relative;
  }

  .heading-banner {
    margin-bottom: auto;
    margin-left: auto;
    margin-right: auto;
    padding-right: 0;
    font-size: 40px;
    line-height: 50px;
  }

  .heading-banner.smaller.order {
    font-size: 40px;
    line-height: 50px;
  }

  .heading-banner.smaller.shop {
    position: static;
  }

  .top-margin {
    margin-top: 20px;
  }

  .top-margin.main-page {
    margin-right: 10px;
  }

  .button.white.main-page.best-seller {
    margin-top: 0;
    margin-bottom: 0;
    position: static;
  }

  .button.white.main-page.feature {
    margin-bottom: -13px;
  }

  .button.white.main-page.school {
    display: none;
  }

  .button.white.main-page.cookie-kiddle-feature, .button.white.main-page.pearson-feature, .button.white.main-page.school {
    margin-bottom: -13px;
  }

  .button.white.main-page.school._3d {
    display: block;
  }

  .button.white.main-page.turtle-teach {
    margin-bottom: -13px;
  }

  .button.white.distributor.best-seller {
    margin-top: 0;
    margin-bottom: 0;
    position: static;
  }

  .button.white.distributor.feature {
    margin-bottom: -13px;
  }

  .button.white.distributor.school {
    display: none;
  }

  .button.white.distributor.cookie-kiddle-feature, .button.white.distributor.pearson-feature {
    margin-bottom: -13px;
  }

  .product-wrapper {
    min-height: auto;
  }

  .product-wrapper.with-padding.shop {
    grid-column-gap: 16px;
    grid-row-gap: 0px;
    grid-template-rows: auto auto auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    padding-left: 0;
    padding-right: 0;
    display: block;
  }

  .product-image {
    position: static;
  }

  .flex-row.make-vertical {
    flex-direction: column;
  }

  .footer-left-part.right-now {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: flex-start;
    margin-top: auto;
    margin-bottom: 16px;
    display: grid;
  }

  .copyright {
    margin-bottom: 20px;
  }

  .align-right.make-left {
    text-align: left;
  }

  .top-title-text-2.in-left {
    color: #5a4522;
  }

  .sidebar {
    margin-bottom: 40px;
    padding-left: 7.5px;
  }

  .form-block-2 {
    width: 80%;
  }

  .utility-page-content {
    width: 260px;
  }

  .right-padding {
    margin-top: 50px;
    padding-left: 0;
  }

  .product-item {
    width: 50%;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: minmax(200px, 200px) minmax(140px, 140px) minmax(66px, .5fr) auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: space-between;
    justify-content: space-between;
    align-items: center;
    justify-items: center;
    margin-bottom: 40px;
    display: grid;
  }

  .product-item.shop {
    width: 100%;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    grid-template-rows: minmax(300px, 350px) minmax(0, 100px);
  }

  .menu-button {
    float: none;
    text-align: center;
    padding-top: 7px;
    padding-bottom: 7px;
    display: inline-block;
  }

  .menu-button.w--open {
    background-color: #212127;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .heading-description-heading {
    margin-bottom: 18px;
    font-size: 32px;
  }

  .nav-bar {
    margin-right: 0;
    position: relative;
  }

  .product-actual-image {
    height: auto;
    object-fit: scale-down;
    position: relative;
  }

  .image-2 {
    height: 100px;
  }

  .div-block-2 {
    padding-right: 0;
  }

  .top-menu-nav-div {
    max-width: none;
    color: #fffbf6;
    background-color: #fffbf6;
  }

  .top-menu-nav-div.mobile {
    width: auto;
  }

  .menu-button-2 {
    background-color: #fffbf6;
  }

  .menu-button-2.w--open {
    color: #fffbf6;
    background-color: #fffbf6;
  }

  .icon-2 {
    color: #f05023;
  }

  .div-block-4 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: -13px;
    margin-bottom: auto;
    display: grid;
  }

  .div-block-5 {
    justify-content: flex-start;
    align-items: center;
    display: flex;
  }

  .nav-link-language-1 {
    padding-left: 0;
    display: block;
  }

  .nav-link-language-1.w--current {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .nav-link-language-1.in-footer {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-right: 0;
  }

  .nav-link-language-2 {
    margin-left: 20px;
    margin-right: 0;
    padding-left: 0;
    padding-right: 20px;
    display: block;
  }

  .nav-link-language-2.w--current {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .nav-link-language-2.in-footer {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-right: 0;
  }

  .top-menu-nav-lang-div {
    width: auto;
    max-width: 50px;
    grid-column-gap: 0px;
    grid-row-gap: 16px;
    grid-template-rows: minmax(auto, 19px);
    grid-template-columns: .5fr 1fr 1fr;
    grid-auto-columns: 1fr;
    align-content: stretch;
    justify-content: start;
    align-items: center;
    justify-items: start;
    margin-top: 40px;
    display: grid;
  }

  .paragraph-2 {
    width: 448px;
    margin-bottom: auto;
    margin-left: auto;
    margin-right: auto;
    font-size: 18px;
  }

  .heroaccolades {
    width: 35%;
    max-width: none;
  }

  .brand-2.w--current {
    min-width: 20%;
    order: 1;
    position: relative;
  }

  .product-actual-image-variant {
    height: auto;
  }

  .top-menu-div {
    height: 100%;
    order: -1;
    margin-right: 0;
    display: block;
  }

  .section-title {
    margin-top: 16px;
  }

  .section-title.orange {
    margin-top: 59px;
  }

  .cards-grid-container {
    grid-column-gap: 20px;
  }

  .demo-buy-button, .button-3 {
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .herohksda {
    z-index: 5;
    width: auto;
    height: auto;
    max-height: none;
    max-width: 80%;
    text-align: left;
    object-fit: fill;
    margin-left: 10px;
    margin-right: 10px;
    padding-bottom: 10px;
    display: block;
    position: relative;
    bottom: auto;
    left: auto;
  }

  .language-dropdown {
    display: none;
  }

  .language-icon {
    margin-left: 20px;
  }

  .heropattern {
    z-index: 1;
    width: auto;
    margin-left: auto;
    top: 5%;
    bottom: auto;
    left: auto;
    right: 0%;
  }

  .herowhitebanner {
    position: absolute;
    bottom: 0;
  }

  .background-video-3.cookiekiddle {
    border-radius: 40px;
  }

  .characterdiv2 {
    z-index: 5;
    top: 133px;
    left: 29%;
  }

  .characterdiv1 {
    top: 162px;
    left: 14%;
  }

  .characterdiv3 {
    line-height: 20px;
    top: 75%;
    bottom: 0%;
    left: -13%;
    right: 0%;
  }

  .column-8 {
    padding-left: 2px;
    padding-right: 2px;
  }

  .retail-grid {
    padding-left: 10px;
    padding-right: 10px;
  }

  .feature-section {
    width: 100%;
    min-height: 600px;
    justify-content: center;
    margin-top: 5px;
    margin-bottom: 67px;
    padding-right: 40px;
    overflow: hidden;
  }

  .feature-grid {
    grid-template-rows: 1fr auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: row;
    margin-left: auto;
    margin-right: auto;
  }

  .feature-video-1 {
    display: block;
  }

  .retail-location-section {
    overflow: hidden;
  }

  .operation-section {
    overflow: visible;
  }

  .image-31 {
    top: -100px;
  }

  .text-block-14 {
    margin-right: 0;
  }

  .school-section-image {
    max-width: none;
    position: static;
  }

  .best-sellers-section {
    background-color: #fff;
    margin-top: 0;
    padding-top: 60px;
    padding-bottom: 60px;
    overflow: hidden;
  }

  .cookie-kiddle-section {
    z-index: auto;
    overflow: hidden;
  }

  .pearson-section {
    margin-bottom: auto;
    overflow: hidden;
  }

  .buy-now-section {
    overflow: hidden;
  }

  .grid-11 {
    margin-left: 0;
    margin-right: 0;
    padding-left: 20px;
    padding-right: 20px;
  }

  .columns-2 {
    display: none;
  }

  .pagination.products {
    top: 101%;
  }

  .pagination.customer-reviews {
    top: 50%;
  }

  .cookie-kiddle-eclipse {
    z-index: 1;
    min-width: 300px;
    object-fit: cover;
    margin-left: auto;
    display: block;
    position: absolute;
    top: auto;
    bottom: auto;
    left: 0%;
    right: auto;
  }

  .cookie-kiddle-image {
    z-index: 0;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .cookie-kiddle-turtle {
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .cookie-kiddle-award {
    left: 4%;
  }

  .cookie-kiddle-unicorn {
    position: absolute;
    top: 265px;
    bottom: 0%;
    left: 71%;
    right: 0%;
  }

  .cookie-kiddle-dino {
    position: absolute;
    top: 265px;
    bottom: 0%;
    left: 32%;
    right: 0%;
  }

  .cookie-kiddle-submarine {
    display: none;
  }

  .retail-geo-text {
    font-size: 16px;
  }

  .pearson-section-column-2 {
    z-index: 1;
    margin-bottom: auto;
    padding-top: 0%;
  }

  .image-35 {
    width: 100%;
    height: 100%;
    max-width: none;
    min-height: 0%;
    object-fit: cover;
    position: relative;
    top: auto;
    left: auto;
  }

  .operation-section-column-2 {
    padding-top: 0%;
    padding-left: 0;
    padding-right: 0;
  }

  .operation-section-list {
    margin-bottom: auto;
  }

  .pearson-section-image {
    z-index: 2;
  }

  .pearson-product-1 {
    width: auto;
    left: 10%;
  }

  .pearson-product-2 {
    width: auto;
    height: auto;
    left: 31%;
  }

  .list {
    margin-top: 51px;
    margin-right: auto;
    padding-left: 60px;
    padding-right: 60px;
  }

  .div-block-21 {
    margin-top: -13px;
  }

  .hero-turtle {
    left: 17%;
  }

  .hero-dino {
    right: 73px;
  }

  .hero-unicorn {
    top: -22px;
    left: auto;
  }

  .characterdiv-columns {
    height: 100%;
  }

  .pearson-section-column-1 {
    z-index: 6;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template: "."
                   "Area"
                   "."
                   / minmax(33px, 1fr);
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    align-content: center;
    padding-left: 40px;
    padding-right: 40px;
    display: grid;
    top: auto;
    bottom: auto;
  }

  .column-14 {
    justify-content: flex-start;
    align-items: stretch;
    display: flex;
  }

  .columns-6 {
    justify-content: center;
    align-items: center;
    display: none;
  }

  .pearson-logo-mobile {
    z-index: 2;
    position: absolute;
  }

  .collection-list-7 {
    align-items: stretch;
    justify-items: center;
  }

  .hero-turtle-div {
    margin-bottom: -22px;
    margin-left: 10px;
  }

  .hero-dino-div {
    z-index: 2;
    margin-top: 89px;
    margin-left: 41px;
  }

  .hero-unicorn-div {
    margin-left: 51px;
    left: 38%;
  }

  .heroeduhk {
    z-index: 5;
    max-width: 80%;
    padding-left: 0;
  }

  ._w-accordion-item-a.job-posting-text {
    grid-column-gap: 1px;
    grid-row-gap: 1px;
  }

  .nav-link-language-3 {
    color: #f05023;
    margin-left: 20px;
    margin-right: 0;
    padding-left: 0;
    padding-right: 20px;
    display: block;
  }

  .nav-link-language-3.w--current {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .nav-link-language-4 {
    color: #f05023;
    padding-left: 20px;
    display: block;
  }

  .nav-link-language-4.w--current {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .top-menu-div-mobile {
    height: 100%;
    margin-right: 0;
    display: none;
  }

  .cookie-kiddle-award-mobile {
    left: 4%;
  }

  .herowhitebanner-copy {
    bottom: -1px;
  }

  .pearson-eclipse {
    z-index: 0;
    min-width: 100%;
    object-fit: cover;
    margin-left: auto;
    display: block;
    position: absolute;
    top: auto;
    bottom: auto;
    left: 0%;
    right: auto;
  }

  .div-block-26 {
    position: static;
  }

  .grid-18 {
    grid-template-rows: auto auto;
    padding-left: 20px;
    padding-right: 20px;
  }

  .school-grid {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    grid-template-columns: 1fr 1fr;
  }

  .school-div._1 {
    width: 100%;
    height: auto;
    padding: 0;
  }

  .buy-now-grid {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    grid-template-columns: 1fr 1fr;
  }

  .buy-now-div._1 {
    width: 100%;
    height: auto;
    padding: 0;
  }

  .remove {
    max-width: none;
    position: static;
  }

  .character-bio.turtle {
    z-index: 6;
  }

  .cookie-kiddle-video {
    z-index: 0;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .customer-reviews-section {
    width: auto;
    height: auto;
    min-height: 700px;
    padding-top: 60px;
    padding-bottom: 60px;
    overflow: hidden;
  }

  .customer-reviews-collection-wrapper-desktop {
    height: auto;
    padding-left: 10px;
    padding-right: 10px;
  }

  .customer-reviewer-collection-item {
    justify-content: center;
    align-items: center;
    padding-left: 0;
    padding-right: 0;
    display: flex;
  }

  .customer-review-item-div {
    width: 90%;
    height: 500px;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    -webkit-text-fill-color: inherit;
    background-clip: border-box;
    border: 1px #000;
    border-radius: 0;
    grid-template-rows: minmax(50%, 50%) auto;
    grid-template-columns: minmax(auto, auto);
    grid-auto-columns: 1fr;
    display: grid;
  }

  .customer-review-text-div {
    height: 100%;
    grid-column-gap: 16px;
    grid-row-gap: 0px;
    background-color: #fff;
    border-radius: 0 0 25px 22px;
    grid-template-rows: auto minmax(auto, 50px);
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    display: grid;
  }

  .rich-text-block-4 {
    text-align: left;
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
  }

  .customer-review-image {
    object-fit: cover;
    border-radius: 22px 22px 0 0;
  }

  .rich-text-block-5 {
    color: #f05023;
    text-align: left;
    font-weight: 400;
  }

  .customer-review-title {
    color: #f05023;
    text-align: left;
    font-weight: 700;
  }

  .customer-review-text {
    height: auto;
    max-height: none;
    text-align: left;
    overflow: visible;
  }

  .pagination-2 {
    position: static;
  }

  .customer-review-pagination {
    z-index: 99;
    height: auto;
    min-height: 200px;
    min-width: 100%;
    margin-top: -200px;
    position: absolute;
  }

  .customer-review-pagination.products {
    top: 101%;
  }

  .previous-3 {
    position: absolute;
  }

  .customer-reviews-collection-wrapper-mobile {
    height: auto;
    padding-left: 10px;
    padding-right: 10px;
    display: none;
  }

  .image-42 {
    right: 10%;
  }

  .red-dot {
    z-index: 9;
    position: absolute;
    top: 16%;
    bottom: auto;
    left: auto;
    right: 25%;
  }

  .testimonial-div {
    grid-column-gap: 9px;
    grid-template-columns: 32% 32% 32%;
    margin-left: 0;
    margin-right: 0;
  }

  .testimonial-image._1 {
    width: 100%;
  }

  .testimonial-grid {
    grid-template-rows: 40% 60%;
  }

  .testimonial-text {
    font-size: 14px;
    line-height: 20px;
  }

  .left-arrow-2, .right-arrow-3 {
    display: none;
  }

  .animation-detection-div {
    top: 0%;
    bottom: auto;
    left: 0%;
    right: auto;
  }

  .feature-dino-div {
    z-index: 2;
    margin-top: 0;
    margin-left: 10px;
    bottom: 5%;
  }

  .feature-unicorn-div {
    margin-left: 0;
    margin-right: 10px;
    top: auto;
    bottom: 4%;
    left: auto;
    right: 0%;
  }

  .unicorn {
    top: -22px;
    left: 54%;
  }

  .unicorn.feature {
    top: auto;
    bottom: auto;
    left: auto;
  }

  .grid-21 {
    width: 35%;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    grid-template-rows: 100px 100px minmax(60px, 1fr);
    grid-template-columns: 33% 33% repeat(auto-fit, 33%);
    grid-template-areas: "."
                         "."
                         ".";
    align-content: stretch;
    justify-content: stretch;
    align-items: stretch;
    justify-items: end;
    margin-right: 10px;
    padding-top: 0;
    position: absolute;
    top: auto;
    bottom: 4%;
    left: auto;
    right: 0%;
  }

  .text-block-20 {
    z-index: 6;
    width: 100%;
    color: #fff;
    text-align: center;
    margin-left: 20px;
    display: block;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: auto;
    right: -104%;
  }

  .grid-21-cookie-kiddle {
    width: 35%;
    grid-column-gap: 2px;
    grid-row-gap: 2px;
    grid-template: "." 100px
    / 33% 33% 33%;
    align-content: stretch;
    justify-content: stretch;
    justify-items: end;
    margin-right: 10px;
    position: absolute;
    top: auto;
    bottom: 8%;
    left: auto;
    right: 0%;
  }

  .nav-link-turtle-teach {
    display: block;
  }

  .nav-link-turtle-teach.w--current {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .nav-link-turtle-teach.in-footer {
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 0;
  }

  .app-store {
    z-index: 5;
    padding-left: 0;
  }

  .turtle-teach-section {
    max-height: none;
    min-height: 0;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding-left: 60px;
    padding-right: 60px;
    display: block;
  }

  .turtle-teach-grid {
    max-height: none;
    min-height: 0;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    display: grid;
  }

  .turtle-teach-illustration-div._1 {
    width: 100%;
    height: auto;
    padding: 0;
  }

  .turtle-teach-hero-title {
    font-family: sofia-pro-soft, sans-serif;
    font-size: 36px;
  }

  .turtle-teach-signup-form {
    padding: 64px 40px;
  }

  .turtle-teach-signup-form.less-space {
    overflow: hidden;
  }

  .turtle-teach-signup-form.school-order {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .grid-22 {
    height: 70%;
    max-width: 90%;
    align-items: center;
    justify-items: center;
    padding-left: 0;
  }

  .image-54 {
    max-height: none;
    max-width: 100%;
    object-fit: scale-down;
    display: inline-block;
  }

  .turtle-teach-feature-section {
    width: 100%;
    min-height: 600px;
    justify-content: center;
    margin-top: 0;
    margin-bottom: 0;
    padding-right: 40px;
    display: flex;
    overflow: hidden;
  }

  .turtle-teach-hero-container {
    padding-left: 40px;
    padding-right: 40px;
  }

  .turtle-teach-feature-dino-div {
    z-index: 2;
    margin-top: 0;
    margin-left: 10px;
    bottom: 5%;
  }

  .turtle-teach-feature-unicorn-div-copy {
    margin-left: 0;
    margin-right: 10px;
    top: auto;
    bottom: 4%;
    left: auto;
    right: 0%;
  }

  .turtle-teach-hero-turtle-div {
    margin-bottom: -22px;
  }

  .turtle-teach-feature-main-points {
    grid-template-rows: auto auto;
    padding-left: 20px;
    padding-right: 20px;
  }

  .image-56 {
    max-width: 100%;
    object-fit: scale-down;
  }

  .grid-23 {
    grid-column-gap: 0px;
    position: relative;
  }

  .turtle-teach-image {
    max-width: none;
    position: static;
  }

  .tt-grid-with-head {
    grid-template-rows: auto auto;
    padding-left: 20px;
    padding-right: 20px;
  }

  .footer-2 {
    padding-left: 20px;
    padding-right: 20px;
  }

  .short-page-wrapper {
    height: auto;
    flex-direction: column;
  }
}

@media screen and (max-width: 767px) {
  .banner {
    height: 600px;
  }

  .banner.sub {
    height: auto;
    padding-left: 30px;
    padding-right: 30px;
    position: static;
  }

  .section {
    padding-top: 48px;
    padding-bottom: 48px;
  }

  .section.school-order {
    padding-bottom: 40px;
  }

  .container.center {
    padding-left: 32px;
    padding-right: 32px;
  }

  .navbar {
    padding-bottom: 0;
    padding-left: 10px;
    padding-right: 10px;
  }

  .brand.w--current {
    margin-bottom: 0;
  }

  .top-banner {
    padding-top: 0;
    padding-bottom: 0;
  }

  .cart-button {
    width: 36px;
    height: 36px;
  }

  .cart {
    width: 18px;
    height: 18px;
  }

  .banner-second.normal {
    z-index: 1;
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
    position: relative;
  }

  .top-title {
    margin-bottom: 0;
  }

  .top-title-text {
    margin-bottom: 20px;
  }

  .top-title-text.job-posting.subtitle {
    margin-top: auto;
    margin-bottom: auto;
  }

  .top-title-text.form-section {
    font-size: 24px;
    font-weight: 400;
    line-height: 32px;
  }

  .client-logo {
    width: 33.333%;
    padding: 20px 30px;
  }

  .align-center {
    grid-row-gap: 9px;
    text-align: center;
    justify-content: center;
    align-items: stretch;
    justify-items: center;
    margin-top: 300px;
    padding-left: 0;
  }

  .heading-banner {
    text-align: center;
    margin-bottom: auto;
    font-size: 30px;
  }

  .heading-banner.smaller {
    padding-left: 24px;
    padding-right: 24px;
    font-size: 34px;
    line-height: 46px;
  }

  .heading-banner.smaller.order {
    font-size: 30px;
    line-height: 40px;
  }

  .heading-banner.smaller.career {
    margin-bottom: 20px;
  }

  .heading-banner.smaller {
    padding-left: 24px;
    padding-right: 24px;
    font-size: 34px;
    line-height: 46px;
  }

  .heading-banner.smaller.school-order {
    font-size: 36px;
  }

  .top-margin.main-page {
    justify-content: center;
    margin-right: auto;
    display: flex;
  }

  .button.white {
    font-size: 16px;
  }

  .button.white.main-page {
    max-width: none;
    margin: auto;
    position: static;
    top: auto;
    bottom: 0%;
    left: auto;
    right: auto;
  }

  .button.white.main-page.hero {
    margin-top: auto;
    top: auto;
  }

  .button.white.main-page.buy-now {
    margin-top: auto;
    position: relative;
  }

  .button.white.main-page.feature {
    margin-bottom: 20px;
  }

  .button.white.main-page.school {
    display: none;
  }

  .button.white.main-page.cookie-kiddle-feature {
    margin-bottom: 20px;
  }

  .button.white.main-page.cookie-kiddle-feature._3d.product-page {
    top: 124px;
  }

  .button.white.main-page.pearson-feature, .button.white.main-page.school, .button.white.main-page.turtle-teach {
    margin-bottom: 20px;
  }

  .button.white.main-page.turtle-teach._3d {
    left: 0%;
  }

  .button.white.distributor {
    max-width: none;
    margin: auto;
    position: static;
    top: auto;
    bottom: 0%;
    left: auto;
    right: auto;
  }

  .button.white.distributor.hero {
    margin-top: auto;
    top: auto;
  }

  .button.white.distributor.buy-now {
    margin-top: auto;
    position: relative;
  }

  .button.white.distributor.feature {
    margin-bottom: 20px;
  }

  .button.white.distributor.school {
    display: none;
  }

  .button.white.distributor.cookie-kiddle-feature, .button.white.distributor.pearson-feature {
    margin-bottom: 20px;
  }

  .subscribe-flex {
    flex-direction: column;
  }

  .subscribe-text {
    margin-bottom: 20px;
    margin-right: 0;
  }

  .product-wrapper {
    min-height: 400px;
  }

  .product-wrapper.with-padding {
    padding-left: 0;
    padding-right: 0;
  }

  .product-wrapper.with-padding.shop {
    display: block;
  }

  .product-image {
    object-fit: fill;
  }

  .footer-left-part.right-now {
    flex-direction: column;
    grid-template-columns: 1fr 1.25fr;
  }

  .footer-column {
    width: 100%;
    margin-top: 40px;
  }

  .footer-column.no-top-margin {
    margin-top: 0;
  }

  .form-block-2 {
    width: 100%;
  }

  .cart-product-name {
    text-align: left;
  }

  .product-item {
    width: 100%;
    min-height: auto;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: minmax(0, 170px) minmax(140px, 193px) minmax(66px, .5fr) auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: space-between;
    justify-content: flex-end;
    align-items: center;
    justify-items: center;
    display: grid;
  }

  .product-item.shop {
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    justify-content: space-between;
  }

  .menu-button {
    margin-top: 10px;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .menu-button.w--open {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .cart-quantity {
    min-width: 14px;
    top: -6px;
    right: -6px;
  }

  .container-description {
    flex-direction: column;
  }

  .description-text-container {
    align-self: flex-start;
    margin-top: 8px;
    margin-bottom: 32px;
    padding-right: 0;
  }

  .description-video {
    width: 100%;
  }

  .nav-bar {
    margin-right: 0;
  }

  .product-actual-image {
    height: auto;
    object-fit: fill;
    position: static;
  }

  .div-block-2 {
    align-self: center;
  }

  .menu-button-2 {
    transition-duration: 1s;
  }

  .menu-button-2.w--open:active {
    transform: none;
  }

  .icon-2 {
    color: #f05023;
  }

  .rich-text-about-us figure {
    width: auto;
  }

  .description-image, .description-image-container {
    width: 100%;
  }

  .div-block-5 {
    max-width: 100%;
    justify-content: flex-start;
  }

  .paragraph-2 {
    width: 80%;
    text-align: center;
    margin: auto;
    font-size: 18px;
    line-height: 150%;
  }

  .icon-3 {
    margin-bottom: 32px;
    margin-left: 32px;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .icon-4 {
    margin-bottom: 32px;
    margin-right: 32px;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .slide-nav {
    margin-bottom: 28px;
    display: none;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .image-5 {
    align-self: flex-end;
    padding-bottom: 28px;
  }

  .heroaccolades {
    width: 100%;
    max-width: 95%;
    margin-top: 0;
    display: block;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: auto;
    right: -44%;
    transform: translate(-50%);
  }

  .image-5-copy {
    align-self: flex-end;
    padding-bottom: 28px;
  }

  .brand-2 {
    order: 1;
  }

  .brand-2.w--current {
    padding-left: 0;
    left: 0;
    right: 0;
  }

  .image-7 {
    margin-right: 8px;
  }

  .product-actual-image-variant {
    height: auto;
  }

  .text-block-3 {
    line-height: 30px;
  }

  .div-block-9 {
    margin-right: 8px;
  }

  .avilable-for-ipad {
    height: 50px;
  }

  .link-block, .link-block-2 {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .top-menu-div {
    display: block;
  }

  .text-block-6 {
    margin-left: 16px;
    margin-right: 16px;
    font-size: 16px;
  }

  .section-title {
    margin-top: 51px;
    font-size: 30px;
  }

  .section-title.orange {
    margin-top: 50px;
  }

  .image-holder {
    flex-direction: column;
  }

  .image-10, .image-11, .image-12 {
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .grid-3 {
    width: 90%;
    margin-top: 0;
  }

  .school-logos {
    width: 100%;
  }

  .column-2 {
    flex-direction: row;
    align-items: stretch;
    position: relative;
    overflow: visible;
  }

  .cards-section {
    padding: 40px 20px;
  }

  .cards-grid-container {
    max-width: none;
    grid-template-rows: auto auto auto;
    grid-template-columns: 1fr;
    align-self: stretch;
  }

  .demo-buy-button, .button-3 {
    justify-content: center;
    align-items: center;
    padding-top: 9px;
    display: flex;
  }

  .herohksda {
    z-index: 5;
    width: auto;
    height: 120px;
    max-height: none;
    max-width: 100%;
    min-height: 100px;
    object-fit: contain;
    border-radius: 10px;
    display: block;
    position: static;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .heading-7 {
    position: static;
  }

  .retail-logo {
    max-width: 90%;
  }

  .retail-logo.clickable {
    max-width: 90%;
    border-radius: 3px;
  }

  .location-text {
    font-size: 24px;
  }

  .language-dropdown {
    display: none;
  }

  .herocontainer {
    max-height: 1100px;
    min-height: 1250px;
  }

  .heropattern {
    top: 25%;
  }

  .herowhitebanner {
    margin-top: -200px;
    position: absolute;
    top: auto;
  }

  .heroorange {
    z-index: 1;
    position: absolute;
    top: auto;
    left: auto;
    right: -6%;
  }

  .background-video-3 {
    width: 99%;
  }

  .characterdiv2 {
    margin-top: 0;
    margin-left: 0;
    display: none;
    position: static;
    top: auto;
    bottom: auto;
    left: auto;
  }

  .text-block-12 {
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .column-6 {
    height: 50px;
    align-items: center;
    padding-left: 0;
    padding-right: 0;
    display: flex;
  }

  .column-7 {
    height: 50px;
    justify-content: flex-end;
    align-items: center;
    padding-left: 0;
    padding-right: 0;
  }

  .characterdiv1 {
    margin-top: 0;
    margin-left: 0;
    display: none;
    position: static;
    top: auto;
    bottom: auto;
    left: auto;
  }

  .characterdiv3 {
    margin-top: 0;
    margin-left: 0;
    display: none;
    position: static;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .column-8 {
    padding-left: 0;
    padding-right: 0;
  }

  .feature-section {
    width: 95%;
    min-height: 350px;
    margin-top: auto;
    overflow: visible;
  }

  .feature-grid {
    width: 100%;
  }

  .feature-video-1 {
    display: block;
  }

  .feature-text {
    z-index: 998;
    font-size: 16px;
    display: block;
  }

  .retail-location-section {
    width: 95%;
    min-height: auto;
    margin-left: auto;
    margin-right: auto;
    padding-top: 20px;
    padding-bottom: 0;
  }

  .operation-section {
    min-height: 950px;
    margin-top: 168px;
    margin-bottom: auto;
    overflow: visible;
  }

  .text-block-14 {
    width: 90%;
    text-align: center;
    margin-top: 0;
    margin-left: auto;
    margin-right: auto;
    position: static;
    top: 0%;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .operation-video {
    margin-top: 22px;
  }

  .column-9 {
    height: 50%;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .column-10 {
    height: 50%;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template: "Area"
                   "."
                   / 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-items: center;
    justify-items: center;
    margin-top: auto;
    padding-top: 0%;
    padding-left: 0;
    padding-right: 0;
    display: grid;
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .school-section {
    min-height: 800px;
  }

  .school-section-image {
    position: static;
  }

  .school-section-logos {
    height: auto;
    padding-bottom: 60px;
  }

  .best-sellers-section {
    min-height: 750px;
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .cookie-kiddle-section {
    min-height: 750px;
    justify-content: center;
    display: flex;
    overflow: hidden;
  }

  .pearson-section {
    min-height: 800px;
    align-items: center;
  }

  .buy-now-section {
    max-height: none;
    min-height: 800px;
  }

  .buy-now-section-title {
    margin-top: 0;
    margin-bottom: 0;
    position: static;
  }

  .div-block-17 {
    width: 90%;
    margin-left: 0;
    margin-right: 0;
  }

  .footer-div-block-1 {
    height: 40%;
    justify-content: center;
    align-items: flex-start;
    display: flex;
  }

  .school-logo-div {
    width: 100%;
    margin-bottom: 0;
  }

  .grid-11 {
    justify-content: stretch;
    justify-items: center;
  }

  .columns-2 {
    justify-content: center;
    display: none;
  }

  .text-block-16 {
    z-index: 1;
    text-align: center;
    margin: 10% 20px 0;
    padding-left: 0;
    padding-right: 0;
    font-size: 20px;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .previous {
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: auto;
  }

  .collection-list-3 {
    margin-top: 73px;
  }

  .pagination.products {
    justify-content: space-between;
    align-items: center;
    margin-top: 0%;
    display: flex;
    position: relative;
    top: -50%;
  }

  .pagination.customer-reviews {
    justify-content: space-between;
    align-items: center;
    margin-top: 0%;
    display: flex;
    position: absolute;
    top: 50%;
  }

  .next {
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: auto;
    right: 0%;
  }

  .cookie-kiddle-eclipse {
    display: none;
  }

  .cookie-kiddle-image {
    z-index: auto;
    width: auto;
    height: 50%;
    max-width: none;
    min-height: auto;
    min-width: 100%;
    object-fit: cover;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .columns-3 {
    grid-template-areas: "Area"
                         "Area-2";
    display: block;
  }

  .cookie-kiddle-turtle {
    max-height: none;
    max-width: 40%;
    margin-right: 5%;
    top: auto;
    bottom: 0%;
    left: auto;
    right: 0%;
  }

  .cookie-kiddle-pattern {
    height: auto;
    margin-top: auto;
  }

  .cookie-kiddle-award {
    width: 20%;
    max-width: 20%;
    display: none;
    top: auto;
    bottom: 4%;
  }

  .cookie-kiddle-logo {
    z-index: 0;
    max-width: 40%;
    margin-left: 0;
    top: auto;
    bottom: 4%;
    left: 4%;
  }

  .cookie-kiddle-unicorn, .cookie-kiddle-dino {
    display: none;
  }

  .cookie-kiddle-submarine {
    max-width: 40%;
    display: block;
    top: auto;
    bottom: -12%;
    left: auto;
    right: 0;
  }

  .cookie-kiddle-collection-list-wrapper {
    z-index: 3;
    justify-content: center;
    align-items: center;
    margin-top: 0;
    margin-left: 0;
    display: flex;
    position: absolute;
    top: auto;
    left: 0;
    right: 0;
  }

  .collection-list-4, .collection-item {
    justify-content: center;
    align-items: center;
    display: flex;
    position: static;
  }

  .retail-geo-text {
    font-size: 16px;
  }

  .pearson-section-column-2 {
    height: 70%;
    background-color: #fcbe4b;
    justify-content: center;
    display: flex;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .collection-list-wrapper-6 {
    height: 100%;
    position: static;
  }

  .collection-item-2 {
    width: 100%;
    position: absolute;
  }

  .collection-list-5 {
    height: 100%;
  }

  .image-35 {
    width: 100%;
    height: 100%;
    max-width: 100%;
    object-fit: cover;
    margin-left: 0;
    position: static;
  }

  .buy-now-text {
    text-align: center;
    position: static;
  }

  .school-section-column-1 {
    height: 50%;
  }

  .school-section-column-2 {
    height: 50%;
    justify-content: center;
    padding-right: 20px;
    display: flex;
    top: 50%;
  }

  .operation-section-column-1 {
    top: -20%;
  }

  .operation-section-column-2 {
    height: 40%;
    padding-top: 0%;
    padding-right: 20px;
    top: auto;
    bottom: 11%;
    left: 0%;
    right: 0%;
  }

  .operation-section-list {
    font-size: 18px;
  }

  .pearson-section-image {
    width: auto;
    height: auto;
    max-height: 100%;
    max-width: 30%;
    min-width: 0%;
    margin: auto;
    position: static;
    top: 14%;
    left: auto;
  }

  .pearson-product-1 {
    height: auto;
    max-height: 50%;
    max-width: 70%;
    min-height: 0%;
    object-fit: fill;
    margin-top: 0;
    margin-right: -50%;
    top: auto;
    bottom: 5%;
    left: 23%;
  }

  .pearson-product-2 {
    max-height: 50%;
    max-width: 70%;
    min-height: 0%;
    object-fit: fill;
    margin-top: 0;
    margin-left: -50%;
    top: auto;
    bottom: 5%;
    left: auto;
    right: 23%;
  }

  .list {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 70px;
    margin-left: 60px;
    margin-right: 60px;
    font-size: 18px;
    display: block;
  }

  .grid-13 {
    grid-template-columns: 1fr 1fr;
  }

  .hero-turtle {
    z-index: 2;
    width: auto;
    height: 200px;
    max-width: none;
    position: relative;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .hero-dino {
    width: auto;
    height: 200px;
    max-width: none;
    margin-left: 0;
    position: relative;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .hero-unicorn {
    width: auto;
    height: 200px;
    max-width: none;
    position: relative;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .grid-14 {
    width: 95%;
    height: auto;
    max-width: 100%;
    grid-template-columns: 30% 30% 1fr;
    align-content: center;
    align-items: center;
    justify-items: center;
    margin-top: 300px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    top: auto;
    bottom: 15%;
    left: 0%;
    right: 0%;
  }

  .characterdiv-columns {
    height: 100%;
    justify-content: center;
    align-items: center;
    margin-top: auto;
    margin-bottom: auto;
    position: static;
  }

  .slide-nav-2 {
    margin-bottom: 0;
    position: static;
  }

  .right-arrow-2 {
    display: none;
  }

  .pearson-section-column-1 {
    height: 30%;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto auto;
    grid-template-columns: minmax(33px, 1fr);
    grid-auto-columns: 1fr;
    align-content: stretch;
    justify-content: center;
    padding-left: 20px;
    display: grid;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .pearson-logo-desktop {
    object-fit: fill;
    display: none;
  }

  .column-14 {
    padding-left: 0;
    padding-right: 0;
  }

  .column-15 {
    margin-top: auto;
  }

  .columns-6 {
    display: none;
  }

  .grid-15 {
    grid-template-rows: minmax(50px, 1fr) auto auto;
    align-content: stretch;
    justify-content: stretch;
    align-items: center;
    justify-items: center;
  }

  .text-block-16-copy {
    text-align: center;
    font-size: 18px;
  }

  .hero-column {
    z-index: 2;
    position: absolute;
    top: auto;
  }

  .hero-column-video {
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    padding-top: 0;
    display: flex;
  }

  .pearson-logo-mobile {
    width: 40%;
    max-width: 80%;
    object-fit: fill;
    margin: auto;
    display: block;
    position: static;
    top: 0%;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .hero-turtle-div {
    width: auto;
    max-width: none;
    margin: 0 0 auto;
    position: relative;
    bottom: auto;
    left: auto;
  }

  .hero-dino-div {
    z-index: auto;
    width: auto;
    max-width: none;
    margin-top: 0;
    margin-bottom: auto;
    margin-left: 0;
    padding-left: 0;
    position: relative;
    bottom: auto;
    left: auto;
  }

  .hero-unicorn-div {
    width: auto;
    max-width: none;
    object-fit: fill;
    margin-bottom: auto;
    margin-left: 0;
    position: relative;
    bottom: auto;
    left: auto;
  }

  .heroeduhk {
    z-index: 5;
    width: 100%;
    height: 80%;
    max-width: 80%;
    padding-left: 10px;
    padding-right: 10px;
    position: relative;
  }

  .characterdiv1-mobile, .characterdiv2-mobile, .characterdiv3-mobile {
    width: 160px;
    height: 50px;
    display: block;
    position: static;
  }

  ._w-accordion-item-a {
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
  }

  ._w-accordion-item-a.job-posting-text {
    grid-template-rows: auto;
  }

  .accordion-item-q-text.job-posting-title {
    font-size: 16px;
    line-height: 24px;
  }

  .pagination-button {
    width: 80%;
  }

  .nav-link-language-4 {
    padding-left: 20px;
  }

  .top-menu-div-mobile {
    display: none;
  }

  .image-39 {
    width: 80%;
  }

  .cookie-kiddle-award-mobile {
    width: 20%;
    top: auto;
    bottom: 4%;
    left: 4%;
    right: auto;
  }

  .feature-text-landscape {
    z-index: 998;
    font-size: 16px;
    display: none;
  }

  .herowhitebanner-copy {
    margin-top: -200px;
    position: absolute;
    top: auto;
  }

  .heroorange-copy {
    z-index: 3;
    position: absolute;
    top: auto;
    left: auto;
    right: -6%;
  }

  .pearson-eclipse {
    display: none;
  }

  .grid-17 {
    grid-template-rows: minmax(65%, 65%) auto;
    grid-template-columns: 1.5fr;
    align-content: stretch;
    position: absolute;
  }

  .pearson-div._1 {
    width: 100%;
    height: 65%;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: #fcbe4b;
    grid-template-rows: minmax(80px, 100px) minmax(80px, 100px) minmax(200px, .5fr);
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: start;
    justify-content: center;
    align-items: center;
    justify-items: center;
    display: grid;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .pearson-div._2 {
    height: 35%;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .grid-18 {
    grid-template-rows: auto auto;
    align-items: center;
    justify-items: center;
  }

  .div-block-28 {
    width: auto;
    height: 100%;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: minmax(0, 50%) minmax(0, 50%);
    grid-auto-columns: 1fr;
    align-items: center;
    justify-items: center;
    margin: auto;
    display: grid;
  }

  .school-grid {
    grid-template-rows: minmax(40%, 40%) auto;
    grid-template-columns: 1.5fr;
    align-content: stretch;
    position: absolute;
  }

  .school-div._1 {
    width: 100%;
    height: 40%;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: #fcbe4b;
    grid-template-rows: minmax(80px, 100px) minmax(80px, 100px) minmax(200px, .5fr);
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: start;
    justify-content: center;
    align-items: center;
    justify-items: center;
    display: block;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .school-div._2 {
    height: 35%;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .pearson-div-copy._1 {
    width: 100%;
    height: 65%;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: #fcbe4b;
    grid-template-rows: minmax(80px, 100px) minmax(80px, 100px) minmax(200px, .5fr);
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: start;
    justify-content: center;
    align-items: center;
    justify-items: center;
    display: grid;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .pearson-div-copy._2 {
    height: 60%;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .operation-column {
    justify-content: center;
  }

  .buy-now-grid {
    grid-template-rows: minmax(50%, 50%) auto;
    grid-template-columns: 1.5fr;
    align-content: stretch;
    position: absolute;
  }

  .buy-now-div._1 {
    width: 100%;
    height: 50%;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: #fff;
    grid-template-rows: minmax(80px, 100px) minmax(80px, 100px) minmax(200px, .5fr);
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: start;
    justify-content: center;
    align-items: center;
    justify-items: center;
    display: block;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .buy-now-div._2 {
    height: 35%;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .buy-now-div2._1 {
    width: 100%;
    height: 65%;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: #fcbe4b;
    grid-template-rows: minmax(80px, 100px) minmax(80px, 100px) minmax(200px, .5fr);
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: start;
    justify-content: center;
    align-items: center;
    justify-items: center;
    display: grid;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .buy-now-div2._2 {
    height: 50%;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .remove {
    display: none;
    position: static;
  }

  .retail-logo-2 {
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .character-bio.dino {
    display: none;
  }

  .character-bio.turtle {
    z-index: 6;
    display: none;
  }

  .character-bio.unicorn {
    display: none;
  }

  .cookie-kiddle-video {
    z-index: auto;
    width: auto;
    height: 50%;
    max-width: none;
    min-height: auto;
    min-width: 100%;
    object-fit: cover;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .customer-reviews-section {
    min-height: 700px;
    margin-top: 0;
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .customer-reviews-collection-wrapper-desktop {
    display: none;
  }

  .customer-reviews-collection-list {
    margin-top: 73px;
  }

  .customer-reviewer-collection-item {
    margin-bottom: 40px;
  }

  .customer-review-item-div {
    width: 70%;
  }

  .customer-review-text-div {
    grid-template-rows: auto minmax(50px, 50px);
  }

  .customer-review-pagination.products {
    justify-content: space-between;
    align-items: center;
    margin-top: 0%;
    display: flex;
    position: relative;
    top: -50%;
  }

  .customer-reviews-collection-wrapper-mobile {
    display: none;
  }

  .div-block-29 {
    padding-left: 10px;
    padding-right: 10px;
  }

  .testimonial-text {
    font-size: 12px;
    line-height: 18px;
  }

  .animation-detection-div {
    bottom: auto;
  }

  .feature-dino-div {
    width: auto;
    max-width: none;
    margin-top: 0;
    margin-bottom: auto;
    margin-left: 0;
    padding-left: 0;
    display: none;
    position: absolute;
    bottom: -17%;
  }

  .feature-unicorn-div {
    z-index: 3;
    width: auto;
    max-width: none;
    object-fit: fill;
    margin-bottom: auto;
    margin-left: 0;
    display: none;
    position: absolute;
    bottom: -18%;
  }

  .unicorn {
    width: auto;
    height: 200px;
    max-width: none;
    position: relative;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .unicorn.feature {
    width: auto;
  }

  .grid-21 {
    width: 90%;
    height: 120px;
    min-height: 80px;
    grid-template: ". . . . ."
                   "Area Area Area Area Area"
                   / 20% 20% 20% 20% 20%;
    grid-auto-rows: 111px;
    align-content: stretch;
    align-items: center;
    justify-items: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 0;
    position: absolute;
    top: auto;
    bottom: 8%;
    left: 0%;
    right: 0%;
  }

  .left-arrow-3 {
    display: none;
  }

  .subheading-banner {
    margin-bottom: 20px;
  }

  .subheading-banner.school-order {
    font-weight: 400;
  }

  .subheading-banner.job-posting.subtitle {
    margin-top: auto;
    margin-bottom: auto;
  }

  .text-block-20 {
    width: 130%;
    color: #fff;
    position: absolute;
    top: -31px;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .text-block-21 {
    font-size: 8px;
  }

  .text-block-22 {
    font-size: 8px;
    font-weight: 400;
  }

  .image-46 {
    width: 50%;
  }

  .grid-21-cookie-kiddle {
    width: 70%;
    height: 120px;
    min-height: 80px;
    grid-template: "."
    / 33% 33% 33%;
    grid-auto-rows: 111px;
    align-content: stretch;
    align-items: center;
    justify-items: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 0;
    position: relative;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .image-47, .image-48 {
    top: -3%;
  }

  .app-store {
    z-index: 5;
    width: 100%;
    height: 80%;
    padding-left: 10px;
    padding-right: 10px;
    position: relative;
  }

  .app-store-label {
    top: auto;
    bottom: 0%;
    left: auto;
    right: 10%;
  }

  .turtle-teach-section {
    min-height: 900px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .turtle-teach-section.features {
    min-height: 1500px;
  }

  .turtle-teach-grid {
    grid-template-rows: minmax(40%, 40%) auto;
    grid-template-columns: 1.5fr;
    align-content: stretch;
    align-items: center;
    justify-items: stretch;
    position: relative;
  }

  .turtle-teach-text-div._1 {
    width: 100%;
    height: 65%;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: #fcbe4b;
    grid-template-rows: minmax(80px, 100px) minmax(80px, 100px) minmax(200px, .5fr);
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: start;
    justify-content: center;
    align-items: center;
    justify-items: center;
    display: grid;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .turtle-teach-text-div._2 {
    height: 60%;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .turtle-teach-illustration-div._1 {
    width: 100%;
    height: 40%;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: #fcbe4b;
    grid-template-rows: minmax(80px, 100px) minmax(80px, 100px) minmax(200px, .5fr);
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: start;
    justify-content: center;
    align-items: center;
    justify-items: center;
    display: block;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .turtle-teach-illustration-div._2 {
    height: 35%;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .turtle-teach-signup-form {
    padding-top: 48px;
    padding-bottom: 48px;
  }

  .turtle-teach-signup-form.school-order {
    padding-bottom: 40px;
  }

  .heading-14 {
    line-height: 150%;
  }

  .turtle-teach-feature-section {
    width: 100%;
    min-height: 350px;
    margin-top: auto;
    overflow: visible;
  }

  .turtle-teach-text-block {
    text-align: left;
    font-size: 18px;
  }

  .turtle-teach-text-block-title {
    margin-bottom: 20px;
  }

  .turtle-teach-hero-container {
    max-height: 1100px;
    min-height: 500px;
  }

  .turtle-teach-feature-dino-div {
    width: auto;
    max-width: none;
    margin-top: 0;
    margin-bottom: auto;
    margin-left: 0;
    padding-left: 0;
    display: none;
    position: absolute;
    bottom: -17%;
  }

  .turtle-teach-feature-unicorn-div-copy {
    z-index: 3;
    width: auto;
    max-width: none;
    object-fit: fill;
    margin-bottom: auto;
    margin-left: 0;
    display: none;
    position: absolute;
    bottom: -18%;
  }

  .turtle-teach-hero-turtle-div {
    width: auto;
    max-width: none;
    margin: 0 0 auto;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: auto;
    right: 0%;
  }

  .turtle-teach-feature-main-points {
    grid-template-rows: auto auto auto;
    grid-template-columns: minmax(200px, 20%) minmax(200px, 20%);
    align-items: center;
    justify-items: center;
  }

  .turtle-teach-key-points-text {
    text-align: left;
    font-size: 18px;
  }

  .grid-23 {
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    justify-items: center;
  }

  .form-bg-pattern {
    height: 100%;
    object-fit: none;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .turtle-teach-image {
    position: static;
  }

  .tt-grid-with-head {
    grid-template-rows: auto auto;
    align-items: center;
    justify-items: center;
  }

  .turtle-teach-feature-subgrid {
    grid-template-rows: 20% auto auto;
  }

  .turtle-teach-video {
    margin-top: 22px;
  }

  .footer-2 {
    padding: 40px 20px;
  }

  .short-page-wrapper {
    flex-direction: column;
  }

  .widget-wrapper {
    width: 250px;
    height: 400px;
    margin: auto;
    display: block;
    top: 0;
    left: 0;
  }

  .widget-mobile {
    width: 42px;
    height: 42px;
    color: #fff;
    background-color: #2962ff;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    display: flex;
    position: fixed;
    top: auto;
    bottom: 3vw;
    left: auto;
    right: 3vw;
    box-shadow: 0 0 0 5px rgba(41, 98, 255, .2);
  }

  .widget-svg {
    width: 36px;
  }

  .widget-svg.close {
    display: none;
  }

  .widget-embed {
    min-width: 690px;
  }

  .widget-move {
    display: none;
  }
}

@media screen and (max-width: 479px) {
  h3 {
    font-size: 18px;
  }

  a {
    text-align: center;
  }

  .banner {
    height: 320px;
    min-height: 512px;
  }

  .banner.sub {
    height: auto;
    min-height: auto;
    padding-left: 16px;
    padding-right: 16px;
  }

  .banner.sub.school-order {
    overflow: hidden;
  }

  .banner.sub.distributor {
    height: auto;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .section {
    padding: 32px 10px;
  }

  .section.school-order, .section.distributor {
    padding-top: 10px;
  }

  .container.center {
    align-self: flex-start;
    padding-left: 0;
    padding-right: 0;
  }

  .container.center.main-screen {
    padding-left: 24px;
    padding-right: 24px;
  }

  .brand.w--current {
    width: 100px;
    margin-bottom: 0;
  }

  .nav-link {
    padding-right: 20px;
  }

  .nav-link.in-footer {
    text-align: left;
    padding-top: 8px;
  }

  .top-icon-flex.no-space {
    text-align: left;
    grid-template-columns: 1fr 1fr 1fr;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .banner-second.normal {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex-direction: row;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-items: flex-start;
    display: grid;
  }

  .top-title {
    margin-bottom: 0;
  }

  .top-title-text {
    padding-left: 20px;
    padding-right: 20px;
    font-size: 30px;
    line-height: 50px;
  }

  .top-title-text.school-order {
    margin-top: auto;
    margin-bottom: 0;
  }

  .top-title-text.distributor.subtitle {
    margin-top: 0;
    line-height: 30px;
  }

  .top-title-text.job-posting.subtitle {
    line-height: 30px;
  }

  .top-title-text.job-posting.subtitle.left-aligned.career {
    font-size: 16px;
    line-height: 24px;
  }

  .top-title-text.form-section, .top-title-text.form-section.school-order {
    padding-left: 0;
  }

  .client-logo {
    width: 50%;
    padding: 20px;
  }

  .align-center {
    height: auto;
    grid-template-columns: minmax(292px, .25fr);
    align-content: stretch;
    justify-content: center;
    align-items: center;
    justify-items: center;
    margin: auto;
    padding-top: 0;
    right: auto;
  }

  .heading-banner {
    text-align: center;
    margin-bottom: 0;
    margin-right: auto;
    font-size: 30px;
    line-height: 45px;
  }

  .heading-banner.smaller {
    padding-left: 16px;
    padding-right: 16px;
    font-size: 24px;
    line-height: 150%;
  }

  .heading-banner.smaller.order {
    font-size: 24px;
    line-height: 36px;
  }

  .heading-banner.smaller.demo {
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  .heading-banner.smaller {
    padding-left: 16px;
    padding-right: 16px;
    font-size: 34px;
    line-height: 150%;
  }

  .heading-banner.smaller.school-order {
    line-height: 44px;
  }

  .heading-banner.smaller.product {
    padding-left: 40px;
    padding-right: 60px;
  }

  .top-margin.main-page {
    text-align: center;
    flex-direction: column;
    justify-content: center;
    margin-top: 0;
    margin-right: auto;
  }

  .button.white.main-page {
    flex: 0 auto;
    margin: auto;
    display: block;
    position: static;
    top: 121px;
    bottom: 0%;
    left: 6px;
    right: 0%;
  }

  .button.white.main-page.hero {
    margin-top: auto;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    top: auto;
  }

  .button.white.main-page.hero._3d {
    position: relative;
    left: 0;
  }

  .button.white.main-page.best-seller {
    margin-top: 20px;
    margin-right: auto;
    position: relative;
  }

  .button.white.main-page.buy-now {
    margin-top: auto;
    position: static;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .button.white.main-page.feature {
    margin-bottom: 15px;
    margin-right: auto;
  }

  .button.white.main-page.school {
    display: block;
    position: relative;
    top: auto;
    bottom: -17%;
    left: 0%;
    right: 0%;
  }

  .button.white.main-page.cookie-kiddle-feature {
    margin-bottom: 15px;
    margin-right: auto;
  }

  .button.white.main-page.cookie-kiddle-feature._3d.product-page {
    width: 150px;
    position: static;
  }

  .button.white.main-page.pearson-feature, .button.white.main-page.school, .button.white.main-page.turtle-teach {
    margin-bottom: 15px;
    margin-right: auto;
  }

  .button.white.main-page.turtle-teach._3d {
    z-index: 99;
    width: 250px;
    text-align: center;
  }

  .button.white.main-page.turtle-teach._3d.form-submit {
    width: 150px;
  }

  .button.white.distributor {
    flex: 0 auto;
    margin: auto;
    display: block;
    position: static;
    top: 121px;
    bottom: 0%;
    left: 6px;
    right: 0%;
  }

  .button.white.distributor.hero {
    margin-top: auto;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    top: auto;
  }

  .button.white.distributor.best-seller {
    margin-top: 20px;
    margin-right: auto;
    position: relative;
  }

  .button.white.distributor.buy-now {
    margin-top: auto;
    position: static;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .button.white.distributor.feature {
    margin-bottom: 15px;
    margin-right: auto;
  }

  .button.white.distributor.school {
    display: block;
    position: relative;
    top: auto;
    bottom: -17%;
    left: 0%;
    right: 0%;
  }

  .button.white.distributor.cookie-kiddle-feature, .button.white.distributor.pearson-feature {
    margin-bottom: 15px;
    margin-right: auto;
  }

  .footer {
    height: 500px;
  }

  .form-block {
    width: 300px;
  }

  .product-wrapper {
    min-height: 0;
  }

  .product-wrapper.with-padding.shop {
    height: 100%;
    min-height: 300px;
    display: block;
  }

  .price {
    position: relative;
  }

  .price.buy-now {
    margin-top: 10px;
  }

  .flex-row.make-vertical {
    justify-content: center;
    align-items: center;
    display: none;
  }

  .footer-left-part.right-now {
    height: 100%;
    grid-column-gap: 16px;
    grid-row-gap: 0px;
    grid-template-rows: 1fr auto;
    grid-template-columns: minmax(200px, 5fr);
    grid-auto-columns: 1fr;
    align-content: center;
    display: grid;
  }

  .product-item {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-items: center;
    display: block;
  }

  .product-item.mobile {
    width: 80%;
  }

  .cart-container {
    min-width: 240px;
    overflow: auto;
  }

  .best-seller-collection-wrapper-desktop {
    height: auto;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    display: block;
  }

  .order-confirmation-container {
    padding: 0;
  }

  .container-description {
    margin-top: 60px;
  }

  .description-text-container {
    margin-top: 0;
  }

  .description-video {
    z-index: 1;
  }

  .heading-description-heading, .heading-description-heading.description-2 {
    font-size: 24px;
  }

  .heading-description-body, .heading-description-body.white-text {
    font-size: 16px;
  }

  .nav-bar {
    margin-right: 0;
  }

  .product-actual-image {
    height: auto;
    max-height: 100%;
  }

  .image-2 {
    height: 80px;
    max-height: 100%;
    text-align: right;
    margin-left: 0;
  }

  .div-block-2 {
    padding-right: 0;
  }

  .top-menu-nav-div.mobile {
    display: block;
  }

  .menu-button-2 {
    padding-left: 0;
  }

  .menu-button-2:active {
    -webkit-backface-visibility: visible;
    backface-visibility: visible;
    perspective-origin: 50%;
    transform-origin: 50%;
    transform: none;
  }

  .menu-button-2.w--open:active {
    transform: none;
  }

  .icon-2 {
    color: #f05023;
  }

  .form.school-order {
    padding-top: 0;
  }

  .div-block-4 {
    height: 100%;
    margin-top: 10px;
    margin-left: 35px;
    display: block;
  }

  .rich-text-about-us figure {
    width: auto;
  }

  .slider {
    overflow: hidden;
  }

  .div-block-5 {
    justify-content: flex-start;
  }

  .collection-list-wrapper-4 {
    display: none;
  }

  .collection-list-2 {
    grid-column-gap: 3px;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    align-items: center;
  }

  .paragraph-2 {
    width: 80%;
    text-align: center;
    margin-bottom: 0;
    margin-right: auto;
    font-size: 16px;
    line-height: 150%;
  }

  .video-overlay {
    background-color: rgba(0, 0, 0, .4);
  }

  .image-5 {
    width: 32px;
    padding-bottom: 36px;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: auto;
  }

  .right-arrow {
    display: flex;
  }

  .heroaccolades {
    z-index: 5;
    width: 100%;
    max-width: 90%;
    text-align: justify;
    object-fit: fill;
    justify-content: center;
    align-items: center;
    margin-right: 0;
    display: none;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 50%;
    right: 0%;
  }

  .image-5-copy {
    width: 32px;
    padding-bottom: 36px;
    top: auto;
    bottom: 0%;
    left: auto;
    right: 0%;
  }

  .brand-2 {
    padding-left: 0;
    position: absolute;
    top: auto;
    bottom: 20%;
    left: 0%;
    right: 0%;
  }

  .brand-2.w--current {
    z-index: 1;
    padding-left: 0;
    position: absolute;
    top: auto;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .image-7 {
    margin-right: 0;
  }

  .image-8 {
    margin-left: 0;
  }

  .product-actual-image-variant {
    height: auto;
    max-height: 100%;
    max-width: 100%;
  }

  .promo-banner {
    height: 120px;
    padding-left: 16px;
    padding-right: 16px;
  }

  .text-block-3 {
    font-size: 18px;
    line-height: 24px;
  }

  .text-block-3-copy {
    font-size: 12px;
  }

  .div-block-9 {
    margin-right: 0;
  }

  .link-block-2 {
    margin-top: 0;
  }

  .cart-form-wrapper {
    background-color: #fff;
    flex: 0 auto;
  }

  .top-menu-div {
    z-index: 2;
    margin-right: 16px;
    display: block;
    position: relative;
  }

  .container-3 {
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .section-title {
    margin-top: 63px;
    font-size: 30px;
    top: 0%;
  }

  .section-title.orange {
    margin-top: 51px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 30px;
    line-height: 45px;
  }

  .image-10 {
    width: 40%;
    max-width: 50%;
    border-radius: 8px;
    margin-left: 8px;
    margin-right: 0;
  }

  .image-11 {
    width: 40%;
    margin-left: 0;
    margin-right: 8px;
  }

  .html-embed {
    max-width: 100%;
  }

  .image-10-copy {
    width: 40%;
    border-radius: 8px;
    margin-left: 8px;
    margin-right: 0;
  }

  .image-12 {
    max-width: 50%;
  }

  .section-2 {
    max-width: 100%;
  }

  .grid-3 {
    height: 500px;
    grid-row-gap: 0px;
    grid-template: "."
                   "."
                   "."
                   "."
                   "."
                   "."
                   "."
                   "."
                   / 1fr;
    grid-auto-flow: row;
    overflow: visible;
  }

  .school-logos {
    max-width: 140px;
  }

  .column-2 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid;
  }

  .centered-container {
    text-align: left;
  }

  .cards-grid-container {
    grid-template-columns: 1fr;
    margin-left: 0;
    margin-right: 0;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .button-2 {
    border-radius: 20px;
  }

  .demo-buy-button {
    width: 100%;
    height: 100px;
    text-align: center;
    border-radius: 20px;
    justify-content: center;
    align-items: center;
    padding-top: 9px;
    display: flex;
    overflow: visible;
    box-shadow: 0 6px 8px -2px #000;
  }

  .grid-7 {
    width: 100%;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    text-align: left;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    align-content: stretch;
    justify-content: stretch;
    align-items: stretch;
    justify-items: stretch;
    padding-left: 10px;
    padding-right: 10px;
    display: grid;
  }

  .button-3 {
    width: 100%;
    height: 100px;
    text-align: center;
    border-radius: 20px;
    justify-content: center;
    align-items: center;
    margin: auto;
    padding-top: 9px;
    text-decoration: none;
    display: flex;
    box-shadow: 0 6px 8px -2px #000;
  }

  .herohksda {
    z-index: 5;
    width: auto;
    height: 100%;
    max-width: 90%;
    box-shadow: none;
    object-fit: contain;
    border: 1px #000;
    border-radius: 8px;
    margin-left: 10px;
    margin-right: 10px;
    padding-bottom: 0;
    display: block;
    position: relative;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .heading-7 {
    text-align: center;
  }

  .retail-logo {
    width: auto;
    max-width: 80%;
  }

  .retail-logo.clickable {
    max-width: 90%;
    box-shadow: none;
    border-radius: 3px;
  }

  .image-24 {
    max-width: 50%;
    text-align: center;
    text-decoration: underline;
    display: inline-block;
  }

  .location-text {
    color: #5a4522;
    margin-top: 20px;
    margin-bottom: 0;
    font-size: 18px;
  }

  .link-block-5 {
    text-align: center;
    display: inline-block;
  }

  .image-25 {
    max-width: 50%;
  }

  .link-block-6 {
    margin-top: 20px;
  }

  .language-dropdown {
    display: none;
  }

  .herocontainer {
    z-index: auto;
    max-height: 1000px;
    min-height: 1100px;
  }

  .heropattern {
    z-index: 0;
    margin-top: 0;
    margin-bottom: 0;
    top: 15%;
    bottom: auto;
    left: auto;
    right: 0%;
  }

  .herowhitebanner {
    display: inline-block;
    position: absolute;
    top: auto;
    bottom: 0;
  }

  .heroorange {
    width: 100%;
    height: 100px;
    object-fit: none;
    top: auto;
    bottom: 0%;
    left: 0;
    right: 0%;
  }

  .column-5 {
    margin-top: 20px;
  }

  .background-video-3 {
    width: 99%;
    height: 200px;
    border-radius: 0;
    margin-top: 40px;
  }

  .background-video-3.cookiekiddle {
    border-radius: 30px;
  }

  .characterdiv2 {
    width: 100%;
    height: 75%;
    display: none;
    position: relative;
    bottom: 0;
    left: auto;
  }

  .text-block-12 {
    width: 100%;
    justify-content: center;
    font-size: 10px;
    display: flex;
    position: absolute;
  }

  .text-block-13 {
    width: 100%;
    align-items: center;
    font-size: 14px;
    position: absolute;
  }

  .column-6 {
    height: 50px;
    align-items: center;
    padding-left: 0;
    padding-right: 0;
    display: flex;
  }

  .column-7 {
    height: 50px;
    flex: 0 auto;
    justify-content: center;
    align-items: center;
    padding-left: 0;
    padding-right: 0;
    display: flex;
  }

  .characterdiv1 {
    width: 100%;
    height: 75%;
    display: none;
    position: relative;
    bottom: 0;
    left: auto;
  }

  .characterdiv3 {
    width: 100%;
    height: 75%;
    display: none;
    position: relative;
  }

  .column-8 {
    z-index: 5;
    object-fit: fill;
    justify-content: center;
    align-items: center;
    margin-top: auto;
    padding-left: 0;
    padding-right: 0;
    display: flex;
    position: static;
  }

  .image-27 {
    width: 80%;
    height: auto;
    object-fit: fill;
    display: block;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .link-block-7 {
    z-index: 5;
    position: absolute;
  }

  .retail-grid {
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr 1fr;
  }

  .feature-section {
    min-height: 350px;
    text-align: left;
    margin-top: 40px;
    margin-bottom: 100px;
  }

  .feature-grid, .feature-grid.cookiekiddle {
    grid-template-rows: auto auto auto;
    grid-template-columns: 1fr;
  }

  .feature-image-filler {
    border-radius: 40px;
  }

  .feature-div {
    max-height: 200px;
    max-width: 200px;
    border-radius: 40px;
  }

  .feature-video-1 {
    z-index: 999;
    border-radius: 25px;
    display: block;
  }

  .feature-text {
    font-size: 20px;
    display: none;
  }

  .retail-location-section {
    margin-top: 0;
    padding-top: 0;
    padding-left: 20px;
    padding-right: 20px;
  }

  .operation-section {
    min-height: 0;
    overflow: visible;
  }

  .image-31 {
    z-index: -1;
    object-fit: cover;
    border-radius: 11px;
    position: absolute;
    top: -45px;
  }

  .text-block-14 {
    text-align: center;
    flex-direction: row;
    margin-top: 0;
    margin-left: auto;
    margin-right: auto;
    font-size: 16px;
    display: flex;
    position: static;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .operation-video {
    height: auto;
    min-height: 300px;
    margin-top: -200px;
    position: relative;
  }

  .column-9 {
    height: 50%;
    margin-top: 0;
    display: flex;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .column-10 {
    height: 50%;
    grid-column-gap: 16px;
    grid-row-gap: 0px;
    flex: 0 auto;
    order: 0;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: space-around;
    justify-content: center;
    align-self: auto;
    align-items: center;
    justify-items: center;
    margin-top: auto;
    padding-top: 0%;
    padding-left: 0;
    padding-right: 0;
    display: grid;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .school-section {
    max-height: 700px;
    min-height: 800px;
  }

  .school-section-image {
    border-radius: 20px;
  }

  .school-section-logos {
    height: auto;
  }

  .best-sellers-section {
    margin-top: 0;
    padding: 32px 10px;
  }

  .cookie-kiddle-section {
    z-index: auto;
    min-height: 750px;
    text-align: left;
    justify-content: center;
    align-items: center;
    display: flex;
    top: auto;
  }

  .pearson-section {
    align-items: center;
  }

  .buy-now-section {
    min-height: 700px;
  }

  .buy-now-section-title {
    margin-top: auto;
    margin-bottom: auto;
    position: static;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .div-block-17 {
    width: 100%;
    height: 100%;
    margin-bottom: auto;
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    top: auto;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .footer-div-block-2 {
    height: 60%;
    align-items: center;
    display: flex;
  }

  .text-block-15 {
    margin-left: 20px;
    margin-right: 20px;
  }

  .image-33 {
    padding-top: 0;
    padding-left: 29px;
  }

  .footer-div-block-1 {
    justify-content: space-between;
  }

  .grid-10 {
    align-items: center;
    justify-items: center;
    position: static;
  }

  .school-logo-slider {
    height: 600px;
    margin-top: 0;
    position: static;
  }

  .grid-11 {
    margin-top: 25px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .columns-2 {
    height: 600px;
    flex-wrap: nowrap;
    align-content: space-between;
    justify-content: center;
    align-items: center;
    display: none;
    position: relative;
  }

  .text-block-16 {
    z-index: 1;
    text-align: center;
    border-radius: 0;
    flex: 0 auto;
    justify-content: flex-start;
    margin: 10% 20px 0;
    padding-left: 0;
    padding-right: 0;
    font-size: 20px;
    display: block;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .text-block-17 {
    text-align: center;
    position: static;
  }

  .previous {
    margin-left: 0;
    padding-left: 0;
  }

  .collection-list-3 {
    flex-direction: column;
    align-items: center;
    margin-top: 0;
  }

  .pagination.products, .pagination.customer-reviews {
    position: absolute;
    top: 48%;
  }

  .next {
    margin-right: 0;
    padding-right: 0;
  }

  .cookie-kiddle-eclipse {
    display: none;
  }

  .cookie-kiddle-image {
    z-index: auto;
    width: auto;
    height: 50%;
    max-width: none;
    min-height: 0%;
    text-align: center;
    object-fit: cover;
    margin-top: 0;
    display: block;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .columns-3 {
    height: 100%;
    display: block;
  }

  .cookie-kiddle-turtle {
    width: 60%;
    margin-top: 0;
    margin-bottom: 0;
    margin-right: 0;
    top: auto;
    bottom: 0%;
    left: auto;
    right: 0%;
  }

  .cookie-kiddle-pattern {
    z-index: 0;
    object-fit: fill;
    margin-top: -89px;
    display: block;
    top: auto;
    bottom: 39%;
    left: 0%;
    right: 0%;
  }

  .cookie-kiddle-award {
    width: 20%;
    max-width: 20%;
    display: none;
    position: absolute;
    top: auto;
    bottom: 4%;
    left: 4%;
    right: auto;
  }

  .cookie-kiddle-logo {
    z-index: 0;
    max-width: 40%;
    float: none;
    clear: none;
    margin-top: 0;
    margin-left: 0;
    position: absolute;
    top: auto;
    bottom: 4%;
    left: 4%;
    right: auto;
  }

  .cookie-kiddle-unicorn, .cookie-kiddle-dino {
    display: none;
  }

  .cookie-kiddle-submarine {
    z-index: 2;
    max-width: 40%;
    margin-top: 156px;
    padding-top: 0;
    display: block;
    position: absolute;
    top: auto;
    bottom: -12%;
    left: auto;
    right: 0%;
    overflow: visible;
  }

  .cookie-kiddle-collection-list-wrapper {
    z-index: 3;
    width: 40%;
    text-align: left;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 0%;
    margin-left: 0;
    display: block;
    position: relative;
    top: 108px;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .collection-list-4 {
    margin-top: 0;
    margin-right: 0;
    position: static;
    left: auto;
  }

  .collection-item {
    flex-wrap: nowrap;
    position: absolute;
  }

  .retail-geo-text {
    font-size: 12px;
  }

  .pearson-section-column-2 {
    z-index: auto;
    height: 65%;
    background-color: #fcbe4b;
    justify-content: center;
    align-items: center;
    padding-top: 0%;
    display: flex;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .collection-list-wrapper-6 {
    min-height: 100%;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .collection-item-2 {
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .collection-list-5 {
    height: 100%;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .image-35 {
    max-height: none;
    max-width: 100%;
    object-fit: cover;
    margin-left: 0;
    position: static;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: auto;
  }

  .buy-now-text {
    text-align: center;
    margin: 20px auto auto;
    font-size: 16px;
    position: static;
    top: 0%;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .column-12 {
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .school-section-column-1 {
    height: 50%;
  }

  .school-section-column-2 {
    height: 50%;
    margin-top: -200px;
    position: relative;
    top: 50%;
  }

  .operation-section-column-1 {
    height: 100%;
    margin-top: -70px;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .operation-section-column-2 {
    height: 40%;
    margin-top: auto;
    margin-bottom: auto;
    padding-top: 0%;
    padding-left: 0;
    padding-right: 0;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .operation-section-list {
    font-size: 16px;
    line-height: 32px;
  }

  .columns-5 {
    height: 850px;
    display: none;
  }

  .pearson-section-image {
    z-index: 6;
    width: auto;
    height: auto;
    max-height: 100%;
    max-width: 50%;
    min-width: 0%;
    margin: auto;
    position: static;
    top: 13%;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .pearson-product-1 {
    z-index: 2;
    width: auto;
    height: auto;
    max-height: 50%;
    max-width: 70%;
    min-height: 0;
    object-fit: fill;
    margin-top: 0;
    margin-left: 0;
    margin-right: -50%;
    display: block;
    position: absolute;
    top: auto;
    bottom: 5%;
    left: 23%;
    right: auto;
  }

  .pearson-product-2 {
    z-index: 2;
    width: auto;
    height: auto;
    max-height: 50%;
    max-width: 70%;
    min-height: 0;
    object-fit: fill;
    margin-top: 0;
    margin-left: -50%;
    display: block;
    position: absolute;
    top: auto;
    bottom: 5%;
    left: auto;
    right: 23%;
  }

  .div-block-20 {
    padding-left: 0;
    padding-right: 0;
  }

  .grid-12 {
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
  }

  .list {
    height: auto;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: -51px;
    padding-left: 0;
    padding-right: 0;
    font-size: 16px;
    display: block;
    position: absolute;
    top: auto;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .column-13 {
    padding-left: 0;
    padding-right: 0;
  }

  .grid-13 {
    width: 100%;
    grid-column-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr minmax(162px, .5fr);
    align-content: stretch;
    justify-content: stretch;
    align-items: stretch;
    justify-items: start;
    margin-right: 0;
    padding-left: 20px;
    padding-right: 20px;
  }

  .div-block-21 {
    margin-top: 10px;
    margin-bottom: auto;
    margin-left: auto;
  }

  .hero-turtle {
    width: 100%;
    height: auto;
    max-width: none;
    margin-bottom: auto;
    display: inline-block;
    position: relative;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .hero-dino {
    width: 100%;
    height: auto;
    max-width: none;
    margin-bottom: auto;
    margin-left: 0;
    position: relative;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .hero-unicorn {
    width: 100%;
    height: auto;
    max-width: none;
    margin-bottom: auto;
    position: relative;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .grid-14 {
    width: 95%;
    height: auto;
    max-width: 100%;
    float: none;
    clear: none;
    grid-row-gap: 0px;
    grid-template-rows: minmax(auto, .5fr);
    grid-template-columns: 30% 30% 30%;
    align-content: center;
    justify-content: center;
    align-items: center;
    justify-items: center;
    margin-top: auto;
    margin-left: auto;
    margin-right: auto;
    position: static;
    top: 200px;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .characterdiv-columns {
    height: 100%;
    clear: none;
    text-align: left;
    flex-flow: row;
    justify-content: center;
    align-items: center;
    margin-left: 0;
    margin-right: 0;
    position: static;
  }

  .div-block-22, .div-block-23 {
    display: none;
  }

  .slide-nav-2 {
    position: static;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .right-arrow-2 {
    z-index: auto;
    display: none;
  }

  .pearson-section-column-1 {
    z-index: 5;
    height: 30%;
    grid-column-gap: 16px;
    grid-row-gap: 0px;
    grid-template: "Area-2" 1.75fr
                   "Area" 96px
                   "."
                   / 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    padding-top: 0%;
    padding-left: 20px;
    padding-right: 20px;
    display: grid;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .pearson-logo-desktop {
    width: 50%;
    max-width: 80%;
    text-align: left;
    margin-top: 40px;
    display: none;
    position: absolute;
    top: 0;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .column-14 {
    height: auto;
    flex-wrap: wrap;
    flex: 0 auto;
    align-content: stretch;
    justify-content: flex-start;
    align-items: stretch;
    padding-left: 0;
    padding-right: 0;
    display: flex;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .column-15 {
    height: auto;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex-flow: wrap;
    flex: 0 auto;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-self: auto;
    align-items: center;
    margin-top: auto;
    padding-top: 0;
    display: flex;
    position: relative;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .columns-6 {
    height: auto;
    justify-content: flex-start;
    align-items: stretch;
    margin-bottom: 0;
    display: flex;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .grid-15 {
    height: auto;
    grid-column-gap: 16px;
    grid-row-gap: 0px;
    flex: 0 auto;
    grid-template-rows: auto auto auto auto minmax(115px, 1fr);
    grid-template-columns: 2.75fr;
    grid-auto-columns: 1fr;
    justify-content: stretch;
    align-self: auto;
    align-items: center;
    justify-items: center;
    margin: auto 10px;
    display: grid;
    position: static;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .operation-bubble {
    position: absolute;
  }

  .operation-bubble.lower-right {
    top: auto;
    bottom: 6%;
    left: auto;
    right: 0%;
  }

  .operation-bubble.upper-left {
    top: 11%;
    bottom: auto;
    left: 0%;
    right: auto;
  }

  .operation-bubble.lower-left {
    top: auto;
    bottom: 13%;
    left: 0%;
    right: auto;
  }

  .operation-bubble.upper-right {
    top: 2%;
    bottom: auto;
    left: auto;
    right: 0%;
  }

  .text-block-16-copy {
    text-align: center;
    margin-left: 40px;
    margin-right: 40px;
    font-size: 16px;
    position: static;
    top: 18%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .hero-column {
    height: auto;
    justify-content: center;
    align-items: center;
    display: flex;
    position: absolute;
    top: 25%;
    left: auto;
  }

  .hero-column-video {
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    padding-top: 0;
    display: flex;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .hero-columns {
    height: 550px;
    margin-bottom: 28px;
  }

  .pearson-logo-mobile {
    width: auto;
    max-width: 50%;
    text-align: left;
    margin: auto;
    display: block;
    position: static;
    top: 0;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .best-seller-collection-wrapper-mobile {
    height: auto;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    display: none;
  }

  .collection-list-7 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    align-content: stretch;
    justify-content: start;
    align-items: center;
    justify-items: center;
    display: grid;
  }

  .heading-9 {
    display: none;
  }

  .heading-10 {
    display: block;
  }

  .collection-item-3 {
    width: 72px;
    height: 72px;
  }

  .hero-turtle-div {
    width: auto;
    max-width: none;
    object-fit: fill;
    margin: auto;
    position: relative;
  }

  .hero-dino-div {
    z-index: auto;
    width: auto;
    max-width: none;
    margin: auto;
    position: relative;
  }

  .hero-unicorn-div {
    width: auto;
    max-width: none;
    margin: auto;
    position: relative;
  }

  .heroeduhk {
    z-index: 3;
    height: auto;
    max-height: none;
    max-width: 80%;
    display: block;
    position: relative;
  }

  .characterdiv1-mobile, .characterdiv2-mobile {
    width: 100%;
    height: 75%;
    display: block;
    position: static;
    bottom: 0;
    left: auto;
  }

  .characterdiv3-mobile {
    width: 100%;
    height: 75%;
    display: block;
    position: static;
  }

  ._w-accordion-item-a {
    overflow: visible;
  }

  ._w-accordion-item-a.job-posting-subtitle {
    font-size: 12px;
    line-height: 16px;
  }

  ._w-accordion-item-a.job-posting-text {
    float: none;
    clear: none;
    font-size: 12px;
    line-height: 16px;
  }

  .c-accordion-item-q-icon {
    padding: 10px;
  }

  .accordion-item-q-text {
    font-size: 1.1em;
    line-height: 1.3em;
  }

  .accordion-item-q-text.job-posting-title {
    font-size: 12px;
    line-height: 20px;
  }

  .c-accordion-item-q-text {
    justify-content: space-between;
    padding: 10px;
  }

  .best-seller-collection-wrapper-desktop-copy {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    display: none;
  }

  .pagination-button-mobile, .pagination-button {
    width: 80%;
  }

  .nav-link-language-3 {
    margin-left: 0;
    margin-right: 0;
    padding-left: 20px;
    padding-right: 20px;
  }

  .nav-link-language-4 {
    margin-left: 0;
    margin-right: 0;
    padding-left: 20px;
  }

  .top-menu-div-mobile {
    z-index: 2;
    margin-right: 0;
    display: none;
    position: static;
  }

  .cookie-kiddle-award-mobile {
    width: 20%;
    max-width: 20%;
    position: absolute;
    top: auto;
    bottom: 4%;
    left: 4%;
    right: auto;
  }

  .feature-text-landscape {
    display: block;
  }

  .herowhitebanner-copy {
    position: absolute;
    top: auto;
    bottom: -1px;
  }

  .heroorange-copy {
    height: 100px;
    object-fit: none;
    top: auto;
    bottom: 0%;
    left: auto;
    right: 0%;
  }

  .pearson-eclipse {
    display: none;
  }

  .div-block-26 {
    text-align: center;
  }

  .grid-17 {
    grid-template-rows: minmax(65%, 65%) auto;
    grid-template-columns: 1.5fr;
    align-items: stretch;
    position: absolute;
  }

  .pearson-div._1 {
    height: 65%;
    grid-column-gap: 16px;
    grid-row-gap: 0px;
    background-color: #fcbe4b;
    grid-template-rows: minmax(80px, 100px) minmax(80px, 100px) minmax(200px, .5fr);
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    align-content: start;
    justify-content: center;
    align-items: center;
    justify-items: center;
    padding: 10px;
    display: grid;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .pearson-div._2 {
    height: 35%;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .grid-18 {
    grid-template-rows: auto auto;
    padding-left: 0;
    padding-right: 0;
    position: static;
  }

  .image-40 {
    position: relative;
  }

  .div-block-28 {
    width: auto;
    height: 100%;
    max-width: none;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    object-fit: fill;
    grid-template-rows: auto;
    grid-template-columns: minmax(0, 50%) minmax(0, 50%);
    grid-auto-columns: 1fr;
    align-items: center;
    justify-items: center;
    margin: auto;
    display: grid;
    position: static;
  }

  .school-grid {
    grid-template-rows: minmax(40%, 40%) auto;
    grid-template-columns: 1.5fr;
    align-items: stretch;
    position: absolute;
  }

  .school-div._1 {
    height: 40%;
    grid-column-gap: 16px;
    grid-row-gap: 0px;
    background-color: #fcbe4b;
    grid-template-rows: minmax(80px, 100px) minmax(80px, 100px) minmax(200px, .5fr);
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    align-content: start;
    justify-content: center;
    align-items: center;
    justify-items: center;
    padding: 0;
    display: block;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .school-div._2 {
    height: 35%;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .pearson-div-copy._1 {
    height: 65%;
    grid-column-gap: 16px;
    grid-row-gap: 0px;
    background-color: #fcbe4b;
    grid-template-rows: minmax(80px, 100px) minmax(80px, 100px) minmax(200px, .5fr);
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    align-content: start;
    justify-content: center;
    align-items: center;
    justify-items: center;
    padding: 10px;
    display: grid;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .pearson-div-copy._2 {
    height: 60%;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .operation-column {
    height: 600px;
    flex-wrap: nowrap;
    align-content: space-between;
    justify-content: center;
    align-items: center;
    display: flex;
    position: relative;
  }

  .buy-now-grid {
    grid-template-rows: minmax(40%, 40%) auto;
    grid-template-columns: 1.5fr;
    align-items: stretch;
    position: absolute;
  }

  .buy-now-div._1 {
    height: 40%;
    grid-column-gap: 16px;
    grid-row-gap: 0px;
    background-color: #fcbe4b;
    grid-template-rows: minmax(80px, 100px) minmax(80px, 100px) minmax(200px, .5fr);
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    align-content: start;
    justify-content: center;
    align-items: center;
    justify-items: center;
    padding: 0;
    display: block;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .buy-now-div._2 {
    height: 35%;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .buy-now-div2._1 {
    height: 65%;
    grid-column-gap: 16px;
    grid-row-gap: 0px;
    background-color: #fcbe4b;
    grid-template-rows: minmax(80px, 100px) minmax(80px, 100px) minmax(200px, .5fr);
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    align-content: start;
    justify-content: center;
    align-items: center;
    justify-items: center;
    padding: 10px;
    display: grid;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .buy-now-div2._2 {
    height: 60%;
    padding-left: 0;
    padding-right: 0;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .heading-11 {
    display: block;
  }

  .retail-logo-2 {
    width: 40%;
    max-width: 50%;
    border-radius: 8px;
    margin-left: 8px;
    margin-right: 0;
  }

  .character-bio.dino, .character-bio.turtle, .character-bio.unicorn {
    width: 100px;
    height: 100px;
    display: none;
  }

  .cookie-kiddle-bg-video {
    display: block;
  }

  .cookie-kiddle-video {
    z-index: auto;
    width: auto;
    height: 50%;
    max-width: none;
    min-height: 0%;
    text-align: center;
    object-fit: cover;
    margin-top: 0;
    display: none;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .customer-reviews-section {
    margin-top: 0;
    padding: 32px 10px;
  }

  .customer-reviews-collection-wrapper-desktop {
    height: auto;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    display: none;
  }

  .customer-reviews-collection-list {
    flex-direction: column;
    align-items: center;
    margin-top: 0;
  }

  .customer-review-item-div {
    width: 90%;
  }

  .customer-review-pagination.products {
    position: absolute;
    top: 48%;
  }

  .customer-reviews-collection-wrapper-mobile {
    height: auto;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-left: 0;
    padding-right: 0;
    display: none;
  }

  .job-posting-mascot {
    width: 80%;
    height: auto;
    max-height: 80%;
  }

  .testimonial-div {
    height: 90%;
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    grid-template-rows: minmax(500px, 1fr) auto auto;
    grid-template-columns: 100%;
  }

  .testimonial-grid {
    height: 500px;
  }

  .testimonial-text {
    font-size: 16px;
    line-height: 23px;
  }

  .testimonial-slider {
    height: auto;
    min-height: 1600px;
  }

  .last-updated-date {
    align-items: center;
  }

  .feature-dino-div {
    width: 25%;
    max-width: none;
    margin: auto;
    display: none;
    position: absolute;
    left: 4%;
  }

  .feature-unicorn-div {
    width: 20%;
    max-width: none;
    margin: auto;
    display: none;
    position: absolute;
    bottom: -16%;
    right: 6%;
  }

  .unicorn {
    width: 100%;
    height: auto;
    max-width: none;
    margin-bottom: auto;
    position: relative;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }

  .unicorn.feature {
    width: 100%;
  }

  .grid-21 {
    width: 100%;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    text-align: left;
    object-fit: fill;
    grid-template: "." minmax(100px, 1fr)
                   "." minmax(100px, 1fr)
                   "." minmax(100px, 1fr)
                   / 33% 33% 33%;
    grid-auto-columns: 1fr;
    justify-content: stretch;
    justify-items: center;
    margin-left: 0;
    margin-right: 0;
    display: grid;
    bottom: 14%;
  }

  .left-arrow-3 {
    display: none;
  }

  .subheading-banner {
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 20px;
    line-height: 30px;
  }

  .subheading-banner.school-order {
    margin-top: auto;
    margin-bottom: 0;
  }

  .subheading-banner.distributor.subtitle {
    margin-top: 0;
  }

  .subheading-banner.job-posting.subtitle {
    line-height: 30px;
  }

  .link-4, .link-block-8 {
    color: #fff;
  }

  .text-block-20 {
    text-align: right;
    margin-right: 10px;
    font-size: 12px;
    position: absolute;
    top: -16%;
    bottom: 0%;
    left: auto;
    right: 0%;
  }

  .text-block-21 {
    font-size: 6px;
    line-height: 12px;
  }

  .image-46 {
    width: 80%;
  }

  .grid-21-cookie-kiddle {
    width: 100%;
    grid-column-gap: 2px;
    grid-row-gap: 2px;
    text-align: left;
    object-fit: fill;
    grid-template: "." minmax(100px, 1fr)
    / 30% 30% 30%;
    grid-auto-columns: 1fr;
    justify-content: stretch;
    justify-items: center;
    margin-left: 0;
    margin-right: 0;
    display: grid;
  }

  .div-block-34 {
    align-self: auto;
    position: relative;
  }

  .image-47, .image-48 {
    top: 10%;
  }

  .nav-link-turtle-teach {
    padding-right: 20px;
  }

  .nav-link-turtle-teach.in-footer {
    text-align: left;
    padding-top: 8px;
  }

  .app-store {
    z-index: 3;
    height: auto;
    max-height: none;
    max-width: 70%;
    display: block;
    position: relative;
  }

  .app-store-label {
    max-width: 30%;
    top: auto;
    bottom: 0%;
    left: auto;
    right: 5%;
  }

  .turtle-teach-section {
    max-height: none;
    min-height: 600px;
    padding-left: 10px;
    padding-right: 10px;
    overflow: hidden;
  }

  .turtle-teach-grid {
    max-height: none;
    min-height: 0;
    grid-template-rows: minmax(400px, auto) auto;
    grid-template-columns: 1.5fr;
    align-content: stretch;
    justify-content: center;
    align-items: stretch;
    position: relative;
  }

  .turtle-teach-text-div._1 {
    height: 65%;
    grid-column-gap: 16px;
    grid-row-gap: 0px;
    background-color: #fcbe4b;
    grid-template-rows: minmax(80px, 100px) minmax(80px, 100px) minmax(200px, .5fr);
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    align-content: start;
    justify-content: center;
    align-items: center;
    justify-items: center;
    padding: 10px;
    display: grid;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .turtle-teach-text-div._2 {
    height: 60%;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .turtle-teach-illustration-div {
    padding-left: 0;
    padding-right: 0;
    position: static;
  }

  .turtle-teach-illustration-div._1 {
    height: 40%;
    grid-column-gap: 16px;
    grid-row-gap: 0px;
    background-color: #fcbe4b;
    grid-template-rows: minmax(80px, 100px) minmax(80px, 100px) minmax(200px, .5fr);
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    align-content: start;
    justify-content: center;
    align-items: center;
    justify-items: center;
    padding: 0;
    display: block;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .turtle-teach-illustration-div._2 {
    height: 35%;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%;
  }

  .turtle-teach-hero-title {
    text-align: center;
    font-size: 24px;
    position: static;
  }

  .turtle-teach-signup-form {
    padding: 32px 10px;
  }

  .turtle-teach-signup-form.school-order, .turtle-teach-signup-form.distributor {
    padding-top: 10px;
  }

  .turtle-teach-form.school-order {
    padding-top: 0;
  }

  .grid-22 {
    z-index: 5;
    max-width: 100%;
    grid-row-gap: 31px;
    align-content: stretch;
    justify-content: stretch;
    padding-left: 20px;
    padding-right: 20px;
  }

  .image-53 {
    max-width: 50%;
  }

  .heading-14 {
    font-size: 24px;
    line-height: 150%;
  }

  .turtle-teach-feature-section {
    min-height: 350px;
    text-align: left;
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 20px;
    padding-left: 0;
    padding-right: 0;
  }

  .turtle-teach-text-block {
    text-align: left;
    margin-left: 0;
    margin-right: 0;
    font-size: 16px;
    position: static;
    top: 18%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .turtle-teach-text-block-title {
    text-align: center;
    margin-bottom: 20px;
    font-size: 24px;
    position: static;
  }

  .turtle-teach-hero-container {
    z-index: auto;
    max-height: 1000px;
    min-height: 400px;
    text-align: left;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
  }

  .turtle-teach-feature-dino-div {
    width: 25%;
    max-width: none;
    margin: auto;
    display: none;
    position: absolute;
    left: 4%;
  }

  .turtle-teach-feature-unicorn-div-copy {
    width: 20%;
    max-width: none;
    margin: auto;
    display: none;
    position: absolute;
    bottom: -16%;
    right: 6%;
  }

  .turtle-teach-hero-turtle-div {
    width: auto;
    max-width: 20%;
    object-fit: fill;
    margin: auto;
    position: absolute;
  }

  .turtle-teach-feature-main-points {
    width: 100%;
    grid-template-rows: auto auto;
    grid-template-columns: minmax(150px, 50%) minmax(150px, 50%);
    align-content: start;
    padding-left: 0;
    padding-right: 0;
    position: static;
  }

  .turtle-teach-key-points-text {
    max-width: 80%;
    text-align: left;
    margin-left: 0;
    margin-right: 0;
    font-size: 16px;
    position: static;
    top: 18%;
    bottom: auto;
    left: 0%;
    right: 0%;
  }

  .turtle-teach-image {
    border-radius: 20px;
  }

  .tt-grid-with-head {
    grid-template-rows: auto auto;
    align-content: start;
    justify-content: stretch;
    padding-left: 0;
    padding-right: 0;
    position: static;
  }

  .turtle-teach-feature-subgrid {
    grid-template-rows: 20% auto auto;
    grid-template-columns: minmax(200px, 70%);
    align-content: start;
    justify-content: stretch;
    align-items: end;
    justify-items: center;
  }

  .turtle-teach-feature-thumbnail {
    max-width: 80%;
  }

  .div-block-37 {
    max-width: none;
    grid-template-columns: 100%;
  }

  .turtle-teach-video {
    width: auto;
    height: auto;
    min-height: 300px;
    min-width: 400px;
    margin-top: 0;
    position: relative;
  }

  .footer-2 {
    text-align: left;
    padding-left: 20px;
    padding-right: 20px;
  }

  .footer-flex-container {
    flex-direction: column;
  }

  .footer-column-2 {
    margin-top: 20px;
  }

  .form-divider {
    width: 100%;
  }
}

#w-node-_2175c53b-f823-7fca-ff3e-28377c5b68fb-5f390741, #w-node-c3c85f7f-e632-7142-cfcd-e335b39ffbf7-5f390741, #w-node-a3569e3f-bfe9-2cd6-dfbc-24e0029e527e-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-c83573bc-415f-42b8-9119-433e4d4e15ae-5f390741 {
  grid-area: Area-2;
  align-self: center;
  justify-self: center;
}

#w-node-a76d30ae-4e70-88df-0ce5-78380d0f3536-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-c8122abc-3b43-6e74-b69c-0963680eb67f-5f390741, #w-node-_3636518e-af21-be81-247a-c0744077189e-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_79dc8d1b-bf74-2e69-7ff7-a013178c8864-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: center;
}

#w-node-bf37d83b-4112-37a7-e587-cbae54431344-5f390741, #w-node-e70c839c-8001-17fe-8819-c07e6ddc7452-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_19709121-291a-2799-1fcb-35276e5fab63-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
}

#w-node-_89e1e007-5c1e-f0e2-ef39-7e170e19e585-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_89e1e007-5c1e-f0e2-ef39-7e170e19e58b-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_89e1e007-5c1e-f0e2-ef39-7e170e19e58c-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_0198e76c-1748-7442-e2ff-99da45f4e95b-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_8ce43518-5b0e-e0cf-1b9c-9ace8dba98da-5f390741 {
  align-self: auto;
  justify-self: auto;
}

#w-node-_02251eb6-36cd-1eea-bf42-7ef32e223006-5f390741, #w-node-_02251eb6-36cd-1eea-bf42-7ef32e223007-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_02251eb6-36cd-1eea-bf42-7ef32e22300a-5f390741 {
  align-self: auto;
  justify-self: auto;
}

#w-node-e163b4e8-f132-cb1b-9e25-ebc7fe62ecc9-5f390741, #w-node-_9041a65e-2515-dad8-8e69-9dc126e4bf22-5f390741, #w-node-_9041a65e-2515-dad8-8e69-9dc126e4bf23-5f390741, #w-node-_3d82798c-0f2c-1ed0-82d2-81f013d98ab6-5f390741, #w-node-_3d82798c-0f2c-1ed0-82d2-81f013d98ab7-5f390741, #w-node-_3d82798c-0f2c-1ed0-82d2-81f013d98ab8-5f390741, #w-node-_3d82798c-0f2c-1ed0-82d2-81f013d98ab9-5f390741, #w-node-_3d82798c-0f2c-1ed0-82d2-81f013d98aba-5f390741, #w-node-_3d82798c-0f2c-1ed0-82d2-81f013d98abb-5f390741, #w-node-_3d82798c-0f2c-1ed0-82d2-81f013d98abc-5f390741, #w-node-_827503eb-f5d0-a9f7-4dbd-69ffa814c5ce-5f390741, #w-node-_71cf9b90-fcc9-d049-02af-f3a8d5b6a9fd-5f390741, #w-node-_628791b2-2d07-5cf1-5c7d-47353364a902-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-dde22649-52a9-64c9-09e9-8d6b3a912062-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-f348bc68-2fb1-23c1-e5a2-a1377e7185b3-5f390741, #w-node-dde22649-52a9-64c9-09e9-8d6b3a912063-5f390741, #w-node-dde22649-52a9-64c9-09e9-8d6b3a912064-5f390741, #w-node-ceb01dad-a331-2531-94c5-ff9bf77e46f4-5f390741, #w-node-dde22649-52a9-64c9-09e9-8d6b3a912065-5f390741, #w-node-dde22649-52a9-64c9-09e9-8d6b3a91206a-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_7255e8bc-9fac-170f-d8c9-6d559ede0937-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: end;
  justify-self: start;
}

#w-node-_02d71117-5b14-938a-213d-2bddb80f263f-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_02d71117-5b14-938a-213d-2bddb80f2640-5f390741, #w-node-_02d71117-5b14-938a-213d-2bddb80f2641-5f390741, #w-node-_02d71117-5b14-938a-213d-2bddb80f2642-5f390741, #w-node-_02d71117-5b14-938a-213d-2bddb80f2643-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-caf444be-d16d-4f2d-f82b-9bf8dbb9b7aa-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
}

#w-node-_02d71117-5b14-938a-213d-2bddb80f2649-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_599cbc2f-bad4-b1be-4457-267cc569b671-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: end;
  justify-self: start;
}

#w-node-ec3a381c-a6ac-e02e-1b14-ad5548aa7c4d-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-ec3a381c-a6ac-e02e-1b14-ad5548aa7c4e-5f390741, #w-node-ec3a381c-a6ac-e02e-1b14-ad5548aa7c4f-5f390741, #w-node-ec3a381c-a6ac-e02e-1b14-ad5548aa7c50-5f390741, #w-node-ec3a381c-a6ac-e02e-1b14-ad5548aa7c51-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_845c8a6d-a442-9fa7-fd93-061ef42bdf16-5f390741 {
  align-self: auto;
  justify-self: auto;
}

#w-node-ec3a381c-a6ac-e02e-1b14-ad5548aa7c52-5f390741, #w-node-ec3a381c-a6ac-e02e-1b14-ad5548aa7c57-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_96605803-1eeb-7aa3-fddf-fb75994dcbfe-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: end;
  justify-self: start;
}

#w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f24d9-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f24da-5f390741, #w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f24db-5f390741, #w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f24dc-5f390741, #w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f24dd-5f390741, #w-node-a03e638c-ff10-e006-1dc7-75e7d1787f81-5f390741, #w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f24de-5f390741, #w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f24e3-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_4671143c-75d1-6c40-fc1d-66a06348c652-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: end;
  justify-self: start;
}

#w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f24ec-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f24ed-5f390741, #w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f24ee-5f390741, #w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f24ef-5f390741, #w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f24f0-5f390741, #w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f24f1-5f390741, #w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f24f6-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-ac2ec37e-bc5d-3a42-092d-6a5c559740b3-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: end;
  justify-self: start;
}

#w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f2503-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f2504-5f390741, #w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f2505-5f390741, #w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f2506-5f390741, #w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f2507-5f390741, #w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f2508-5f390741, #w-node-_769f8aeb-12e5-37b9-0f51-8bc5b51f250d-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-e9635235-5c9a-fc2f-0f9a-d08e45374d2b-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: end;
  justify-self: start;
}

#w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5d3-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5d4-5f390741, #w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5d5-5f390741, #w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5d6-5f390741, #w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5d7-5f390741, #w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5d8-5f390741, #w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5dd-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_99c5d3b8-3fb2-63bf-1c94-dee1f3f829c9-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: end;
  justify-self: start;
}

#w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5e6-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5e7-5f390741, #w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5e8-5f390741, #w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5e9-5f390741, #w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5ea-5f390741, #w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5eb-5f390741, #w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5f0-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_472e30db-9ff4-f4f2-7daa-d9b8685242db-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: end;
  justify-self: start;
}

#w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5fd-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5fe-5f390741, #w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b5ff-5f390741, #w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b600-5f390741, #w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b601-5f390741, #w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b602-5f390741, #w-node-_5c7eff37-8ccd-dc12-fe73-90da4ec5b607-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_3ff0cd63-2f3e-c085-ba3e-c528ccad7648-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: end;
  justify-self: start;
}

#w-node-_722eadc8-f58b-4299-e5ca-44a75bb1563a-5f390741 {
  align-self: start;
}

#w-node-_722eadc8-f58b-4299-e5ca-44a75bb1563e-5f390741 {
  align-self: center;
}

#w-node-_722eadc8-f58b-4299-e5ca-44a75bb15640-5f390741 {
  align-self: center;
  justify-self: center;
}

#w-node-_722eadc8-f58b-4299-e5ca-44a75bb15643-5f390741 {
  align-self: start;
  justify-self: center;
}

#w-node-ffb97222-1fef-ff22-1af7-c735f82f43a5-5f390741, #w-node-_730caf20-662b-4b25-a7c9-e2fa5894574c-5f390741, #w-node-_3d96acbe-88f0-35e1-9976-43d3cb3c36de-5f390741, #w-node-_3d96acbe-88f0-35e1-9976-43d3cb3c36e0-5f390741, #w-node-_0c022cbf-5d9b-63bc-d2d4-b17a75ee2a43-5f390741, #w-node-_53172a91-10f7-e144-0096-a84a2c494345-5f390741, #w-node-_0c022cbf-5d9b-63bc-d2d4-b17a75ee2a45-5f390741, #w-node-a3b2adbf-8c24-ec32-c6d1-c370ff6d991c-5f390741, #w-node-a3b2adbf-8c24-ec32-c6d1-c370ff6d991e-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_46536006-679c-97ba-2810-658706535be4-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_5600d002-128a-e564-d688-374f583ee557-5f390741, #w-node-ca5a3f2b-f486-2154-db46-b62375aacc73-5f390741, #w-node-ca5a3f2b-f486-2154-db46-b62375aacc75-5f390741, #w-node-a1357e6c-4ec9-ce8b-e9fb-a4395da8f583-5f390741, #w-node-a1357e6c-4ec9-ce8b-e9fb-a4395da8f585-5f390741, #w-node-_73c800fe-d64b-9509-9abc-757f4a709381-5f390741, #w-node-_73c800fe-d64b-9509-9abc-757f4a709383-5f390741, #w-node-db3d25f6-5566-08fb-e7e3-824ad258348b-5f390741, #w-node-db3d25f6-5566-08fb-e7e3-824ad258348d-5f390741, #w-node-_381c283f-0e4e-3f5c-603c-322121471a81-5f390741, #w-node-_381c283f-0e4e-3f5c-603c-322121471a83-5f390741, #w-node-f4dc5477-4e4e-89af-204b-feef283e196b-5f390741, #w-node-f4dc5477-4e4e-89af-204b-feef283e196d-5f390741, #w-node-f921aaf0-eae9-7a3f-51f5-7d04acd0b9df-5f390741, #w-node-f921aaf0-eae9-7a3f-51f5-7d04acd0b9e1-5f390741, #w-node-_41d7f39f-e09c-355e-e5e2-c98e94b0f813-5f390741, #w-node-ba250a6f-136b-1bf3-748c-d562343b7266-5f390741, #w-node-a1159b99-a947-33a1-09df-265612d6c2d3-5f390741, #w-node-_35d1c83e-ea65-db5b-951e-0a76793801f3-5f390741, #w-node-_83be745f-de31-9132-0171-4fd88ef6b5bb-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-a9c06865-f2b1-5faf-3fb7-e9155ee124a8-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_1db23e3f-d8bf-9dcb-8002-ea02476533fc-5f390741, #w-node-dadf6f5c-2851-e52e-207e-366ab06cd0b8-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-dadf6f5c-2851-e52e-207e-366ab06cd0ba-5f390741 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_7ae06a7d-7e1f-7fb8-ba55-09f30267adcb-27908c89 {
  justify-self: end;
}

#w-node-ccd05776-e614-9295-7db7-867535bfbc43-4839075f, #w-node-_3f08075b-05f5-63e0-976b-48cd8c3dd588-4839075f {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_57ab0371-c2f0-2a92-9773-868964d6b5bb-4839075f {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: center;
  justify-self: center;
}

#w-node-_2d749afe-ce86-1282-47d1-c150d232d1e9-4839075f {
  align-self: center;
  justify-self: center;
}

#w-node-a76d30ae-4e70-88df-0ce5-78380d0f3536-8f390764 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-c8122abc-3b43-6e74-b69c-0963680eb67f-8f390764, #w-node-_3636518e-af21-be81-247a-c0744077189e-8f390764, #w-node-fdfeef96-b21e-99ad-dc41-73749ed849c4-8f390764, #w-node-d3cfd882-566b-2c9d-f668-d9595890b3d3-8f390764, #w-node-_48da89a9-d68e-14f2-05ce-7a87a6a4999a-8f390764, #w-node-_1afc8b6b-7f53-e12e-8747-c7eda33cd1fe-8f390764 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_79dc8d1b-bf74-2e69-7ff7-a013178c8864-8f390764 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: center;
}

#w-node-bf37d83b-4112-37a7-e587-cbae54431344-8f390764, #w-node-e70c839c-8001-17fe-8819-c07e6ddc7452-8f390764, #w-node-_83be745f-de31-9132-0171-4fd88ef6b5bb-8f390764 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-a9c06865-f2b1-5faf-3fb7-e9155ee124a8-8f390764 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_1db23e3f-d8bf-9dcb-8002-ea02476533fc-8f390764 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_97054a2f-0f70-93be-be78-adbc6b6eec3b-0b39077c {
  align-self: center;
  justify-self: end;
}

#w-node-e3c52c33-0c48-12db-c76a-3138e5bf90a7-0b39077c {
  align-self: center;
  justify-self: start;
}

#w-node-d3e03138-6a74-372d-917a-aa1c3262767f-ff390798, #w-node-_5e34a5fc-98ca-0af4-877e-723d25186df5-ff390798 {
  align-self: auto;
  justify-self: auto;
}

#w-node-_3272ee20-6aff-6fcc-2e84-bb682e0b0dce-ff390798 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-d1ff7ccb-3b7e-3f20-c683-5b6def5afc93-ff390798 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: center;
  justify-self: center;
}

#w-node-_26918258-fdac-2cd9-b9c3-c87d41e0e403-ff390798, #w-node-_98d91f50-2af1-5579-d85e-b8ecdebf204a-ff390798 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: center;
  justify-self: auto;
}

#w-node-dab4b6da-a8b1-d5c4-646f-624f33732710-ff390798, #w-node-ae7b37e7-39f1-c55d-8711-2f1ba5116edb-ff390798 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_591722f7-0db8-5fcd-a6e5-c507d0253bc3-2a39079e {
  grid-area: 1 / 1 / 2 / 3;
  align-self: stretch;
  justify-self: stretch;
}

#w-node-_85ef7662-83c1-e9b5-2d8c-be28f04be933-4b3907c2 {
  align-self: auto;
}

#w-node-fa6772f3-d530-e462-9787-0aaa5c7c3130-4b3907c2, #w-node-_3ff23a8c-62c8-8df9-4bd3-8f09b9d7ec93-4b3907c2 {
  align-self: center;
}

#w-node-_21d7e11f-fa91-f612-d024-c6932d3370d6-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_054932a7-0096-398a-b59f-97c46989467d-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_1ab0dd6a-8107-092e-7701-b651f133c058-073907d9, #w-node-_7f6e95b7-de02-6e3f-a896-0012ef5c9bf3-073907d9 {
  align-self: center;
  justify-self: center;
}

#w-node-_77a8c97e-0d07-2b26-15fc-8daa0574a797-073907d9, #w-node-b82c1f6c-d598-1ada-560b-73818a77a6ee-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-b82c1f6c-d598-1ada-560b-73818a77a6ed-073907d9 {
  align-self: auto;
  justify-self: auto;
}

#w-node-_06b51fb2-d420-05b9-4db4-8fdd8fb82397-073907d9, #w-node-_7f4376a5-d2c9-53f9-ac74-82d85e55336f-073907d9, #w-node-dbaf88e0-25d2-e73e-7374-488e7b6b7f23-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_5cf823c1-11c7-3b3b-e0e4-a2565a9fae0d-073907d9 {
  align-self: auto;
  justify-self: auto;
}

#w-node-dec432cb-4948-1092-9deb-1529f11c7ed0-073907d9, #w-node-dec432cb-4948-1092-9deb-1529f11c7ed2-073907d9, #w-node-_5a310cf0-69c6-6374-c2ea-773f63fd32fb-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-dec432cb-4948-1092-9deb-1529f11c7ed4-073907d9 {
  align-self: auto;
  justify-self: auto;
}

#w-node-b82d2fb1-a5cc-a193-2650-501b3cd6d574-073907d9, #w-node-b82d2fb1-a5cc-a193-2650-501b3cd6d576-073907d9, #w-node-b82d2fb1-a5cc-a193-2650-501b3cd6d575-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-b82d2fb1-a5cc-a193-2650-501b3cd6d578-073907d9 {
  align-self: auto;
  justify-self: auto;
}

#w-node-e028c015-67f8-f303-6616-0f51eaf7d4d0-073907d9, #w-node-e028c015-67f8-f303-6616-0f51eaf7d4d2-073907d9, #w-node-ef1048fd-90bd-804c-b82a-7ebf8c42f9cf-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-dd6196f4-92fb-2d75-2c87-904dffd0c112-073907d9 {
  align-self: auto;
  justify-self: auto;
}

#w-node-_5c44d556-74c9-5317-0f58-4fd53d1bf52f-073907d9, #w-node-_5c44d556-74c9-5317-0f58-4fd53d1bf531-073907d9, #w-node-_62c6aa61-70f2-dd1a-b8ee-0fc064fffa4e-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-b5653859-cf5c-7cc3-841a-db9960fcbeb8-073907d9 {
  align-self: auto;
  justify-self: auto;
}

#w-node-_92e942f5-c9b0-7ded-f0c7-1c0efb04a565-073907d9, #w-node-_92e942f5-c9b0-7ded-f0c7-1c0efb04a567-073907d9, #w-node-_21770913-e0b4-8031-4133-467e5752c5f5-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-cbc61ed7-da31-3641-5433-ae7ff50ec71a-073907d9 {
  align-self: auto;
  justify-self: auto;
}

#w-node-_89e1e007-5c1e-f0e2-ef39-7e170e19e58c-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_0198e76c-1748-7442-e2ff-99da45f4e95b-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_20a8ba8b-449b-8ae3-4f51-e419f5f8d93e-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  justify-self: end;
}

#w-node-_8ce43518-5b0e-e0cf-1b9c-9ace8dba98da-073907d9 {
  grid-area: Area-2;
  align-self: auto;
  justify-self: auto;
}

#w-node-_89e1e007-5c1e-f0e2-ef39-7e170e19e585-073907d9, #w-node-f72b0255-81cd-5781-d4bf-5e0fedb03d41-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-f72b0255-81cd-5781-d4bf-5e0fedb03d3b-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-f72b0255-81cd-5781-d4bf-5e0fedb03d3c-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-f72b0255-81cd-5781-d4bf-5e0fedb03d3d-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_8d6c6f73-2300-6950-83e2-5cfd527a6004-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: center;
  justify-self: end;
}

#w-node-f72b0255-81cd-5781-d4bf-5e0fedb03d3f-073907d9 {
  grid-area: Area-2;
  align-self: auto;
  justify-self: auto;
}

#w-node-_5c489dec-ae5f-901b-c9b5-a9250c34ba6c-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_5c489dec-ae5f-901b-c9b5-a9250c34ba6d-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
}

#w-node-_5c489dec-ae5f-901b-c9b5-a9250c34ba6e-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: auto;
  justify-self: auto;
}

#w-node-_5c489dec-ae5f-901b-c9b5-a9250c34ba70-073907d9 {
  align-self: auto;
  justify-self: auto;
}

#w-node-_5c489dec-ae5f-901b-c9b5-a9250c34ba72-073907d9 {
  grid-area: span 1 / span 1 / span 1 / span 1;
  align-self: center;
  justify-self: center;
}

@media screen and (max-width: 991px) {
  #w-node-_9c77e86c-94d7-f85d-623c-baaa3f6b7886-5f390741, #w-node-dc170ca0-77be-ab7b-e8da-eed7df780dcf-5f390741, #w-node-_2175c53b-f823-7fca-ff3e-28377c5b68fb-5f390741 {
    align-self: end;
    justify-self: center;
  }

  #w-node-c3c85f7f-e632-7142-cfcd-e335b39ffbf7-5f390741 {
    grid-area: span 1 / span 1 / span 1 / span 1;
    align-self: end;
    justify-self: center;
  }

  #w-node-a3569e3f-bfe9-2cd6-dfbc-24e0029e527e-5f390741 {
    align-self: end;
    justify-self: center;
  }

  #w-node-c83573bc-415f-42b8-9119-433e4d4e15ae-5f390741 {
    grid-area: span 1 / span 3 / span 1 / span 3;
    align-self: center;
    justify-self: center;
  }

  #w-node-_9cd8b27a-0afa-e4a4-c637-57096bc58924-5f390741 {
    grid-area: span 1 / span 1 / span 1 / span 1;
  }

  #w-node-_722eadc8-f58b-4299-e5ca-44a75bb1563a-5f390741, #w-node-_722eadc8-f58b-4299-e5ca-44a75bb1563e-5f390741 {
    align-self: start;
    justify-self: auto;
  }

  #w-node-_722eadc8-f58b-4299-e5ca-44a75bb15640-5f390741 {
    align-self: start;
    justify-self: center;
  }

  #w-node-_722eadc8-f58b-4299-e5ca-44a75bb15643-5f390741 {
    align-self: end;
    justify-self: center;
  }

  #w-node-_1ad4df91-8135-e871-369d-04d327908c8a-27908c89 {
    grid-area: 1 / 1 / 2 / 2;
  }

  #w-node-_1ad4df91-8135-e871-369d-04d327908c8d-27908c89, #w-node-_9cd8b27a-0afa-e4a4-c637-57096bc58924-8f390764 {
    grid-area: span 1 / span 1 / span 1 / span 1;
  }

  #w-node-dc170ca0-77be-ab7b-e8da-eed7df780dcf-8f390764 {
    align-self: end;
    justify-self: center;
  }

  #w-node-_89e1e007-5c1e-f0e2-ef39-7e170e19e585-073907d9 {
    align-self: center;
    justify-self: center;
  }
}

@media screen and (max-width: 767px) {
  #w-node-c83573bc-415f-42b8-9119-433e4d4e15ae-5f390741 {
    grid-area: span 1 / span 5 / span 1 / span 5;
    align-self: center;
    justify-self: center;
  }

  #w-node-_79dc8d1b-bf74-2e69-7ff7-a013178c8864-5f390741, #w-node-_19709121-291a-2799-1fcb-35276e5fab63-5f390741 {
    align-self: auto;
  }

  #w-node-_89e1e007-5c1e-f0e2-ef39-7e170e19e585-5f390741 {
    align-self: center;
    justify-self: center;
  }

  #w-node-_722eadc8-f58b-4299-e5ca-44a75bb15643-5f390741 {
    align-self: start;
  }

  #w-node-_83be745f-de31-9132-0171-4fd88ef6b5bb-5f390741, #w-node-_7e4ec7bb-ace9-b2b8-3580-f1e558df1b74-5f390741, #w-node-dadf6f5c-2851-e52e-207e-366ab06cd0b8-5f390741 {
    align-self: center;
    justify-self: center;
  }

  #w-node-dadf6f5c-2851-e52e-207e-366ab06cd0ba-5f390741 {
    align-self: auto;
    justify-self: auto;
  }

  #w-node-_79dc8d1b-bf74-2e69-7ff7-a013178c8864-8f390764 {
    align-self: auto;
  }

  #w-node-_83be745f-de31-9132-0171-4fd88ef6b5bb-8f390764, #w-node-_7e4ec7bb-ace9-b2b8-3580-f1e558df1b74-8f390764 {
    align-self: center;
    justify-self: center;
  }

  #w-node-_34cdf210-7ab9-3e63-4b8a-e3eead01f140-0b39077c, #w-node-_34cdf210-7ab9-3e63-4b8a-e3eead01f147-0b39077c {
    grid-area: span 1 / span 1 / span 1 / span 1;
  }

  #w-node-b82d2fb1-a5cc-a193-2650-501b3cd6d576-073907d9 {
    align-self: end;
  }

  #w-node-_89e1e007-5c1e-f0e2-ef39-7e170e19e58c-073907d9 {
    align-self: auto;
    justify-self: auto;
  }

  #w-node-_89e1e007-5c1e-f0e2-ef39-7e170e19e585-073907d9, #w-node-f72b0255-81cd-5781-d4bf-5e0fedb03d41-073907d9, #w-node-_5c489dec-ae5f-901b-c9b5-a9250c34ba72-073907d9 {
    align-self: center;
    justify-self: center;
  }
}

@media screen and (max-width: 479px) {
  #w-node-_9c77e86c-94d7-f85d-623c-baaa3f6b7886-5f390741, #w-node-dc170ca0-77be-ab7b-e8da-eed7df780dcf-5f390741 {
    align-self: center;
    justify-self: center;
  }

  #w-node-_2175c53b-f823-7fca-ff3e-28377c5b68fb-5f390741, #w-node-c3c85f7f-e632-7142-cfcd-e335b39ffbf7-5f390741, #w-node-a3569e3f-bfe9-2cd6-dfbc-24e0029e527e-5f390741 {
    align-self: center;
  }

  #w-node-c83573bc-415f-42b8-9119-433e4d4e15ae-5f390741 {
    grid-area: span 1 / span 3 / span 1 / span 3;
    align-self: center;
    justify-self: center;
  }

  #w-node-_89e1e007-5c1e-f0e2-ef39-7e170e19e585-5f390741 {
    align-self: center;
    justify-self: center;
  }

  #w-node-_0198e76c-1748-7442-e2ff-99da45f4e95b-5f390741 {
    grid-area: span 1 / span 1 / span 1 / span 1;
    align-self: center;
    justify-self: center;
  }

  #w-node-_8ce43518-5b0e-e0cf-1b9c-9ace8dba98da-5f390741, #w-node-e131a8d4-79ee-1ee2-0071-cebf84cc126e-5f390741 {
    align-self: center;
    justify-self: center;
  }

  #w-node-ddcebfd2-e4d2-7925-7787-c94dffddf9df-5f390741 {
    grid-area: span 1 / span 1 / span 1 / span 1;
    align-self: center;
    justify-self: center;
  }

  #w-node-_83be745f-de31-9132-0171-4fd88ef6b5bb-5f390741, #w-node-ddc0da64-6df5-c6ae-9369-7d1a600f25af-5f390741, #w-node-d14deb6c-7a40-5e48-605c-c474e039c0bb-5f390741 {
    align-self: center;
    justify-self: center;
  }

  #w-node-_7e4ec7bb-ace9-b2b8-3580-f1e558df1b74-5f390741 {
    grid-area: span 1 / span 1 / span 1 / span 1;
    align-self: center;
    justify-self: center;
  }

  #w-node-_686d60c6-0bfe-99e2-fbe5-e4740a9b25f0-5f390741 {
    grid-area: span 1 / span 1 / span 1 / span 1;
    align-self: center;
  }

  #w-node-dadf6f5c-2851-e52e-207e-366ab06cd0b8-5f390741 {
    align-self: center;
    justify-self: center;
  }

  #w-node-_3c841a43-3b39-58f2-5736-e39fe3b30747-5f390741 {
    grid-area: span 1 / span 1 / span 1 / span 1;
  }

  #w-node-_7ae06a7d-7e1f-7fb8-ba55-09f30267adcb-27908c89 {
    grid-area: span 1 / span 1 / span 1 / span 1;
    align-self: start;
  }

  #w-node-f79a5b14-1987-41ee-cc80-bc3d13978437-27908c89 {
    align-self: start;
  }

  #w-node-_1ad4df91-8135-e871-369d-04d327908c9d-27908c89 {
    justify-self: start;
  }

  #w-node-fc09a5da-fb91-dec7-a652-ecd5099342ee-27908c89 {
    grid-area: span 1 / span 1 / span 1 / span 1;
  }

  #w-node-_337a7440-7480-d35b-91f8-2b9eea3e6cb3-8f390764 {
    justify-self: auto;
  }

  #w-node-dc170ca0-77be-ab7b-e8da-eed7df780dcf-8f390764, #w-node-_83be745f-de31-9132-0171-4fd88ef6b5bb-8f390764, #w-node-ddc0da64-6df5-c6ae-9369-7d1a600f25af-8f390764, #w-node-d14deb6c-7a40-5e48-605c-c474e039c0bb-8f390764 {
    align-self: center;
    justify-self: center;
  }

  #w-node-_7e4ec7bb-ace9-b2b8-3580-f1e558df1b74-8f390764 {
    grid-area: span 1 / span 1 / span 1 / span 1;
    align-self: center;
    justify-self: center;
  }

  #w-node-_686d60c6-0bfe-99e2-fbe5-e4740a9b25f0-8f390764 {
    grid-area: span 1 / span 1 / span 1 / span 1;
    align-self: center;
  }

  #w-node-_97054a2f-0f70-93be-be78-adbc6b6eec3b-0b39077c {
    grid-area: span 1 / span 1 / span 1 / span 1;
    align-self: center;
    justify-self: center;
  }

  #w-node-e3c52c33-0c48-12db-c76a-3138e5bf90a7-0b39077c {
    align-self: center;
    justify-self: center;
  }

  #w-node-_34cdf210-7ab9-3e63-4b8a-e3eead01f136-0b39077c, #w-node-_34cdf210-7ab9-3e63-4b8a-e3eead01f13d-0b39077c, #w-node-_34cdf210-7ab9-3e63-4b8a-e3eead01f144-0b39077c, #w-node-_84f496b7-ddaa-0d48-118a-8c179b83eb06-0b39077c, #w-node-_1df6bd2f-dae0-9734-56a3-340bffa3aa52-0b39077c, #w-node-_3b863e80-0755-8fab-a18c-8816f90af9f9-0b39077c, #w-node-_11165cb0-6922-262a-c99d-707ed846b4f2-0b39077c, #w-node-_12caee80-4201-0bfb-5376-a28a933526a0-0b39077c, #w-node-_6f3fedf0-ac2e-94f3-df2a-87e55c540e74-0b39077c, #w-node-fbbde31e-114c-0b3e-6061-1a7fe70fd0a5-0b39077c, #w-node-_8193341c-8e61-80eb-a6ec-1e5028e6f1aa-0b39077c {
    grid-column: span 1 / span 1;
  }

  #w-node-_21d7e11f-fa91-f612-d024-c6932d3370d6-073907d9 {
    align-self: auto;
    justify-self: auto;
  }

  #w-node-_1ab0dd6a-8107-092e-7701-b651f133c058-073907d9 {
    align-self: center;
    justify-self: center;
  }

  #w-node-b82c1f6c-d598-1ada-560b-73818a77a6ee-073907d9 {
    grid-area: span 1 / span 1 / span 1 / span 1;
    align-self: center;
    justify-self: center;
  }

  #w-node-_5cf823c1-11c7-3b3b-e0e4-a2565a9fae0d-073907d9 {
    align-self: center;
    justify-self: center;
  }

  #w-node-dec432cb-4948-1092-9deb-1529f11c7ed0-073907d9 {
    align-self: auto;
    justify-self: auto;
  }

  #w-node-dec432cb-4948-1092-9deb-1529f11c7ed4-073907d9, #w-node-b82d2fb1-a5cc-a193-2650-501b3cd6d578-073907d9 {
    align-self: center;
    justify-self: center;
  }

  #w-node-e028c015-67f8-f303-6616-0f51eaf7d4d2-073907d9 {
    align-self: start;
  }

  #w-node-dd6196f4-92fb-2d75-2c87-904dffd0c112-073907d9, #w-node-b5653859-cf5c-7cc3-841a-db9960fcbeb8-073907d9, #w-node-cbc61ed7-da31-3641-5433-ae7ff50ec71a-073907d9 {
    align-self: center;
    justify-self: center;
  }

  #w-node-_0198e76c-1748-7442-e2ff-99da45f4e95b-073907d9 {
    grid-area: span 1 / span 1 / span 1 / span 1;
    align-self: center;
    justify-self: center;
  }

  #w-node-_8ce43518-5b0e-e0cf-1b9c-9ace8dba98da-073907d9, #w-node-_89e1e007-5c1e-f0e2-ef39-7e170e19e585-073907d9, #w-node-f72b0255-81cd-5781-d4bf-5e0fedb03d41-073907d9 {
    align-self: center;
    justify-self: center;
  }

  #w-node-f72b0255-81cd-5781-d4bf-5e0fedb03d3d-073907d9 {
    grid-area: span 1 / span 1 / span 1 / span 1;
    align-self: center;
    justify-self: center;
  }

  #w-node-f72b0255-81cd-5781-d4bf-5e0fedb03d3f-073907d9 {
    align-self: center;
    justify-self: center;
  }

  #w-node-_5c489dec-ae5f-901b-c9b5-a9250c34ba6e-073907d9 {
    grid-area: span 1 / span 1 / span 1 / span 1;
    align-self: center;
    justify-self: center;
  }

  #w-node-_5c489dec-ae5f-901b-c9b5-a9250c34ba70-073907d9, #w-node-_5c489dec-ae5f-901b-c9b5-a9250c34ba72-073907d9 {
    align-self: center;
    justify-self: center;
  }
}



</style>
  <meta charset="utf-8">
  <title>旅龜教學 Beta 登記</title>
  <meta content="《旅龜中文冒險》是一個包括粵語 + 普通話真人發音和人工智能繁體中文字筆順練習，與香港教育大學的特殊學習需要與融合教育中心共同開發，並且依照教育局《香港小學學習字詞表》編撰而成的智能學習卡 app 產品。產品以廣為學術界推崇的情境教學法和多感官觸覺學習法，來使學生在趣味中牢牢的把平時沈悶的中文課程記住，真正地使「學」和「樂」互相補足。 #香港中文教材 #繁體中文 #粵語 #廣東話 #筆順 #筆順練習 #筆順學習 #普通話 #龜 #學繁體中文app" name="description">
  <meta content="旅龜教學 Beta 登記" property="og:title">
  <meta content="《旅龜中文冒險》是一個包括粵語 + 普通話真人發音和人工智能繁體中文字筆順練習，與香港教育大學的特殊學習需要與融合教育中心共同開發，並且依照教育局《香港小學學習字詞表》編撰而成的智能學習卡 app 產品。產品以廣為學術界推崇的情境教學法和多感官觸覺學習法，來使學生在趣味中牢牢的把平時沈悶的中文課程記住，真正地使「學」和「樂」互相補足。 #香港中文教材 #繁體中文 #粵語 #廣東話 #筆順 #筆順練習 #筆順學習 #普通話 #龜 #學繁體中文app" property="og:description">
  <meta content="https://uploads-ssl.webflow.com/5f7a9b0a3bad61e790b3c33e/5f92788ccc3058d518dd10a4_Social%20Media%20Thumbnail.png" property="og:image">
  <meta content="旅龜教學 Beta 登記" property="twitter:title">
  <meta content="《旅龜中文冒險》是一個包括粵語 + 普通話真人發音和人工智能繁體中文字筆順練習，與香港教育大學的特殊學習需要與融合教育中心共同開發，並且依照教育局《香港小學學習字詞表》編撰而成的智能學習卡 app 產品。產品以廣為學術界推崇的情境教學法和多感官觸覺學習法，來使學生在趣味中牢牢的把平時沈悶的中文課程記住，真正地使「學」和「樂」互相補足。 #香港中文教材 #繁體中文 #粵語 #廣東話 #筆順 #筆順練習 #筆順學習 #普通話 #龜 #學繁體中文app" property="twitter:description">
  <meta content="https://uploads-ssl.webflow.com/5f7a9b0a3bad61e790b3c33e/5f92788ccc3058d518dd10a4_Social%20Media%20Thumbnail.png" property="twitter:image">
  <meta property="og:type" content="website">
  <meta content="summary_large_image" name="twitter:card">
  <meta content="width=device-width, initial-scale=1" name="viewport">
  <link href="css/normalize.css" rel="stylesheet" type="text/css">
  <link href="css/webflow.css" rel="stylesheet" type="text/css">
  <link href="css/turtlelearn.webflow.css" rel="stylesheet" type="text/css">
  <link href="https://fonts.googleapis.com" rel="preconnect">
  <link href="https://fonts.gstatic.com" rel="preconnect" crossorigin="anonymous">
  <script src="https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js" type="text/javascript"></script>
  <script type="text/javascript">WebFont.load({  google: {    families: ["Noto Sans HK:regular,500,700,900:chinese-hongkong,latin","Inter:regular,700,900"]  }});</script>
  <script src="https://use.typekit.net/gib2mcj.js" type="text/javascript"></script>
  <script type="text/javascript">try{Typekit.load();}catch(e){}</script>
  <script type="text/javascript">!function(o,c){var n=c.documentElement,t=" w-mod-";n.className+=t+"js",("ontouchstart"in o||o.DocumentTouch&&c instanceof DocumentTouch)&&(n.className+=t+"touch")}(window,document);</script>
  <link href="images/webflow/favicon.png" rel="shortcut icon" type="image/x-icon">
  <link href="images/webflow/webclip.png" rel="apple-touch-icon">
  <script async="" src="https://www.googletagmanager.com/gtag/js?id=UA-80885174-4"></script>
  <script type="text/javascript">window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', 'UA-80885174-4', {'anonymize_ip': false});</script>
  <script async="" src="https://www.googletagmanager.com/gtag/js?id=G-8LVN5NRH8E"></script>
  <script type="text/javascript">window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('set', 'developer_id.dZGVlNj', true);gtag('config', 'G-8LVN5NRH8E');</script>
  <script src="https://www.google.com/recaptcha/api.js" type="text/javascript"></script>
  <script type="text/javascript">!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.agent='plwebflow';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '350372176242687');fbq('track', 'PageView');</script><!--  Google Tag Manager  -->
  <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-P3NBBXX');</script>
  <!--  End Google Tag Manager  -->
  <!--  Global site tag (gtag.js) - Google Analytics  -->
  <script async="" src="https://www.googletagmanager.com/gtag/js?id=UA-80885174-4"></script>
  <script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'UA-80885174-4');
  ga('require', 'ec')
</script>
  <meta property="fb:pages" content="107502374348516">
  <link rel="alternate" hreflang="tw" href="https://turtlelearn.com">
  <link rel="alternate" hreflang="en" href="https://en.turtlelearn.com">
  <script type="text/javascript" src="https://cdn.weglot.com/weglot.min.js"></script>
  <script>
    Weglot.initialize({
        api_key: 'wg_e2f3a3a89685317de2d9d30c173526ff5'
    });
</script>
  <!--  For social media platform sharing  -->
  <script type="text/javascript" src="https://platform-api.sharethis.com/js/sharethis.js#property=63842892eca04d001ac3af7e&product=inline-share-buttons&source=platform" async="async"></script>
  <!--  Memberstack webflow package  -->
  <!-- script data-memberstack-app="app_cle2k91ky00o70ul7f7z87cx0" src="https://static.memberstack.com/scripts/v1/memberstack.js" type="text/javascript"></script -->
  <script>
//console.log("Kendall")
function addCountries(whereto) {
	//console.log("addCountries")
  var countriesfile = "Afghanistan, Albania, Algeria, Andorra, Angola, Antigua and Barbuda, Argentina, Armenia, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bhutan, Bolivia, Bosnia and Herzegovina, Botswana, Brazil, Brunei, Bulgaria, Burkina Faso, Burundi, Côte d'Ivoire, Cabo Verde, Cambodia, Cameroon, Canada, Central African Republic, Chad, Chile, China, Colombia, Comoros, Congo, Costa Rica, Croatia, Cuba, Cyprus, Czech Republic, Democratic Republic of the Congo, Denmark, Djibouti, Dominica, Dominican Republic, Ecuador, Egypt, El Salvador, Equatorial Guinea, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Greece, Grenada, Guatemala, Guinea, Guinea-Bissau, Guyana, Haiti, Holy See, Honduras, Hong Kong SAR, Hungary, Iceland, India, Indonesia, Iran, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Laos, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Marshall Islands, Mauritania, Mauritius, Mexico, Micronesia, Moldova, Monaco, Mongolia, Montenegro, Morocco, Mozambique, Myanmar (formerly Burma), Namibia, Nauru, Nepal, Netherlands, New Zealand, Nicaragua, Niger, Nigeria, North Korea, North Macedonia, Norway, Oman, Pakistan, Palau, Palestine State, Panama, Papua New Guinea, Paraguay, Peru, Philippines, Poland, Portugal, Qatar, Romania, Russia, Rwanda, Saint Kitts and Nevis, Saint Lucia, Saint Vincent and the Grenadines, Samoa, San Marino, Sao Tome and Principe, Saudi Arabia, Senegal, Serbia, Seychelles, Sierra Leone, Singapore, Slovakia, Slovenia, Solomon Islands, Somalia, South Africa, South Korea, South Sudan, Spain, Sri Lanka, Sudan, Suriname, Sweden, Switzerland, Syria, Taiwan, Tajikistan, Tanzania, Thailand, Timor-Leste, Togo, Tonga, Trinidad and Tobago, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, United Arab Emirates, United Kingdom, United States of America, Uruguay, Uzbekistan, Vanuatu, Venezuela, Vietnam, Yemen, Zambia, Zimbabwe";
  var countries = countriesfile.split(", ");
  //console.log(countries)
  for(var c = 0; c<countries.length; c++) {
  //console.log(c)
    $(whereto).append('<option value="' + countries[c] + '">' + countries[c] + '</option>');
  }
}
//Webflow.push(function() {
//console.log("Pushed")
  //addCountries('#country');
//});
</script>
</head>
<body class="body-2">
  <div class="page-content">
      
    
    <div class="footer">
      <div class="footer-div-block-1">
        <div class="flex-row make-vertical w-row">
          <div class="column-13 w-col w-col-6"></div>
          <div class="column-2 w-col w-col-6"></div>
        </div>
        <div id="w-node-_1ad4df91-8135-e871-369d-04d327908c8a-27908c89" class="div-block-17">
          <div class="w-layout-grid grid-13">
            <div id="w-node-_1ad4df91-8135-e871-369d-04d327908c8d-27908c89" class="div-block-4">
              <a href="https://www.turtlelearn.com/sshop" class="nav-link in-footer">購買</a>
              <a href="https://www.turtlelearn.com/about-us.html" class="nav-link in-footer">關於我們</a>
              <a href="https://www.turtlelearn.com/apps/help-center" class="nav-link in-footer">常見問題</a>
              <a href="https://www.turtlelearn.com/career.html" class="nav-link in-footer">加入我們</a>
            </div>
            <div id="w-node-_7ae06a7d-7e1f-7fb8-ba55-09f30267adcb-27908c89" class="div-block-21">
              <div class="footer-left-part right-now">
                <a href="https://www.turtlelearn.com/contact" id="w-node-f79a5b14-1987-41ee-cc80-bc3d13978437-27908c89" class="nav-link in-footer">聯絡我們</a>
                <a href="https://www.turtlelearn.com/distributor" class="nav-link in-footer">成為分銷商</a>
                <div id="w-node-_1ad4df91-8135-e871-369d-04d327908c9d-27908c89" class="top-icon-flex no-space">
                  <a href="http://facebook.com/turtlelearncom" target="_blank" class="social-icon w-inline-block"><img src="images/webflow/social-media-logo.svg" loading="lazy" alt="" class="social-icon"></a>
                  <a href="https://www.instagram.com/turtle.learn/" target="_blank" class="social-icon w-inline-block"><img src="images/webflow/social-media-logo-1.svg" loading="lazy" alt="" class="social-icon"></a>
                  <a href="https://discord.gg/n5vUSW5Znp" target="_blank" class="social-icon w-inline-block"><img src="images/webflow/vecteezy_discord-logo-icon-editorial-vector_6892625.jpg" loading="lazy" alt="" sizes="50px" srcset="images/webflow/vecteezy_discord-logo-icon-editorial-vector_6892625-p-500.jpg 500w, images/webflow/vecteezy_discord-logo-icon-editorial-vector_6892625-p-800.jpg 800w, images/webflow/vecteezy_discord-logo-icon-editorial-vector_6892625-p-1080.jpg 1080w, images/webflow/vecteezy_discord-logo-icon-editorial-vector_6892625-p-1600.jpg 1600w, images/webflow/vecteezy_discord-logo-icon-editorial-vector_6892625.jpg 1920w" class="social-icon rounded"></a>
                  <a href="http://youtube.com/@turtle-learn" target="_blank" class="social-icon w-inline-block"><img src="images/webflow/1491579609-yumminkysocialmedia08_83079.png" loading="lazy" sizes="100vw" srcset="images/webflow/1491579609-yumminkysocialmedia08_83079-p-500.png 500w, images/webflow/1491579609-yumminkysocialmedia08_83079.png 512w" alt="" class="social-icon hidden"></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-div-block-2">
        <div class="w-layout-grid grid-10">
          <a id="w-node-fc09a5da-fb91-dec7-a652-ecd5099342ee-27908c89" href="https://turtleteach.com/privacy-policy" class="link-block-8 w-inline-block">
            <div class="footer-text-block">隱私政策</div>
          </a><img src="images/webflow/Frame.svg" loading="lazy" alt="" class="image-33">
          <div class="text-block-15">© Copyright 2023 Kazoo Technology (Hong Kong) Limited. <br>保留一切權利</div>
        </div>
      </div>
    </div>
  </div>
  <script src="https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=63311ecceafed5876e7d5d49" type="text/javascript" integrity="sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0=" crossorigin="anonymous"></script>
  <script src="js/webflow.js" type="text/javascript"></script><!--  FLOATING SHOPPING CART  -->
  <div id="product-component-1624417744551"></div>
  <script async="" type="text/javascript">
    /*<![CDATA[*/
    (function () {
        var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
        if (window.ShopifyBuy) {
            if (window.ShopifyBuy.UI) {
                ShopifyBuyInit();
            } else {
                loadScript();
            }
        } else {
            loadScript();
        }
        function loadScript() {
            var script = document.createElement('script');
            script.async = true;
            script.src = scriptURL;
            (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
            script.onload = ShopifyBuyInit;
        }
        function ShopifyBuyInit() {
            var client = ShopifyBuy.buildClient({
                domain: 'turtle-learn.myshopify.com',
                storefrontAccessToken: '387eda8ea8088c2530d7c74f70b6979c',
            });
            ShopifyBuy.UI.onReady(client).then(function (ui) {
                ui.createComponent('product', {
                    options: {
                        "option": {},
                        "cart": {
                            "styles": {
                                "button": {
                                    "font-size": "18px",
                                    "padding-top": "17px",
                                    "padding-bottom": "17px",
                                    ":hover": {
                                        "background-color": "#e69700"
                                    },
                                    "background-color": "#ffa800",
                                    ":focus": {
                                        "background-color": "#e69700"
                                    },
                                    "border-radius": "10px"
                                }
                            },
                            "text": {
                                "total": "Subtotal",
                                "button": "Checkout"
                            }
                        },
                        "toggle": {
                            "styles": {
                                "toggle": {
                                    "background-color": "#ffa800",
                                    ":hover": {
                                        "background-color": "#e69700"
                                    },
                                    ":focus": {
                                        "background-color": "#e69700"
                                    }
                                },
                                "count": {
                                    "font-size": "18px"
                                }
                            }
                        }
                    },
                });
            });
        }
    })();
    /*]]>*/
</script>
  <!--  CURRENCY FORMAT  -->
  <script async="">
  $(document).ready(function () {
            $(".price").each(function () { 
                //this is the target text string converted to a number
                var numprice = Number($(this).text());
                // create a function to set the International number format  
                var nprice = Intl.NumberFormat('en-US', {
                        style : 'currency',
                        currency: 'HKD',
                        //currencyDisplay: 'symbol'
                        minimumFractionDigits: 0
                        //maximumFractionDigits: 0
                    }
                );
            // replace the current value for  the new formatted value      
            $(this).text(nprice.format(numprice));
            })
        });
</script>
  <!--  Language indicator. This section must be placed below the Language Switcher HTML code   -->
  <script>
	const {
  	host, hostname, href, origin, pathname, port, protocol, search
	} = window.location
  let x = document.getElementsByclassName("language-indicator")
	if(host == "en.turtlelearn.com") {
  	console.log("English site detected")
    //console.log(x[0].innerText)
    console.log(x)
    console.log(x[0])
    //console.log(x['div.language-indicator])
    //console.log(x[0].innderText)
    //x[0].innerText = "English"
    for(var i = 0; i < x.length; i++){
//    	console.log(x[i]);
    	x[i].innerText="English";    // Change the content
    }
  }
</script>
  <!--  Firebase SDK  -->
  <script type="module">
  // Import the functions you need from the SDKs you need
  import { initializeApp } from "https://www.gstatic.com/firebasejs/9.19.1/firebase-app.js";
  import { getAnalytics } from "https://www.gstatic.com/firebasejs/9.19.1/firebase-analytics.js";
  // TODO: Add SDKs for Firebase products that you want to use
  // https://firebase.google.com/docs/web/setup#available-libraries
  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  const firebaseConfig = {
    apiKey: "AIzaSyC42ifqJxYu3lmcfVWK2bYOQy2Hc7WgtTM",
    authDomain: "turtle-learn.firebaseapp.com",
    projectId: "turtle-learn",
    storageBucket: "turtle-learn.appspot.com",
    messagingSenderId: "141749442390",
    appId: "1:141749442390:web:f82d08cbf38e44977f28f7",
    measurementId: "G-PBYQ167ETZ"
  };
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
</script>
  <!--  Start seamless-pagination custom code  -->
  <!--  https://www.youtube.com/watch?v=u6OsUq023MM&t=278s  -->
  <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery.pjax/2.0.1/jquery.pjax.min.js"></script>
  <script>
  var containerSelector = '#seamless-replace';
  $(document).pjax(
    '.w-pagination-wrapper a',
    containerSelector,
    {
      container: containerSelector, 
      fragment: containerSelector,
      scrollTo: false,
      timeout: 2500,
    }
  );
  // These 3 lines should reinitialize interactions
  $(document).on('pjax:end', function() {
    Webflow.require('ix2').init();
    // CURRENCY FORMAT
     $(".price").each(function () { 
                //this is the target text string converted to a number
                var numprice = Number($(this).text());
                // create a function to set the International number format  
                var nprice = Intl.NumberFormat('en-US', {
                        style : 'currency',
                        currency: 'HKD',
                        //currencyDisplay: 'symbol'
                        minimumFractionDigits: 0
                        //maximumFractionDigits: 0
                    }
                );
            // replace the current value for  the new formatted value      
            $(this).text(nprice.format(numprice));
            })
  });
</script>
  <!--  End seamless-pagination custom code  -->
  <script>
addCountries('#country');
</script>
</body>
</html>`;
